var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetTrackingNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 109.639,
    viewBox: "0 0 150 109.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #4e5863;\n      }\n\n      .cls-4 {\n        fill: #9290c1;\n      }\n\n      .cls-5 {\n        fill: #5b3439;\n      }\n\n      .cls-6 {\n        fill: #bdbdbd;\n      }\n\n      .cls-7 {\n        fill: #4a0b23;\n      }\n\n      .cls-8 {\n        fill: #8b5e6d;\n      }\n\n      .cls-9 {\n        fill: #7c4b56;\n      }\n\n      .cls-10 {\n        fill: #a7878d;\n      }\n\n      .cls-11 {\n        fill: #e2cfc5;\n      }\n\n      .cls-12 {\n        fill: #9b7a83;\n      }\n\n      .cls-13 {\n        fill: #390614;\n      }\n\n      .cls-14 {\n        fill: #765662;\n      }\n\n      .cls-15 {\n        fill: #966879;\n      }\n\n      .cls-16 {\n        fill: #94d9fa;\n      }\n\n      .cls-17 {\n        fill: #919191;\n      }\n\n      .cls-18 {\n        fill: #a97f7f;\n      }\n\n      .cls-19 {\n        fill: #ecdcce;\n      }\n\n      .cls-20 {\n        fill: #828282;\n      }\n\n      .cls-21 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-22 {\n        fill: #d0dcd7;\n      }\n\n      .cls-23 {\n        fill: #fdfdfd;\n      }\n\n      .cls-24 {\n        fill: #5a4f80;\n      }\n\n      .cls-25 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-26 {\n        fill: #c3cf70;\n      }\n\n      .cls-27 {\n        fill: #fff5e6;\n      }\n\n      .cls-28 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-29 {\n        fill: #74739d;\n      }\n\n      .cls-30 {\n        fill: #979797;\n      }\n\n      .cls-31 {\n        fill: #9ab161;\n      }\n\n      .cls-32 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-33 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-34 {\n        fill: #f2635a;\n      }\n\n      .cls-35 {\n        fill: #7686ef;\n      }\n\n      .cls-36 {\n        fill: #edf0b4;\n      }\n\n      .cls-37 {\n        fill: #cfd582;\n      }\n\n      .cls-38 {\n        fill: #ebdfca;\n      }\n\n      .cls-39 {\n        fill: #804a5c;\n      }\n\n      .cls-40 {\n        fill: #799ec9;\n      }\n\n      .cls-41 {\n        fill: #c60d05;\n      }\n\n      .cls-42 {\n        fill: #4b4b91;\n      }\n\n      .cls-43 {\n        fill: #a32c31;\n      }\n\n      .cls-44 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-45 {\n        opacity: 0.38;\n      }\n\n      .cls-46 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-47 {\n        fill: #500a1e;\n      }\n\n      .cls-48 {\n        opacity: 0.25;\n      }\n\n      .cls-49 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-50 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-51 {\n        fill: #411928;\n      }\n\n      .cls-52 {\n        fill: #4e2132;\n      }\n\n      .cls-53 {\n        fill: #814e5b;\n      }\n\n      .cls-54 {\n        fill: #7a4955;\n      }\n\n      .cls-55 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-57 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-59 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-61 {\n        fill: #6e3f4b;\n      }\n\n      .cls-62 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-64 {\n        opacity: 0.8;\n      }\n\n      .cls-65 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-66 {\n        fill: #976e6f;\n      }\n\n      .cls-67 {\n        opacity: 0.9;\n      }\n\n      .cls-68 {\n        clip-path: url(#clip-path-27);\n      }\n\n      .cls-69 {\n        fill: #e6d5c6;\n      }\n\n      .cls-70 {\n        opacity: 0.4;\n      }\n\n      .cls-71 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-73 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-76 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-78 {\n        fill: #552837;\n      }\n\n      .cls-79 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-81 {\n        clip-path: url(#clip-path-37);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-83 {\n        clip-path: url(#clip-path-38);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-85 {\n        clip-path: url(#clip-path-40);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-87 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-89 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-91 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-93 {\n        clip-path: url(#clip-path-47);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-95 {\n        clip-path: url(#clip-path-49);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-97 {\n        clip-path: url(#clip-path-52);\n      }\n\n      .cls-98 {\n        clip-path: url(#clip-path-56);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-100 {\n        clip-path: url(#clip-path-58);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-102 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-104 {\n        clip-path: url(#clip-path-62);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-106 {\n        clip-path: url(#clip-path-63);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-108 {\n        clip-path: url(#clip-path-65);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-110 {\n        clip-path: url(#clip-path-67);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-112 {\n        clip-path: url(#clip-path-69);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-114 {\n        clip-path: url(#clip-path-71);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-116 {\n        opacity: 0.7;\n      }\n\n      .cls-117 {\n        clip-path: url(#clip-path-73);\n      }\n\n      .cls-118 {\n        clip-path: url(#clip-path-74);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-120 {\n        clip-path: url(#clip-path-76);\n      }\n\n      .cls-121 {\n        fill: #8b5865;\n      }\n\n      .cls-122 {\n        fill: #decbbe;\n      }\n\n      .cls-123 {\n        fill: #f2efe2;\n      }\n\n      .cls-124 {\n        clip-path: url(#clip-path-77);\n      }\n\n      .cls-125 {\n        fill: #ffe166;\n      }\n\n      .cls-126 {\n        fill: #fad241;\n      }\n\n      .cls-127 {\n        fill: #ffe66f;\n      }\n\n      .cls-128 {\n        opacity: 0.47;\n      }\n\n      .cls-129 {\n        clip-path: url(#clip-path-78);\n      }\n\n      .cls-130 {\n        fill: #820500;\n      }\n\n      .cls-131 {\n        fill: #fddd61;\n      }\n\n      .cls-132 {\n        opacity: 0.45;\n      }\n\n      .cls-133 {\n        clip-path: url(#clip-path-79);\n      }\n\n      .cls-134 {\n        opacity: 0.42;\n      }\n\n      .cls-135 {\n        clip-path: url(#clip-path-80);\n      }\n\n      .cls-136 {\n        fill: #820000;\n      }\n\n      .cls-137 {\n        fill: #fadc5f;\n      }\n\n      .cls-138 {\n        fill: #c57c2d;\n      }\n\n      .cls-139 {\n        fill: #69505f;\n      }\n\n      .cls-140 {\n        fill: #5f4655;\n      }\n\n      .cls-141 {\n        fill: #6e5564;\n      }\n\n      .cls-142 {\n        clip-path: url(#clip-path-81);\n      }\n\n      .cls-143 {\n        fill: #3c0a28;\n      }\n\n      .cls-144 {\n        opacity: 0.5;\n      }\n\n      .cls-145 {\n        clip-path: url(#clip-path-82);\n      }\n\n      .cls-146 {\n        fill: #644b5a;\n      }\n\n      .cls-147 {\n        fill: #b76d2c;\n      }\n\n      .cls-148 {\n        fill: #3c1623;\n      }\n\n      .cls-149 {\n        clip-path: url(#clip-path-83);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-151 {\n        clip-path: url(#clip-path-85);\n      }\n\n      .cls-152 {\n        fill: #320b16;\n      }\n\n      .cls-153 {\n        clip-path: url(#clip-path-86);\n      }\n\n      .cls-154 {\n        clip-path: url(#clip-path-87);\n      }\n\n      .cls-155 {\n        clip-path: url(#clip-path-89);\n      }\n\n      .cls-156 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-157 {\n        clip-path: url(#clip-path-91);\n      }\n\n      .cls-158 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-159 {\n        clip-path: url(#clip-path-93);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-161 {\n        clip-path: url(#clip-path-94);\n      }\n\n      .cls-162 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-163 {\n        fill: #73434f;\n      }\n\n      .cls-164 {\n        clip-path: url(#clip-path-96);\n      }\n\n      .cls-165 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-166 {\n        opacity: 0.95;\n      }\n\n      .cls-167 {\n        clip-path: url(#clip-path-98);\n      }\n\n      .cls-168 {\n        clip-path: url(#clip-path-99);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-170 {\n        clip-path: url(#clip-path-101);\n      }\n\n      .cls-171 {\n        clip-path: url(#clip-path-102);\n      }\n\n      .cls-172 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-173 {\n        fill: #633442;\n      }\n\n      .cls-174 {\n        clip-path: url(#clip-path-104);\n      }\n\n      .cls-175 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-176 {\n        clip-path: url(#clip-path-106);\n      }\n\n      .cls-177 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-178 {\n        clip-path: url(#clip-path-108);\n      }\n\n      .cls-179 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-180 {\n        clip-path: url(#clip-path-110);\n      }\n\n      .cls-181 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-182 {\n        clip-path: url(#clip-path-112);\n      }\n\n      .cls-183 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-184 {\n        clip-path: url(#clip-path-114);\n      }\n\n      .cls-185 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-186 {\n        clip-path: url(#clip-path-116);\n      }\n\n      .cls-187 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-188 {\n        clip-path: url(#clip-path-118);\n      }\n\n      .cls-189 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-190 {\n        clip-path: url(#clip-path-119);\n      }\n\n      .cls-191 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-192 {\n        fill: #8a6c73;\n      }\n\n      .cls-193 {\n        clip-path: url(#clip-path-121);\n      }\n\n      .cls-194 {\n        fill: #32000a;\n      }\n\n      .cls-195 {\n        fill: #a08387;\n      }\n\n      .cls-196 {\n        clip-path: url(#clip-path-122);\n      }\n\n      .cls-197 {\n        clip-path: url(#clip-path-126);\n      }\n\n      .cls-198 {\n        fill: #552838;\n      }\n\n      .cls-199 {\n        fill: #5c2f40;\n      }\n\n      .cls-200 {\n        clip-path: url(#clip-path-127);\n      }\n\n      .cls-201 {\n        fill: #8d5c68;\n      }\n\n      .cls-202 {\n        opacity: 0.2;\n      }\n\n      .cls-203 {\n        clip-path: url(#clip-path-128);\n      }\n\n      .cls-204 {\n        clip-path: url(#clip-path-129);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-206 {\n        clip-path: url(#clip-path-131);\n      }\n\n      .cls-207 {\n        clip-path: url(#clip-path-132);\n      }\n\n      .cls-208 {\n        clip-path: url(#clip-path-133);\n      }\n\n      .cls-209 {\n        clip-path: url(#clip-path-134);\n      }\n\n      .cls-210 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-211 {\n        clip-path: url(#clip-path-136);\n      }\n\n      .cls-212 {\n        fill: #861616;\n      }\n\n      .cls-213 {\n        opacity: 0.35;\n      }\n\n      .cls-214 {\n        clip-path: url(#clip-path-137);\n      }\n\n      .cls-215 {\n        fill: #ca8530;\n      }\n\n      .cls-216 {\n        fill: #502131;\n      }\n\n      .cls-217 {\n        fill: #fdd952;\n      }\n\n      .cls-218 {\n        clip-path: url(#clip-path-139);\n      }\n\n      .cls-219 {\n        clip-path: url(#clip-path-140);\n      }\n\n      .cls-220 {\n        fill: #e5b33d;\n      }\n\n      .cls-221 {\n        clip-path: url(#clip-path-141);\n      }\n\n      .cls-222 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-223 {\n        clip-path: url(#clip-path-142);\n      }\n\n      .cls-224 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-225 {\n        clip-path: url(#clip-path-144);\n      }\n\n      .cls-226 {\n        clip-path: url(#clip-path-145);\n      }\n\n      .cls-227 {\n        fill: #e9bb32;\n      }\n\n      .cls-228 {\n        clip-path: url(#clip-path-146);\n      }\n\n      .cls-229 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-230 {\n        opacity: 0.39;\n      }\n\n      .cls-231 {\n        clip-path: url(#clip-path-148);\n      }\n\n      .cls-232 {\n        clip-path: url(#clip-path-149);\n      }\n\n      .cls-233 {\n        clip-path: url(#clip-path-150);\n      }\n\n      .cls-234 {\n        opacity: 0.44;\n      }\n\n      .cls-235 {\n        clip-path: url(#clip-path-152);\n      }\n\n      .cls-236 {\n        clip-path: url(#clip-path-153);\n      }\n\n      .cls-237 {\n        opacity: 0.46;\n      }\n\n      .cls-238 {\n        clip-path: url(#clip-path-154);\n      }\n\n      .cls-239 {\n        clip-path: url(#clip-path-170);\n      }\n\n      .cls-240 {\n        clip-path: url(#clip-path-171);\n      }\n\n      .cls-241 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-242 {\n        fill: #603240;\n      }\n\n      .cls-243 {\n        fill: #461e2d;\n      }\n\n      .cls-244 {\n        fill: #572939;\n      }\n\n      .cls-245 {\n        clip-path: url(#clip-path-173);\n      }\n\n      .cls-246 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-247 {\n        clip-path: url(#clip-path-175);\n      }\n\n      .cls-248 {\n        fill: #58283b;\n      }\n\n      .cls-249 {\n        clip-path: url(#clip-path-176);\n      }\n\n      .cls-250 {\n        clip-path: url(#clip-path-177);\n      }\n\n      .cls-251 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-252 {\n        clip-path: url(#clip-path-179);\n      }\n\n      .cls-253 {\n        clip-path: url(#clip-path-180);\n      }\n\n      .cls-254 {\n        fill: #552737;\n      }\n\n      .cls-255 {\n        clip-path: url(#clip-path-181);\n      }\n\n      .cls-256 {\n        fill: #623342;\n      }\n\n      .cls-257 {\n        clip-path: url(#clip-path-183);\n      }\n\n      .cls-258 {\n        clip-path: url(#clip-path-184);\n      }\n\n      .cls-259 {\n        clip-path: url(#clip-path-186);\n      }\n\n      .cls-260 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-261 {\n        clip-path: url(#clip-path-187);\n      }\n\n      .cls-262 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-263 {\n        clip-path: url(#clip-path-189);\n      }\n\n      .cls-264 {\n        clip-path: url(#clip-path-190);\n      }\n\n      .cls-265 {\n        clip-path: url(#clip-path-191);\n      }\n\n      .cls-266 {\n        clip-path: url(#clip-path-192);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-268 {\n        clip-path: url(#clip-path-193);\n      }\n\n      .cls-269 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-270 {\n        fill: #cd8830;\n      }\n\n      .cls-271 {\n        clip-path: url(#clip-path-195);\n      }\n\n      .cls-272 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-273 {\n        fill: #89696c;\n      }\n\n      .cls-274 {\n        fill: #d59838;\n      }\n\n      .cls-275 {\n        fill: #937376;\n      }\n\n      .cls-276 {\n        clip-path: url(#clip-path-197);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-278 {\n        clip-path: url(#clip-path-198);\n      }\n\n      .cls-279 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-280 {\n        fill: #c0772a;\n      }\n\n      .cls-281 {\n        clip-path: url(#clip-path-200);\n      }\n\n      .cls-282 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-283 {\n        opacity: 0.33;\n      }\n\n      .cls-284 {\n        clip-path: url(#clip-path-202);\n      }\n\n      .cls-285 {\n        clip-path: url(#clip-path-203);\n      }\n\n      .cls-286 {\n        clip-path: url(#clip-path-204);\n      }\n\n      .cls-287 {\n        clip-path: url(#clip-path-205);\n      }\n\n      .cls-288 {\n        clip-path: url(#clip-path-206);\n      }\n\n      .cls-289 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-290 {\n        fill: #d0b6b3;\n      }\n\n      .cls-291 {\n        clip-path: url(#clip-path-208);\n      }\n\n      .cls-292 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-293 {\n        fill: #d7c9c2;\n      }\n\n      .cls-294 {\n        opacity: 0.85;\n      }\n\n      .cls-295 {\n        clip-path: url(#clip-path-210);\n      }\n\n      .cls-296 {\n        clip-path: url(#clip-path-211);\n      }\n\n      .cls-297 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-298 {\n        clip-path: url(#clip-path-212);\n      }\n\n      .cls-299 {\n        clip-path: url(#clip-path-213);\n      }\n\n      .cls-300 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-301 {\n        clip-path: url(#clip-path-214);\n      }\n\n      .cls-302 {\n        fill: #ffa831;\n      }\n\n      .cls-303 {\n        clip-path: url(#clip-path-215);\n      }\n\n      .cls-304 {\n        clip-path: url(#clip-path-217);\n      }\n\n      .cls-305 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-306 {\n        clip-path: url(#clip-path-219);\n      }\n\n      .cls-307 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-308 {\n        clip-path: url(#clip-path-222);\n      }\n\n      .cls-309 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-310 {\n        clip-path: url(#clip-path-224);\n      }\n\n      .cls-311 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-312 {\n        fill: #f5cd3c;\n      }\n\n      .cls-313 {\n        clip-path: url(#clip-path-226);\n      }\n\n      .cls-314 {\n        clip-path: url(#clip-path-227);\n      }\n\n      .cls-315 {\n        fill: #691616;\n      }\n\n      .cls-316 {\n        fill: #ffe369;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25266",
    "data-name": "Rectangle 25266",
    className: "cls-1",
    width: 145.255,
    height: 102.702
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71157",
    "data-name": "Path 71157",
    className: "cls-1",
    d: "M263.813,2.04l55.315,32.145a.67.67,0,0,1,.678-.047L264.492,1.992a.542.542,0,0,0-.275-.071.813.813,0,0,0-.4.119",
    transform: "translate(-263.813 -1.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71165",
    "data-name": "Path 71165",
    className: "cls-1",
    d: "M237.512,2.946c-1.985,3.418-4.036,6.867-6.269,10.113-1.043,1.521-1.934,3.152-2.981,4.671A30.273,30.273,0,0,1,226,21.149q-.141.154-.292.3c-.753.72-.787,1.749-.389,2.035l.033.022,55.315,32.146-.033-.022c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.306,30.306,0,0,0,2.265-3.419c1.046-1.519,1.938-3.149,2.981-4.67,2.233-3.246,4.285-6.695,6.269-10.113a1.8,1.8,0,0,1,.621-.673L238.133,2.274a1.8,1.8,0,0,0-.62.672",
    transform: "translate(-225.065 -2.274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71172",
    "data-name": "Path 71172",
    className: "cls-1",
    d: "M199.513,57.716l55.315,32.146c2.318-1.339,4.344-1.029,6.334-.72a13.612,13.612,0,0,0,3.214.243L209.063,57.239A13.613,13.613,0,0,1,205.848,57a17,17,0,0,0-2.628-.268,7.147,7.147,0,0,0-3.707.988",
    transform: "translate(-199.513 -56.728)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71185",
    "data-name": "Path 71185",
    className: "cls-1",
    d: "M177.474,61.012c-1.561,1.893-3.121,3.755-4.548,5.821-.763,1.105-1.476,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.247,4.247,0,0,1-.631.618c-.817.641-.821,1.689-.354,1.961l55.315,32.146c-.467-.271-.464-1.32.354-1.961a4.226,4.226,0,0,0,.63-.618c.574-.685.959-1.5,1.556-2.248.831-1.037,1.544-2.155,2.307-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.727,1.727,0,0,1,.454-.405L177.928,60.608a1.718,1.718,0,0,0-.454.4",
    transform: "translate(-167.765 -60.608)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71203",
    "data-name": "Path 71203",
    className: "cls-1",
    d: "M25.644,123.484c-.922.532-1.129,1.923-.628,2.215l55.315,32.146c-.5-.292-.295-1.684.628-2.216l48.636-28.08L74.281,95.4l-48.636,28.08",
    transform: "translate(-24.751 -95.404)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23474",
    "data-name": "Rectangle 23474",
    className: "cls-1",
    width: 42.364,
    height: 30.891
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23251",
    "data-name": "Rectangle 23251",
    className: "cls-1",
    width: 17.657,
    height: 15.306
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23252",
    "data-name": "Rectangle 23252",
    className: "cls-1",
    width: 9.107,
    height: 5.201
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23253",
    "data-name": "Rectangle 23253",
    className: "cls-1",
    width: 22.544,
    height: 10.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62279",
    "data-name": "Path 62279",
    className: "cls-1",
    d: "M60.114,311.359l2.031-1.173a2.944,2.944,0,0,1,.041-.5,1.972,1.972,0,0,0-.679-.131c-.826,0-1.393.656-1.393,1.8",
    transform: "translate(-60.114 -309.556)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.822,
    y1: 7.034,
    x2: -0.806,
    y2: 7.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62280",
    "data-name": "Path 62280",
    className: "cls-1",
    d: "M73.826,296.122l-2.031,1.173c-.8.464-.8,1.969,0,3.361s2.107,2.144,2.91,1.68l2.031-1.173c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.375-1.817,1.056,1.056,0,0,0-.535.137",
    transform: "translate(-71.192 -295.985)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.168,
    y1: 2.139,
    x2: -0.164,
    y2: 2.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62281",
    "data-name": "Path 62281",
    className: "cls-1",
    d: "M94.023,296.122l-1.747,1.009c.64-.37,2.141.351,2.955,1.655.859,1.376.869,2.859-.077,3.405l1.781-1.028c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.375-1.817,1.056,1.056,0,0,0-.535.137",
    transform: "translate(-92.276 -295.985)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.344,
    y1: 2.392,
    x2: -0.339,
    y2: 2.392,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#582a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62284",
    "data-name": "Path 62284",
    className: "cls-1",
    d: "M93.625,352.49c-.441.254-.441,1.079,0,1.843s1.155,1.176,1.6.921.441-1.079,0-1.843a1.767,1.767,0,0,0-1.3-1,.579.579,0,0,0-.293.075",
    transform: "translate(-93.295 -352.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.868,
    y1: 4.207,
    x2: -0.857,
    y2: 4.207,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#a57d82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e6e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23260",
    "data-name": "Rectangle 23260",
    className: "cls-1",
    width: 0.671,
    height: 0.329
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23261",
    "data-name": "Rectangle 23261",
    className: "cls-1",
    width: 0.766,
    height: 1.821
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23262",
    "data-name": "Rectangle 23262",
    className: "cls-1",
    width: 0.058,
    height: 0.208
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23263",
    "data-name": "Rectangle 23263",
    className: "cls-1",
    width: 0.32,
    height: 0.458
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23264",
    "data-name": "Rectangle 23264",
    className: "cls-1",
    width: 1.864,
    height: 2.727
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62291",
    "data-name": "Path 62291",
    className: "cls-1",
    d: "M110.956,386.435l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.033.008",
    transform: "translate(-110.829 -386.427)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.907,
    y1: 28.032,
    x2: -8.826,
    y2: 28.032,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62293",
    "data-name": "Path 62293",
    className: "cls-1",
    d: "M105.479,368.006l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.033.008",
    transform: "translate(-105.352 -367.998)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8.459,
    y1: 29.509,
    x2: -8.377,
    y2: 29.509,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#643241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62295",
    "data-name": "Path 62295",
    className: "cls-1",
    d: "M124.178,400.393l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.063.063,0,0,0-.032.008",
    transform: "translate(-124.051 -400.385)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -9.99,
    y1: 26.913,
    x2: -9.908,
    y2: 26.913,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62297",
    "data-name": "Path 62297",
    className: "cls-1",
    d: "M108.566,366.449l-.368.212c-.2.115-.2.486,0,.829s.52.529.718.415l.368-.212c.2-.115.2-.486,0-.829a.8.8,0,0,0-.586-.448.26.26,0,0,0-.132.034",
    transform: "translate(-108.049 -366.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.009,
    y1: 7.387,
    x2: -1.989,
    y2: 7.387,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62298",
    "data-name": "Path 62298",
    className: "cls-1",
    d: "M116.614,366.449l-.163.094c.2-.115.57.042.829.35a1.119,1.119,0,0,1,.179.286,1.153,1.153,0,0,0-.126-.316.8.8,0,0,0-.586-.448.26.26,0,0,0-.132.034",
    transform: "translate(-116.451 -366.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4.858,
    y1: 20.242,
    x2: -4.816,
    y2: 20.242,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62300",
    "data-name": "Path 62300",
    className: "cls-1",
    d: "M110.956,355.9l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.032.008",
    transform: "translate(-110.829 -355.892)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -8.907,
    y1: 30.478,
    x2: -8.825,
    y2: 30.478,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62305",
    "data-name": "Path 62305",
    className: "cls-1",
    d: "M142.786,390.216c-.049.028-.049.12,0,.2a.211.211,0,0,0,.13.109,2.073,2.073,0,0,0-.068-.349Z",
    transform: "translate(-142.749 -390.18)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -17.97,
    y1: 37.057,
    x2: -17.843,
    y2: 37.057,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62307",
    "data-name": "Path 62307",
    className: "cls-1",
    d: "M137.4,401.7l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.033.008",
    transform: "translate(-137.273 -401.694)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -11.074,
    y1: 26.809,
    x2: -10.992,
    y2: 26.809,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62309",
    "data-name": "Path 62309",
    className: "cls-1",
    d: "M179.02,356.856l-2.031,1.173c-.8.464-.8,1.969,0,3.361s2.107,2.144,2.91,1.68l2.031-1.173c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.376-1.817,1.056,1.056,0,0,0-.535.137",
    transform: "translate(-176.386 -356.719)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.656,
    y1: 1.86,
    x2: -0.651,
    y2: 1.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62310",
    "data-name": "Path 62310",
    className: "cls-1",
    d: "M199.218,356.856l-1.747,1.009c.64-.37,2.141.351,2.955,1.655.859,1.376.869,2.859-.077,3.405l1.781-1.028c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.376-1.817,1.056,1.056,0,0,0-.535.137",
    transform: "translate(-197.471 -356.719)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.909,
    y1: 2.077,
    x2: -0.904,
    y2: 2.077,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62313",
    "data-name": "Path 62313",
    className: "cls-1",
    d: "M198.82,413.224c-.441.254-.441,1.079,0,1.843s1.155,1.176,1.6.921.441-1.079,0-1.843a1.767,1.767,0,0,0-1.3-1,.578.578,0,0,0-.293.075",
    transform: "translate(-198.489 -413.149)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2.067,
    y1: 3.555,
    x2: -2.055,
    y2: 3.555,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23286",
    "data-name": "Rectangle 23286",
    className: "cls-1",
    width: 0.766,
    height: 1.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62320",
    "data-name": "Path 62320",
    className: "cls-1",
    d: "M216.151,447.169l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.032.008",
    transform: "translate(-216.024 -447.161)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -17.521,
    y1: 23.161,
    x2: -17.439,
    y2: 23.161,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62322",
    "data-name": "Path 62322",
    className: "cls-1",
    d: "M210.674,428.74l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.032.008",
    transform: "translate(-210.547 -428.732)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -17.072,
    y1: 24.639,
    x2: -16.99,
    y2: 24.639,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62324",
    "data-name": "Path 62324",
    className: "cls-1",
    d: "M229.373,461.127l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.065.065,0,0,0-.032.008",
    transform: "translate(-229.246 -461.119)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -18.605,
    y1: 22.043,
    x2: -18.523,
    y2: 22.043,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62326",
    "data-name": "Path 62326",
    className: "cls-1",
    d: "M213.761,427.184l-.368.212c-.2.115-.2.486,0,.829s.52.529.718.415l.368-.212c.2-.115.2-.486,0-.829a.8.8,0,0,0-.586-.449.261.261,0,0,0-.132.034",
    transform: "translate(-213.244 -427.15)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -4.129,
    y1: 6.189,
    x2: -4.109,
    y2: 6.189,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62327",
    "data-name": "Path 62327",
    className: "cls-1",
    d: "M221.809,427.184l-.163.094c.2-.115.57.042.829.35a1.119,1.119,0,0,1,.179.286,1.151,1.151,0,0,0-.127-.316.8.8,0,0,0-.586-.449.261.261,0,0,0-.132.034",
    transform: "translate(-221.646 -427.15)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -9.246,
    y1: 16.903,
    x2: -9.205,
    y2: 16.903,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62329",
    "data-name": "Path 62329",
    className: "cls-1",
    d: "M216.151,416.635l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.033.008",
    transform: "translate(-216.024 -416.627)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -17.523,
    y1: 25.612,
    x2: -17.441,
    y2: 25.612,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62334",
    "data-name": "Path 62334",
    className: "cls-1",
    d: "M247.981,450.951c-.049.028-.049.12,0,.2a.211.211,0,0,0,.13.109,2.058,2.058,0,0,0-.068-.348Z",
    transform: "translate(-247.944 -450.915)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -31.416,
    y1: 30.537,
    x2: -31.288,
    y2: 30.537,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62336",
    "data-name": "Path 62336",
    className: "cls-1",
    d: "M242.594,462.437l-.091.052c-.049.028-.049.12,0,.2s.128.13.177.1l.091-.052c.049-.028.049-.12,0-.2a.2.2,0,0,0-.144-.11.064.064,0,0,0-.032.008",
    transform: "translate(-242.467 -462.429)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -19.686,
    y1: 21.937,
    x2: -19.604,
    y2: 21.937,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62339",
    "data-name": "Path 62339",
    className: "cls-1",
    d: "M175.038,317.611l-.284.111-2.031,1.173.284-.111a.869.869,0,0,1,.742.116l2.522,1.456a1.736,1.736,0,0,1,.647.741l.686,1.424a1.6,1.6,0,0,1,.17.674v1.491l2.031-1.173v-1.491a1.6,1.6,0,0,0-.17-.674l-.686-1.424a1.737,1.737,0,0,0-.647-.741l-2.523-1.456a1.051,1.051,0,0,0-.516-.157.616.616,0,0,0-.226.041",
    transform: "translate(-172.723 -317.57)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.616,
    y1: 1.942,
    x2: -0.612,
    y2: 1.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#6a3b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#5e303f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23307",
    "data-name": "Rectangle 23307",
    className: "cls-1",
    width: 6.705,
    height: 6.248
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62341",
    "data-name": "Path 62341",
    className: "cls-1",
    d: "M74.483,257.092l.01-.006-.01.006m2.031-1.173h0l-2.021,1.167a.581.581,0,0,1,.573.06l2.522,1.456a2.292,2.292,0,0,1,.742.741l.284.439,2.031-1.173-.284-.439a2.293,2.293,0,0,0-.742-.741L77.1,255.973a.744.744,0,0,0-.365-.111.418.418,0,0,0-.218.057",
    transform: "translate(-74.483 -255.862)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.352,
    y1: 3.306,
    x2: -0.346,
    y2: 3.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a3b48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23310",
    "data-name": "Rectangle 23310",
    className: "cls-1",
    width: 5.907,
    height: 3.702
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23314",
    "data-name": "Rectangle 23314",
    className: "cls-1",
    width: 5.5,
    height: 3.021
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23315",
    "data-name": "Rectangle 23315",
    className: "cls-1",
    width: 2.595,
    height: 2.451
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23316",
    "data-name": "Rectangle 23316",
    className: "cls-1",
    width: 4.789,
    height: 2.765
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23317",
    "data-name": "Rectangle 23317",
    className: "cls-1",
    width: 1.906,
    height: 4.548
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23318",
    "data-name": "Rectangle 23318",
    className: "cls-1",
    width: 4.535,
    height: 1.442
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23319",
    "data-name": "Rectangle 23319",
    className: "cls-1",
    width: 4.22,
    height: 3.374
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62373",
    "data-name": "Path 62373",
    className: "cls-1",
    d: "M803.118,319.906l-.669.386a.339.339,0,0,0-.153.265v1.857a.107.107,0,0,0,.045.1l.2.114.885-2.619-.2-.114a.079.079,0,0,0-.039-.01.138.138,0,0,0-.068.021",
    transform: "translate(-802.296 -319.885)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -11.167,
    y1: 7.363,
    x2: -11.153,
    y2: 7.363,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#754654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e4150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23322",
    "data-name": "Rectangle 23322",
    className: "cls-1",
    width: 0.335,
    height: 0.159
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62376",
    "data-name": "Path 62376",
    className: "cls-1",
    d: "M796.216,308.783a.373.373,0,0,0-.084.036h0l-.567.327.01.018.01.018.015.026.015.026.015.026.015.026.014.025.014.025.014.025.014.025.567-.327h0l.023-.011h0a.246.246,0,0,1,0,.025h0v.434h.275v-.434h0a.38.38,0,0,0-.01-.089.306.306,0,0,0-.044-.1.267.267,0,0,0-.081-.077.272.272,0,0,0-.107-.034h-.023a.3.3,0,0,0-.09.014",
    transform: "translate(-795.564 -308.769)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23325",
    "data-name": "Rectangle 23325",
    className: "cls-1",
    width: 1.007,
    height: 0.738
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62378",
    "data-name": "Path 62378",
    className: "cls-1",
    d: "M812.967,316.125c0,.044.062.079.137.079a.182.182,0,0,0,.112-.033,1.119,1.119,0,0,1-.249-.494Z",
    transform: "translate(-812.967 -315.677)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -137.279,
    y1: 33.409,
    x2: -137.11,
    y2: 33.409,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62380",
    "data-name": "Path 62380",
    className: "cls-1",
    d: "M434.345,521.578c-.867-.04-1.47.624-1.47,1.8l1.552-.9a2.387,2.387,0,0,1,.212-1.047Z",
    transform: "translate(-432.875 -521.434)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -7.138,
    y1: 3.616,
    x2: -7.121,
    y2: 3.616,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62384",
    "data-name": "Path 62384",
    className: "cls-1",
    d: "M446.107,517.921l-1.552.9c-.8.464-.8,1.969,0,3.361s2.107,2.144,2.91,1.68l1.552-.9c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.375-1.817,1.057,1.057,0,0,0-.535.137",
    transform: "translate(-443.953 -517.784)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.022,
    y1: 1.172,
    x2: -2.017,
    y2: 1.172,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62385",
    "data-name": "Path 62385",
    className: "cls-1",
    d: "M466.3,517.921l-1.268.732c.64-.37,2.141.351,2.955,1.655.859,1.376.869,2.859-.077,3.405l1.3-.751c.8-.464.8-1.969,0-3.361a3.223,3.223,0,0,0-2.375-1.817,1.056,1.056,0,0,0-.535.137",
    transform: "translate(-465.037 -517.784)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -2.529,
    y1: 1.306,
    x2: -2.523,
    y2: 1.306,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62388",
    "data-name": "Path 62388",
    className: "cls-1",
    d: "M466.386,567.707c-.441.254-.441,1.079,0,1.843s1.155,1.176,1.6.921.441-1.079,0-1.843a1.767,1.767,0,0,0-1.3-1,.58.58,0,0,0-.293.075",
    transform: "translate(-466.056 -567.632)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -5.114,
    y1: 1.897,
    x2: -5.103,
    y2: 1.897,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23336",
    "data-name": "Rectangle 23336",
    className: "cls-1",
    width: 2.062,
    height: 2.813
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62391",
    "data-name": "Path 62391",
    className: "cls-1",
    d: "M473.2,570.843c-.327.189-.327.8,0,1.369s.858.874,1.186.685l.534-.308a2.459,2.459,0,0,0-1.186-2.054Z",
    transform: "translate(-472.951 -570.535)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -6.306,
    y1: 2.235,
    x2: -6.292,
    y2: 2.235,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23339",
    "data-name": "Rectangle 23339",
    className: "cls-1",
    width: 1.546,
    height: 2.261
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62394",
    "data-name": "Path 62394",
    className: "cls-1",
    d: "M490.163,582.206a.253.253,0,0,0,.115.2c.063.037.115.007.115-.066a.253.253,0,0,0-.115-.2.1.1,0,0,0-.051-.016c-.038,0-.063.03-.063.082",
    transform: "translate(-490.163 -582.124)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -73.376,
    y1: 18.278,
    x2: -73.226,
    y2: 18.278,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62396",
    "data-name": "Path 62396",
    className: "cls-1",
    d: "M490.163,615.484a.253.253,0,0,0,.115.2c.063.036.115.007.115-.066a.253.253,0,0,0-.115-.2.1.1,0,0,0-.051-.016c-.038,0-.063.03-.063.082",
    transform: "translate(-490.163 -615.402)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -73.376,
    y1: 14.298,
    x2: -73.226,
    y2: 14.298,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62398",
    "data-name": "Path 62398",
    className: "cls-1",
    d: "M504.572,607.165a.253.253,0,0,0,.114.2c.063.036.115.007.115-.066a.253.253,0,0,0-.115-.2.1.1,0,0,0-.051-.016c-.038,0-.063.03-.063.082",
    transform: "translate(-504.572 -607.083)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -75.537,
    y1: 15.295,
    x2: -75.387,
    y2: 15.295,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62400",
    "data-name": "Path 62400",
    className: "cls-1",
    d: "M475.754,590.526a.253.253,0,0,0,.115.2c.063.036.115.007.115-.066a.253.253,0,0,0-.115-.2.1.1,0,0,0-.051-.016c-.038,0-.063.03-.063.082",
    transform: "translate(-475.754 -590.444)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -71.228,
    y1: 17.285,
    x2: -71.078,
    y2: 17.285,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62402",
    "data-name": "Path 62402",
    className: "cls-1",
    d: "M500.386,592.888c-.045.026-.045.109,0,.187s.117.119.162.094.045-.11,0-.187a.179.179,0,0,0-.132-.1.059.059,0,0,0-.03.008",
    transform: "translate(-500.353 -592.88)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -69.531,
    y1: 16.938,
    x2: -69.392,
    y2: 16.938,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62404",
    "data-name": "Path 62404",
    className: "cls-1",
    d: "M480.008,604.653c-.045.026-.045.11,0,.187s.117.119.162.093.045-.11,0-.187a.18.18,0,0,0-.132-.1.059.059,0,0,0-.03.008",
    transform: "translate(-479.974 -604.645)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -66.683,
    y1: 15.534,
    x2: -66.544,
    y2: 15.534,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62406",
    "data-name": "Path 62406",
    className: "cls-1",
    d: "M500.386,616.419c-.045.026-.045.109,0,.187s.117.119.162.094.045-.11,0-.187a.18.18,0,0,0-.132-.1.059.059,0,0,0-.03.008",
    transform: "translate(-500.353 -616.411)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -69.531,
    y1: 14.133,
    x2: -69.392,
    y2: 14.133,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62408",
    "data-name": "Path 62408",
    className: "cls-1",
    d: "M480.008,581.123c-.045.026-.045.11,0,.187s.117.119.162.094.045-.11,0-.187a.179.179,0,0,0-.132-.1.059.059,0,0,0-.03.008",
    transform: "translate(-479.974 -581.115)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -66.684,
    y1: 18.34,
    x2: -66.545,
    y2: 18.34,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62410",
    "data-name": "Path 62410",
    className: "cls-1",
    d: "M485.4,592.513c-.125.072-.125.3,0,.521s.326.332.451.26.124-.3,0-.521a.5.5,0,0,0-.368-.282.164.164,0,0,0-.083.021",
    transform: "translate(-485.307 -592.492)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.491,
    cy: 1.119,
    r: 0.99,
    gradientTransform: "matrix(1.249, 0, 0, -1, 7.246, 13.671)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62411",
    "data-name": "Path 62411",
    className: "cls-1",
    d: "M450.539,468.381l2.641,1.525a4.872,4.872,0,0,1,2.2,3.817v2.9l.95-.549V473.3l-.859-.5a4.941,4.941,0,0,0-2.106-3.008l-2.641-1.525Z",
    transform: "translate(-450.539 -468.272)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -1.937,
    y1: 1.196,
    x2: -1.932,
    y2: 1.196,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c17a2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23359",
    "data-name": "Rectangle 23359",
    className: "cls-1",
    width: 0.189,
    height: 0.515
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23360",
    "data-name": "Rectangle 23360",
    className: "cls-1",
    width: 2.764,
    height: 1.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23364",
    "data-name": "Rectangle 23364",
    className: "cls-1",
    width: 2.575,
    height: 1.348
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23365",
    "data-name": "Rectangle 23365",
    className: "cls-1",
    width: 1.406,
    height: 3.217
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23366",
    "data-name": "Rectangle 23366",
    className: "cls-1",
    width: 1.406,
    height: 2.267
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62431",
    "data-name": "Path 62431",
    className: "cls-1",
    d: "M492,382.995v1.475a1.1,1.1,0,0,0,.5.862l.909.525v-.134l-.793-.458a1.1,1.1,0,0,1-.5-.862v-1.475a.394.394,0,0,1,.093-.28c-.126.031-.209.154-.209.347",
    transform: "translate(-492.004 -382.648)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -7.341,
    y1: 4.278,
    x2: -7.325,
    y2: 4.278,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23369",
    "data-name": "Rectangle 23369",
    className: "cls-1",
    width: 0.232,
    height: 0.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23370",
    "data-name": "Rectangle 23370",
    className: "cls-1",
    width: 2.964,
    height: 4.859
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23371",
    "data-name": "Rectangle 23371",
    className: "cls-1",
    width: 2.409,
    height: 2.691
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62436",
    "data-name": "Path 62436",
    className: "cls-1",
    d: "M539.034,465.26l1.468.847a.957.957,0,0,1,.357.409l.133.275a.958.958,0,0,0,.357.409l.467.27c.082.048.15.024.173-.044a.188.188,0,0,1-.058-.022l-.467-.27a.958.958,0,0,1-.357-.409l-.133-.275a.958.958,0,0,0-.357-.409l-1.468-.847Z",
    transform: "translate(-539.034 -465.193)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -5.99,
    y1: 3.413,
    x2: -5.979,
    y2: 3.413,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23374",
    "data-name": "Rectangle 23374",
    className: "cls-1",
    width: 0.231,
    height: 0.067
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23375",
    "data-name": "Rectangle 23375",
    className: "cls-1",
    width: 1.095,
    height: 6.681
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23377",
    "data-name": "Rectangle 23377",
    className: "cls-1",
    width: 0.86,
    height: 0.767
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23378",
    "data-name": "Rectangle 23378",
    className: "cls-1",
    width: 0.896,
    height: 1.035
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62449",
    "data-name": "Path 62449",
    className: "cls-1",
    d: "M614.67,597.3l.327.188h.428l1.53-.883-.541-.312Z",
    transform: "translate(-614.67 -596.297)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -9.978,
    y1: 2.892,
    x2: -9.962,
    y2: 2.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c78731"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62450",
    "data-name": "Path 62450",
    className: "cls-1",
    d: "M771.856,506.555l.54.312,1.53-.883v-.247l-.326-.188Z",
    transform: "translate(-771.856 -505.548)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -13.158,
    y1: 4.621,
    x2: -13.14,
    y2: 4.621,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23382",
    "data-name": "Rectangle 23382",
    className: "cls-1",
    width: 8.807,
    height: 5.051
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23383",
    "data-name": "Rectangle 23383",
    className: "cls-1",
    width: 2.589,
    height: 1.62
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62481",
    "data-name": "Path 62481",
    className: "cls-1",
    d: "M584.014,299.447v.4a.232.232,0,0,0,.137.19l1.012.584a.729.729,0,0,0,.659,0l1.879-1.085a.232.232,0,0,0,.137-.191v-.4Z",
    transform: "translate(-584.014 -298.946)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -6.424,
    y1: 10.281,
    x2: -6.413,
    y2: 10.281,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23386",
    "data-name": "Rectangle 23386",
    className: "cls-1",
    width: 0.28,
    height: 0.316
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23387",
    "data-name": "Rectangle 23387",
    className: "cls-1",
    width: 0.341,
    height: 0.077
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23388",
    "data-name": "Rectangle 23388",
    className: "cls-1",
    width: 0.28,
    height: 0.315
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23390",
    "data-name": "Rectangle 23390",
    className: "cls-1",
    width: 0.579,
    height: 0.215
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23391",
    "data-name": "Rectangle 23391",
    className: "cls-1",
    width: 0.579,
    height: 0.454
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23392",
    "data-name": "Rectangle 23392",
    className: "cls-1",
    width: 0.207,
    height: 0.239
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23408",
    "data-name": "Rectangle 23408",
    className: "cls-1",
    width: 8.3,
    height: 8.223
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62515",
    "data-name": "Path 62515",
    className: "cls-1",
    d: "M641.464,325.563l.671,3.37a.767.767,0,0,1-.3.775l-6.768,3.908a.323.323,0,0,1-.262.037.308.308,0,0,0,.377.03l6.768-3.908a.766.766,0,0,0,.3-.775l-.694-3.49Z",
    transform: "translate(-634.8 -325.51)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2.303,
    y1: 1.741,
    x2: -2.299,
    y2: 1.741,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26827"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62529",
    "data-name": "Path 62529",
    className: "cls-1",
    d: "M599.014,540.322l.753.435v-1.871l-.753-.435Z",
    transform: "translate(-599.014 -538.451)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -33.457,
    y1: 3.576,
    x2: -33.401,
    y2: 3.576,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad241"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23413",
    "data-name": "Rectangle 23413",
    className: "cls-1",
    width: 0.753,
    height: 1.731
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23414",
    "data-name": "Rectangle 23414",
    className: "cls-1",
    width: 0.613,
    height: 1.013
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62535",
    "data-name": "Path 62535",
    className: "cls-1",
    d: "M536.285,489.371v.881l.252.145a.172.172,0,0,0,.175.016l.115-.067a.173.173,0,0,0,.071-.158v-.314a.543.543,0,0,0-.246-.426l-.251-.145Z",
    transform: "translate(-536.285 -489.304)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -20.774,
    y1: 8.051,
    x2: -20.735,
    y2: 8.051,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23417",
    "data-name": "Rectangle 23417",
    className: "cls-1",
    width: 0.58,
    height: 1.608
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23418",
    "data-name": "Rectangle 23418",
    className: "cls-1",
    width: 8.722,
    height: 5.366
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23419",
    "data-name": "Rectangle 23419",
    className: "cls-1",
    width: 8.567,
    height: 5.889
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62541",
    "data-name": "Path 62541",
    className: "cls-1",
    d: "M576.491,515.584h-.254v.434h0a.374.374,0,0,0,.01.089.307.307,0,0,0,.044.1.267.267,0,0,0,.081.077.27.27,0,0,0,.106.034.3.3,0,0,0,.113-.013.366.366,0,0,0,.084-.036h0l.567-.327-.014-.025-.014-.025-.014-.025-.014-.025-.015-.026-.015-.026-.015-.026-.015-.026-.01-.018-.01-.018-.567.327h0l-.023.011h0s0-.015,0-.025h0v-.434Z",
    transform: "translate(-576.237 -515.584)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23423",
    "data-name": "Rectangle 23423",
    className: "cls-1",
    width: 1.007,
    height: 0.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62543",
    "data-name": "Path 62543",
    className: "cls-1",
    d: "M596.261,518.358c-.038.022-.038.093,0,.159s.1.1.137.079.038-.093,0-.159a.152.152,0,0,0-.112-.086.05.05,0,0,0-.025.007",
    transform: "translate(-596.233 -518.352)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -78.63,
    y1: 27.041,
    x2: -78.498,
    y2: 27.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73434f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62544",
    "data-name": "Path 62544",
    className: "cls-1",
    d: "M566.386,456.583l-.669.386a.339.339,0,0,0-.153.265v1.857a.107.107,0,0,0,.045.1l.2.114.885-2.619-.2-.114a.079.079,0,0,0-.039-.01.138.138,0,0,0-.068.021",
    transform: "translate(-565.564 -456.562)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -7.781,
    y1: 4.909,
    x2: -7.767,
    y2: 4.909,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23427",
    "data-name": "Rectangle 23427",
    className: "cls-1",
    width: 0.541,
    height: 0.257
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62547",
    "data-name": "Path 62547",
    className: "cls-1",
    d: "M576.539,432.761h0a.652.652,0,0,0-.3.522h0v.434h.275v-.434h0a.382.382,0,0,1,.164-.285h0l.567-.327-.014-.025-.014-.025-.014-.025-.014-.025-.015-.026-.015-.026-.015-.026-.015-.026-.01-.018-.01-.018-.567.327",
    transform: "translate(-576.237 -432.434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23430",
    "data-name": "Rectangle 23430",
    className: "cls-1",
    width: 1.007,
    height: 1.286
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62548",
    "data-name": "Path 62548",
    className: "cls-1",
    d: "M596.261,432.286c-.038.022-.038.093,0,.159s.1.1.137.079.038-.093,0-.159a.152.152,0,0,0-.112-.086.05.05,0,0,0-.025.006",
    transform: "translate(-596.233 -432.28)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -78.63,
    y1: 37.764,
    x2: -78.498,
    y2: 37.764,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62549",
    "data-name": "Path 62549",
    className: "cls-1",
    d: "M576.236,461.2c0,.044.062.079.137.079s.138-.036.138-.079-.062-.079-.138-.079-.137.036-.137.079",
    transform: "translate(-576.236 -461.116)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -88.123,
    y1: 72.428,
    x2: -87.97,
    y2: 72.428,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62555",
    "data-name": "Path 62555",
    className: "cls-1",
    d: "M789.749,447.929l-.613,2.181.3-.176a1.183,1.183,0,0,0,.521-.812l.187-1.424Z",
    transform: "translate(-789.136 -447.698)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -15.713,
    y1: 4.682,
    x2: -15.693,
    y2: 4.682,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62560",
    "data-name": "Path 62560",
    className: "cls-1",
    d: "M640.48,542.172l.187,1.208c.042.27.263.359.521.21l.3-.176-.613-1.473Z",
    transform: "translate(-640.48 -541.941)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -14.906,
    y1: 3.992,
    x2: -14.883,
    y2: 3.992,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62561",
    "data-name": "Path 62561",
    className: "cls-1",
    d: "M641.233,542.153l.573,1.376.408-.116-.613-1.473Z",
    transform: "translate(-641.233 -541.941)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -17.621,
    y1: 4.464,
    x2: -17.593,
    y2: 4.464,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c57c2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62578",
    "data-name": "Path 62578",
    className: "cls-1",
    d: "M789.749,451.079l-.613,2.181.2-.236.573-2.038Z",
    transform: "translate(-789.136 -450.987)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -13.501,
    y1: 8.41,
    x2: -13.484,
    y2: 8.41,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23443",
    "data-name": "Rectangle 23443",
    className: "cls-1",
    width: 0.576,
    height: 0.317
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23444",
    "data-name": "Rectangle 23444",
    className: "cls-1",
    width: 0.488,
    height: 0.213
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23445",
    "data-name": "Rectangle 23445",
    className: "cls-1",
    width: 0.22,
    height: 0.165
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23446",
    "data-name": "Rectangle 23446",
    className: "cls-1",
    width: 0.863,
    height: 0.436
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62587",
    "data-name": "Path 62587",
    className: "cls-1",
    d: "M560.082,372.133v.161c0,.121.169.218.378.218s.378-.1.378-.218v-.161c0-.121-.169-.218-.378-.218s-.378.1-.378.218",
    transform: "translate(-560.082 -371.915)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -31.155,
    y1: 25.545,
    x2: -31.1,
    y2: 25.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62590",
    "data-name": "Path 62590",
    className: "cls-1",
    d: "M564.754,365.818c-.059.1-.059.211,0,.245l.067.039c.059.034.153-.021.212-.122s.059-.211,0-.245l-.067-.039a.078.078,0,0,0-.039-.01.234.234,0,0,0-.173.132",
    transform: "translate(-564.71 -365.686)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -40.256,
    y1: 27.431,
    x2: -40.185,
    y2: 27.431,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a87f80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23452",
    "data-name": "Rectangle 23452",
    className: "cls-1",
    width: 0.677,
    height: 0.887
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62592",
    "data-name": "Path 62592",
    className: "cls-1",
    d: "M561.659,360.668c0,.1-.134.173-.3.173s-.3-.077-.3-.173l-.039.691c0,.108.152.2.339.2s.339-.088.339-.2Z",
    transform: "translate(-561.021 -360.668)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -34.848,
    y1: 17.732,
    x2: -34.786,
    y2: 17.732,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dd7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd7300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23454",
    "data-name": "Rectangle 23454",
    className: "cls-1",
    width: 0.598,
    height: 0.345
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62593",
    "data-name": "Path 62593",
    className: "cls-1",
    d: "M562.259,356.562c.133,0,.241.062.241.139s-.108.139-.241.139-.241-.062-.241-.139.108-.139.241-.139c-.165,0-.3.077-.3.173s.134.173.3.173.3-.077.3-.173-.134-.173-.3-.173",
    transform: "translate(-561.96 -356.562)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -39.516,
    y1: 46.032,
    x2: -39.446,
    y2: 46.032,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e27b06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23455",
    "data-name": "Rectangle 23455",
    className: "cls-1",
    width: 0.481,
    height: 0.278
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23456",
    "data-name": "Rectangle 23456",
    className: "cls-1",
    width: 0.492,
    height: 0.251
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62597",
    "data-name": "Path 62597",
    className: "cls-1",
    d: "M735.79,270.688v.16c0,.121.169.218.378.218s.378-.1.378-.218v-.16c0-.121-.169-.218-.378-.218s-.378.1-.378.218",
    transform: "translate(-735.79 -270.47)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -40.927,
    y1: 32.694,
    x2: -40.871,
    y2: 32.694,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62600",
    "data-name": "Path 62600",
    className: "cls-1",
    d: "M740.463,264.372c-.058.1-.058.211,0,.245l.067.039c.058.034.153-.021.212-.122s.059-.211,0-.245l-.067-.039a.077.077,0,0,0-.039-.01.235.235,0,0,0-.173.132",
    transform: "translate(-740.419 -264.24)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -52.841,
    y1: 34.947,
    x2: -52.769,
    y2: 34.947,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62602",
    "data-name": "Path 62602",
    className: "cls-1",
    d: "M737.367,259.222c0,.1-.134.173-.3.173s-.3-.077-.3-.173l-.04.691c0,.108.152.2.339.2s.339-.087.339-.2Z",
    transform: "translate(-736.729 -259.222)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -45.76,
    y1: 22.544,
    x2: -45.698,
    y2: 22.544,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62603",
    "data-name": "Path 62603",
    className: "cls-1",
    d: "M737.968,255.117c.133,0,.241.062.241.139s-.108.139-.241.139-.241-.062-.241-.139.108-.139.241-.139c-.165,0-.3.077-.3.173s.134.173.3.173.3-.077.3-.173-.134-.173-.3-.173",
    transform: "translate(-737.669 -255.117)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -51.872,
    y1: 58.394,
    x2: -51.802,
    y2: 58.394,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23467",
    "data-name": "Rectangle 23467",
    className: "cls-1",
    width: 15.784,
    height: 11.122
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23468",
    "data-name": "Rectangle 23468",
    className: "cls-1",
    width: 0.801,
    height: 0.431
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset_Tracking",
    "data-name": "Asset Tracking",
    transform: "translate(4517.533 23194.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67451",
    "data-name": "Group 67451",
    transform: "translate(-4512.788 -23188.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67424",
    "data-name": "Group 67424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67423",
    "data-name": "Group 67423",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71102",
    "data-name": "Path 71102",
    className: "cls-3",
    d: "M235.462,288.25l-.016-.523c-.223.137-.455.269-.7.388.237.051.479.1.711.135",
    transform: "translate(-155.582 -190.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71103",
    "data-name": "Path 71103",
    className: "cls-4",
    d: "M96.528,153.194c4.067,5.058,20.115,17.083,32.622,23.306,0,.008.005,0,.005,0,.165-.025.327-.05.488-.083.414-.092.832-.195,1.237-.32a10.692,10.692,0,0,0,2.318-1.049L155.992,161a4.629,4.629,0,0,0,2.5-3.285l0-.006a3.791,3.791,0,0,0-1.9-2.128l-52.654-29.741c-2.876-1.625-7.756-1.366-10.907.573l-.911.56,0,.009c-5.084,8.769-1.7,18.626,4.411,26.212",
    transform: "translate(-59.41 -82.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71104",
    "data-name": "Path 71104",
    className: "cls-5",
    d: "M252.916,258.293l-16.1,9.927.016.523.1,3.426,7.8-4.805-.523-.874a.513.513,0,0,1-.536.078.4.4,0,0,1-.184-.355,1.42,1.42,0,0,1,.635-1.138l9.35-5.859Z",
    transform: "translate(-156.948 -171.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71105",
    "data-name": "Path 71105",
    className: "cls-4",
    d: "M83.126,181.015a15.787,15.787,0,0,0,2.176-.054c.093-.01.191-.023.287-.037a4.586,4.586,0,0,0,.48-.077C73.562,174.623,57.514,162.6,53.447,157.54c-6.113-7.586-9.5-17.443-4.411-26.212L27.157,144.812c-1.073.657-2.381,1.832-2.518,3.215a.8.8,0,0,0,.055.182,3.26,3.26,0,0,0,.741,1.174,3.452,3.452,0,0,0,.272.257c.085.073.172.143.26.216a2.852,2.852,0,0,0,.238.165,4,4,0,0,0,.342.213L79.21,179.966a.367.367,0,0,0,.035.023,3.028,3.028,0,0,0,.289.147,9.359,9.359,0,0,0,2.165.7,11.559,11.559,0,0,0,1.427.176",
    transform: "translate(-16.33 -87.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71106",
    "data-name": "Path 71106",
    className: "cls-5",
    d: "M199.417,288.419l.116,3.949a13.226,13.226,0,0,0,12.609-.233l-.1-3.426c-.232-.035-.474-.084-.711-.135-.228.123-.463.231-.7.331a13.669,13.669,0,0,1-7.241.842,11.5,11.5,0,0,1-3.745-1.206,1.848,1.848,0,0,1-.194-.1.333.333,0,0,1-.035-.02",
    transform: "translate(-132.165 -191.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71107",
    "data-name": "Path 71107",
    className: "cls-5",
    d: "M26.866,140.234a5.757,5.757,0,0,0-.6.411,6.183,6.183,0,0,0-1.138,1.082,3.337,3.337,0,0,0-.768,2,3.225,3.225,0,0,0,.02.42.745.745,0,0,1,.011.081c.022.087.039.167.063.249.138-1.383,1.445-2.557,2.518-3.214l21.879-13.484,0-.009a17.923,17.923,0,0,1,1.176-1.8c-.125.068-.246.137-.37.212l-12.637,7.791Z",
    transform: "translate(-16.145 -83.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71108",
    "data-name": "Path 71108",
    className: "cls-5",
    d: "M108.7,122.8c-2.763-1.564-7.379-1.388-10.534.359a18.058,18.058,0,0,0-1.176,1.8l.911-.56c3.151-1.939,8.03-2.2,10.907-.574l52.654,29.741a3.79,3.79,0,0,1,1.9,2.128,3.33,3.33,0,0,0-2.008-3.157Z",
    transform: "translate(-64.281 -80.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71109",
    "data-name": "Path 71109",
    className: "cls-5",
    d: "M313.173,232.167a1.633,1.633,0,0,1-.041.28,2.563,2.563,0,0,1-.066.28,1.612,1.612,0,0,1-.1.274,1.847,1.847,0,0,1-.1.25s-.005.006,0,.01a4.088,4.088,0,0,1-.574.891,4.637,4.637,0,0,1-.411.453c-.039.04-.087.085-.126.126-.063.051-.131.111-.19.167-.1.081-.2.164-.3.239-.2.149-.408.291-.612.418l.115,3.952a4.751,4.751,0,0,0,2.511-3.475Z",
    transform: "translate(-205.888 -153.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71110",
    "data-name": "Path 71110",
    className: "cls-6",
    d: "M317.868,233a2.069,2.069,0,0,1-.066.28,2.555,2.555,0,0,0,.066-.28",
    transform: "translate(-210.625 -154.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71111",
    "data-name": "Path 71111",
    className: "cls-6",
    d: "M317.616,233.828a2.735,2.735,0,0,1-.095.274,1.566,1.566,0,0,0,.095-.274",
    transform: "translate(-210.439 -154.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71112",
    "data-name": "Path 71112",
    className: "cls-6",
    d: "M317.327,234.641a2.524,2.524,0,0,1-.1.25,1.855,1.855,0,0,0,.1-.25",
    transform: "translate(-210.244 -155.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71113",
    "data-name": "Path 71113",
    className: "cls-6",
    d: "M316.09,235.413a4.686,4.686,0,0,1-.574.891,4.078,4.078,0,0,0,.574-.891",
    transform: "translate(-209.11 -156.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71114",
    "data-name": "Path 71114",
    className: "cls-6",
    d: "M314.048,239.4c-.038.04-.087.085-.126.125.039-.04.088-.086.126-.125",
    transform: "translate(-208.053 -158.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71115",
    "data-name": "Path 71115",
    className: "cls-7",
    d: "M251.16,239.275a1.058,1.058,0,0,0-.987.018l-19.474,12a.245.245,0,0,0-.085.068.374.374,0,0,0,.13.1,1.069,1.069,0,0,0,.989-.021l19.471-12a.447.447,0,0,0,.085-.061.428.428,0,0,0-.13-.1",
    transform: "translate(-152.841 -158.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71116",
    "data-name": "Path 71116",
    className: "cls-8",
    d: "M54.776,135.608a5.211,5.211,0,0,0-3.055-.52,2.733,2.733,0,0,0,.526,3.184c.133.12.3.263.5.406a4.7,4.7,0,0,0,2.1-.635,2.168,2.168,0,0,0,.814-.808,1.407,1.407,0,0,0,.148-.414l0,0a1.892,1.892,0,0,0-1.031-1.208",
    transform: "translate(-34.086 -89.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71117",
    "data-name": "Path 71117",
    className: "cls-9",
    d: "M55.332,134.273a5.094,5.094,0,0,0-2.778-.547,2.9,2.9,0,0,0-.266.476,5.208,5.208,0,0,1,3.055.52,1.894,1.894,0,0,1,1.031,1.207,1.673,1.673,0,0,0-1.043-1.657",
    transform: "translate(-34.655 -88.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71118",
    "data-name": "Path 71118",
    className: "cls-5",
    d: "M276.233,242.212l-8.8,5.423.548.921c.373-.236.7-.109.721.282a1.408,1.408,0,0,1-.641,1.134l-9.344,5.859.523.874,17.108-10.542Z",
    transform: "translate(-171.466 -160.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71119",
    "data-name": "Path 71119",
    className: "cls-9",
    d: "M46.945,133.753a4.869,4.869,0,0,0-2.136.633,2.257,2.257,0,0,0-.823.813,1.253,1.253,0,0,0-.133.876,1.333,1.333,0,0,1,.145-.428,2.219,2.219,0,0,1,.821-.812,4.676,4.676,0,0,1,1.86-.606,2.941,2.941,0,0,1,.266-.476",
    transform: "translate(-29.045 -88.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71120",
    "data-name": "Path 71120",
    className: "cls-10",
    d: "M55.906,142.524a4.389,4.389,0,0,0,1.519-.552,2.269,2.269,0,0,0,.823-.814,1.236,1.236,0,0,0,.131-.855,1.409,1.409,0,0,1-.148.414,2.173,2.173,0,0,1-.814.808,4.705,4.705,0,0,1-2.1.635,3.548,3.548,0,0,0,.589.365",
    transform: "translate(-36.662 -92.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71121",
    "data-name": "Path 71121",
    className: "cls-11",
    d: "M57.968,109.486l-11.9,7.336.229.382a4.874,4.874,0,0,1,2.136-.633,5.1,5.1,0,0,1,2.778.547,1.674,1.674,0,0,1,1.043,1.657l0,0a1.238,1.238,0,0,1-.131.855,2.274,2.274,0,0,1-.823.814,4.389,4.389,0,0,1-1.519.552,1.268,1.268,0,0,0,1.149.135l.485.812,12.637-7.79c.124-.075.245-.143.37-.212a25.8,25.8,0,0,1,5.141-5.185,13.855,13.855,0,0,0-11.587.725",
    transform: "translate(-30.528 -71.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71122",
    "data-name": "Path 71122",
    className: "cls-12",
    d: "M47.26,138.349a2.732,2.732,0,0,1-.526-3.184,4.674,4.674,0,0,0-1.86.606,2.218,2.218,0,0,0-.821.812,1.333,1.333,0,0,0-.145.428,1.936,1.936,0,0,0,1.033,1.2,4.968,4.968,0,0,0,2.471.554c.115,0,.231-.008.343-.015-.193-.143-.363-.286-.5-.406",
    transform: "translate(-29.1 -89.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71123",
    "data-name": "Path 71123",
    className: "cls-10",
    d: "M47.728,142.383c-.113.007-.228.011-.343.015a4.968,4.968,0,0,1-2.471-.554,1.936,1.936,0,0,1-1.033-1.2,1.664,1.664,0,0,0,1.04,1.643,4.991,4.991,0,0,0,2.477.558,6.113,6.113,0,0,0,.919-.093,3.547,3.547,0,0,1-.589-.365",
    transform: "translate(-29.073 -93.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71124",
    "data-name": "Path 71124",
    className: "cls-13",
    d: "M267.286,261.073c-.022-.391-.347-.518-.721-.282l-9.349,5.859a1.421,1.421,0,0,0-.635,1.139.4.4,0,0,0,.184.355.514.514,0,0,0,.536-.078l9.344-5.859a1.408,1.408,0,0,0,.641-1.133",
    transform: "translate(-170.049 -172.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71125",
    "data-name": "Path 71125",
    className: "cls-14",
    d: "M251.122,238.556c.179-.169.142-.38-.1-.519a1.08,1.08,0,0,0-.986.019l-19.472,12c-.221.132-.258.333-.115.487a.244.244,0,0,1,.085-.068l19.474-12a1.058,1.058,0,0,1,.987-.018.428.428,0,0,1,.13.1",
    transform: "translate(-152.673 -157.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71126",
    "data-name": "Path 71126",
    className: "cls-15",
    d: "M250.987,239.852l-19.471,12a1.07,1.07,0,0,1-.99.021.37.37,0,0,1-.13-.1c-.177.166-.139.377.1.512a1.059,1.059,0,0,0,.985-.018l19.476-12c.217-.138.25-.327.113-.483a.421.421,0,0,1-.085.061",
    transform: "translate(-152.624 -158.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71127",
    "data-name": "Path 71127",
    className: "cls-16",
    d: "M30.015,168.676a5.757,5.757,0,0,1,.6-.411c-.195.12-.4.26-.6.411",
    transform: "translate(-19.893 -111.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71128",
    "data-name": "Path 71128",
    className: "cls-16",
    d: "M24.319,174.692a3.338,3.338,0,0,1,.768-2,2.971,2.971,0,0,0-.748,2.419,3.16,3.16,0,0,1-.02-.42",
    transform: "translate(-16.103 -114.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71129",
    "data-name": "Path 71129",
    className: "cls-16",
    d: "M193.182,276.878a15.8,15.8,0,0,1-2.176.054,11.5,11.5,0,0,1-1.427-.176,9.35,9.35,0,0,1-2.165-.7,10.5,10.5,0,0,0,5.768.825",
    transform: "translate(-124.21 -182.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71130",
    "data-name": "Path 71130",
    className: "cls-16",
    d: "M24.453,180.1c.017.091.039.182.061.268,0-.007.005-.01,0-.02-.023-.082-.041-.162-.063-.249",
    transform: "translate(-16.206 -119.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71131",
    "data-name": "Path 71131",
    className: "cls-16",
    d: "M24.635,180.842c0,.009,0,.013,0,.02a.785.785,0,0,0,.057.163.775.775,0,0,1-.055-.182",
    transform: "translate(-16.326 -119.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71132",
    "data-name": "Path 71132",
    className: "cls-16",
    d: "M25.543,182.558a3.261,3.261,0,0,1-.741-1.174,3.15,3.15,0,0,0,.741,1.174",
    transform: "translate(-16.438 -120.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71133",
    "data-name": "Path 71133",
    className: "cls-16",
    d: "M27,184.864a1.841,1.841,0,0,0,.273.257,3.461,3.461,0,0,1-.273-.257",
    transform: "translate(-17.894 -122.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71134",
    "data-name": "Path 71134",
    className: "cls-6",
    d: "M1.566,173.041A4.328,4.328,0,0,1,.217,171a3.146,3.146,0,0,1-.085-.372,3.793,3.793,0,0,0,1.434,2.416",
    transform: "translate(-0.087 -113.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71135",
    "data-name": "Path 71135",
    className: "cls-5",
    d: "M.079,172.282a7.806,7.806,0,0,0,.168,1.992,5.153,5.153,0,0,0,2.561,2.816l-.117-3.94c-.136-.076-.281-.169-.421-.259l-.027-.015c-.109-.074-.227-.151-.333-.235-.035-.028-.07-.05-.11-.08-.107-.08-.214-.168-.323-.266a3.8,3.8,0,0,1-1.434-2.416c-.009-.005-.008-.009-.008-.009s0-.01,0-.013A2.01,2.01,0,0,1,0,169.5c.025.926.055,1.853.079,2.783",
    transform: "translate(0 -112.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71136",
    "data-name": "Path 71136",
    className: "cls-6",
    d: "M4.708,178.054c-.112-.083-.214-.168-.323-.266.109.1.215.186.323.266",
    transform: "translate(-2.906 -117.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71137",
    "data-name": "Path 71137",
    className: "cls-6",
    d: "M6,179.048c-.109-.074-.227-.15-.333-.235.106.085.224.162.333.235",
    transform: "translate(-3.756 -118.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71138",
    "data-name": "Path 71138",
    className: "cls-6",
    d: "M7.155,179.814c-.146-.08-.281-.169-.421-.259.139.091.284.183.421.259",
    transform: "translate(-4.463 -119.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71139",
    "data-name": "Path 71139",
    className: "cls-17",
    d: "M203.842,289.987a12.164,12.164,0,0,1-3.745-1.205,11.486,11.486,0,0,0,3.745,1.205",
    transform: "translate(-132.615 -191.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71140",
    "data-name": "Path 71140",
    className: "cls-17",
    d: "M199.661,288.55c-.048-.029-.091-.047-.138-.072a1.787,1.787,0,0,0,.194.1.468.468,0,0,1-.056-.03",
    transform: "translate(-132.235 -191.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71141",
    "data-name": "Path 71141",
    className: "cls-18",
    d: "M153.742,266.491l-14.335-8.045a1.2,1.2,0,0,0-1.29.159.726.726,0,0,1,.528.1l14.249,7.991a1.135,1.135,0,0,1,.6,1.042.462.462,0,0,1-.161.271c.44-.1.882-.368.919-.547a.951.951,0,0,0-.515-.969",
    transform: "translate(-91.538 -171.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71142",
    "data-name": "Path 71142",
    className: "cls-18",
    d: "M103.249,239.21l-2-1.12a1.225,1.225,0,0,0-1.311.162.719.719,0,0,1,.55.095s1.022.569,2.51,1.406c2.032,1.143,3.994,2.24,5.229,2.932.792.447,1.279.718,1.279.718a1.137,1.137,0,0,1,.6,1.042.416.416,0,0,1-.167.276c.445-.108.894-.372.92-.556a.941.941,0,0,0-.514-.97s-.737-.409-1.875-1.05c-1.359-.762-3.292-1.85-5.227-2.934",
    transform: "translate(-66.236 -157.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71143",
    "data-name": "Path 71143",
    className: "cls-19",
    d: "M152.283,267.214l-14.249-7.991a.723.723,0,0,0-.528-.1l0,0a.388.388,0,0,0-.3.33,1.125,1.125,0,0,0,.6,1.041l14.244,7.99a.982.982,0,0,0,.674.036.465.465,0,0,0,.161-.271,1.136,1.136,0,0,0-.6-1.042",
    transform: "translate(-90.927 -171.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71144",
    "data-name": "Path 71144",
    className: "cls-19",
    d: "M101.946,241.409l5.2,2.914,1.565.879a1.012,1.012,0,0,0,.664.038.415.415,0,0,0,.167-.275,1.137,1.137,0,0,0-.6-1.042s-.488-.272-1.279-.718c-1.235-.693-3.2-1.79-5.229-2.932-1.488-.837-2.509-1.406-2.509-1.406a.72.72,0,0,0-.55-.095.387.387,0,0,0-.283.331,1.122,1.122,0,0,0,.6,1.041s.908.507,2.261,1.265",
    transform: "translate(-65.661 -158.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71145",
    "data-name": "Path 71145",
    className: "cls-20",
    d: "M181.248,286.929a.623.623,0,0,0,.674.036.98.98,0,0,1-.674-.036",
    transform: "translate(-120.123 -190.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71146",
    "data-name": "Path 71146",
    className: "cls-5",
    d: "M137.954,263.9,158.8,275.679l-.116-3.949-4.69-2.65-.359.667a.951.951,0,0,1,.515.969c-.038.179-.479.443-.919.547a.623.623,0,0,1-.674-.036l-14.244-7.99Z",
    transform: "translate(-91.43 -174.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71147",
    "data-name": "Path 71147",
    className: "cls-20",
    d: "M128.3,257.918a1.016,1.016,0,0,1-.664-.038.628.628,0,0,0,.664.038",
    transform: "translate(-84.593 -170.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71148",
    "data-name": "Path 71148",
    className: "cls-5",
    d: "M7.981,180.323l5.931,3.348,53.94,30.457-.358.667-14.335-8.044a1.2,1.2,0,0,0-1.29.159l-.005.005a.388.388,0,0,0-.3.33,1.123,1.123,0,0,0,.6,1.041l-.356.666L8.1,184.263Zm40.354,26.155a.628.628,0,0,0,.664.038c.445-.107.894-.372.92-.556a.94.94,0,0,0-.514-.97s-.737-.409-1.875-1.05c-1.358-.762-3.291-1.85-5.227-2.935l-2-1.12a1.224,1.224,0,0,0-1.311.162.387.387,0,0,0-.283.331,1.122,1.122,0,0,0,.6,1.041s.908.507,2.261,1.265l5.2,2.914,1.565.879",
    transform: "translate(-5.289 -119.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71149",
    "data-name": "Path 71149",
    className: "cls-11",
    d: "M111.01,115.421c-2.763-1.565-7.379-1.388-10.534.359a25.779,25.779,0,0,1,5.141-5.185,10.83,10.83,0,0,1,1.019.495L171.2,147.543c1.765,1,2.664,2.327,2.691,3.673l.006,0c0,.126-.007.255-.018.374a1.648,1.648,0,0,1-.041.28,2.06,2.06,0,0,1-.066.28,2.777,2.777,0,0,1-.095.274,2.605,2.605,0,0,1-.1.25s-.006.006,0,.01a4.657,4.657,0,0,1-.574.891,4.552,4.552,0,0,1-.411.454c-.038.04-.087.085-.126.125-.063.051-.131.111-.19.167-.1.081-.2.164-.3.239-.2.149-.408.291-.612.418l-8.8,5.423-16.1,9.927c-.223.137-.456.269-.7.388a41.36,41.36,0,0,1-9.424-3.611c.166-.025.327-.05.488-.083.411-.087.827-.19,1.237-.32a10.7,10.7,0,0,0,2.318-1.048L163.173,151.6a4.627,4.627,0,0,0,2.5-3.285l0-.006a3.33,3.33,0,0,0-2.007-3.157Zm52.941,38.244-19.471,12c-.221.132-.259.333-.115.487-.178.165-.139.377.1.512a1.059,1.059,0,0,0,.985-.018l19.476-12c.216-.138.25-.327.113-.483.179-.169.142-.38-.1-.519a1.082,1.082,0,0,0-.986.019",
    transform: "translate(-66.591 -73.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71150",
    "data-name": "Path 71150",
    className: "cls-11",
    d: "M15.583,134.5l-13,8.007a4.51,4.51,0,0,0-2.495,4.154s.006.008,0,.013,0,0,.008.009a3.215,3.215,0,0,0,.085.372,4.324,4.324,0,0,0,1.35,2.044c.108.1.211.183.323.266.039.03.075.052.11.08.106.085.224.162.333.235l.027.015c.139.09.275.179.421.259L8.671,153.3l.478-.9a2.953,2.953,0,0,1-.758-1.578,2.379,2.379,0,0,1-.035-.672c-.022-.086-.044-.177-.061-.268a.743.743,0,0,0-.01-.081,2.97,2.97,0,0,1,.748-2.419,6.185,6.185,0,0,1,1.138-1.082c.2-.151.4-.291.6-.411l10.157-6.262-.485-.812a1.268,1.268,0,0,1-1.149-.135,6.077,6.077,0,0,1-.92.092,4.99,4.99,0,0,1-2.477-.558,1.664,1.664,0,0,1-1.04-1.643,1.252,1.252,0,0,1,.134-.876,2.258,2.258,0,0,1,.822-.813Z",
    transform: "translate(-0.048 -89.139)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67426",
    "data-name": "Group 67426",
    transform: "translate(88.97 0.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67425",
    "data-name": "Group 67425",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71151",
    "data-name": "Path 71151",
    className: "cls-22",
    d: "M319.253,33.817a.688.688,0,0,0-.327,0,.9.9,0,0,0-.259.1l-30.976-18a.9.9,0,0,1,.26-.1.806.806,0,0,1,.5.1l30.807,17.9-.007,0M285.342,14.11A.455.455,0,0,0,285,14.1a.919.919,0,0,0-.26.1L264.46,2.415a.893.893,0,0,1,.259-.1.752.752,0,0,1,.482.092l20.156,11.714-.015-.007m33.787,20.075a.669.669,0,0,1,.679-.048L264.493,1.993a.669.669,0,0,0-.679.048Z",
    transform: "translate(-263.814 -1.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71152",
    "data-name": "Path 71152",
    className: "cls-23",
    d: "M319.129,34.186,263.814,2.04a.669.669,0,0,1,.679-.048l55.315,32.146a.669.669,0,0,0-.679.048m0,0a.669.669,0,0,1,.679-.048L264.493,1.993a.669.669,0,0,0-.679.048Z",
    transform: "translate(-263.814 -1.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71153",
    "data-name": "Path 71153",
    className: "cls-22",
    d: "M287.648,15.47a.575.575,0,0,0-.313.006.9.9,0,0,0-.259.1L269,5.077a.91.91,0,0,1,.26-.1.77.77,0,0,1,.523.116l17.862,10.38Z",
    transform: "translate(-267.253 -3.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71154",
    "data-name": "Path 71154",
    className: "cls-22",
    d: "M285.477,14.208a.575.575,0,0,0-.313.006.906.906,0,0,0-.26.1l-18.071-10.5a.906.906,0,0,1,.26-.1.77.77,0,0,1,.523.116l17.862,10.38Zm1.133.66c-2.281-1.313-2.281-1.313-20.142-11.706l-.042-.024a.8.8,0,0,0-.409-.071.871.871,0,0,0-.289.107L286.01,14.959a.905.905,0,0,1,.259-.1c.22-.035.238-.037.341.012",
    transform: "translate(-265.082 -2.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71155",
    "data-name": "Path 71155",
    className: "cls-22",
    d: "M367.131,61.673l-.206.058a.968.968,0,0,0-.268.107L337.892,45.121a.9.9,0,0,1,.26-.1,1.012,1.012,0,0,1,.633.18l2.766,1.607,25.57,14.86s.007.005.01.008",
    transform: "translate(-312.909 -30.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71156",
    "data-name": "Path 71156",
    className: "cls-22",
    d: "M364.959,60.4a2.107,2.107,0,0,0-.215.061.916.916,0,0,0-.26.1L335.72,43.853a.9.9,0,0,1,.26-.1,1.012,1.012,0,0,1,.633.18l2.766,1.607L364.948,60.4s.008.005.011.008m1.217.706c-1.765-1-1.765-1-30.8-17.9l-.039-.023a1.736,1.736,0,0,0-.426-.085.851.851,0,0,0-.3.107l30.976,18a.9.9,0,0,1,.259-.1.705.705,0,0,1,.327,0",
    transform: "translate(-310.737 -29.215)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67428",
    "data-name": "Group 67428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67427",
    "data-name": "Group 67427",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71158",
    "data-name": "Path 71158",
    className: "cls-24",
    d: "M402.152,97.358c.715-.413,1.352.293.7,1.423-2.217,3.818-4.64,7.431-6.958,11.169-1.672,2.7-3.475,6.27-5.665,8.354a1.6,1.6,0,0,1-.3.231.522.522,0,0,1-.589.031c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.312,30.312,0,0,0,2.265-3.419c1.046-1.519,1.938-3.149,2.981-4.67,2.233-3.246,4.285-6.7,6.269-10.113a1.8,1.8,0,0,1,.621-.672",
    transform: "translate(-257.867 -64.446)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67430",
    "data-name": "Group 67430",
    transform: "translate(75.902 0.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67429",
    "data-name": "Group 67429",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71159",
    "data-name": "Path 71159",
    className: "cls-4",
    d: "M288.873,33.612c1.485,1.107,1.766,2.555.859,4.429-1.339,2.235-2.724,4.449-4.187,6.576-1.043,1.521-1.935,3.152-2.981,4.67a30.271,30.271,0,0,1-2.265,3.419c-.093.1-.19.2-.292.3-.753.719-.788,1.748-.389,2.034l.034.022-22.22-12.913a.273.273,0,0,1-.034-.022c-.4-.285-.365-1.315.389-2.034.1-.1.2-.2.291-.3a30.318,30.318,0,0,0,2.264-3.419c1.046-1.519,1.939-3.149,2.982-4.671,1.463-2.127,2.848-4.34,4.187-6.576,1.242-1.715,2.612-2.167,4.311-1.424ZM262.853,18.49c1.87,1.327,2.327,2.84,1.433,4.763-1.339,2.235-2.725,4.449-4.187,6.576-1.043,1.521-1.935,3.152-2.982,4.671a30.293,30.293,0,0,1-2.264,3.419c-.093.1-.191.2-.292.3-.753.719-.787,1.749-.389,2.034a.318.318,0,0,0,.034.022L226,23.879l-.033-.022c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.257,30.257,0,0,0,2.265-3.419c1.046-1.519,1.939-3.149,2.982-4.671,1.463-2.126,2.848-4.34,4.187-6.576,1.276-1.7,2.828-2.049,4.887-1.09ZM293.448,34.42,238.133,2.274a1.794,1.794,0,0,0-.621.672c-1.985,3.418-4.036,6.867-6.269,10.113-1.043,1.521-1.935,3.152-2.981,4.671A30.24,30.24,0,0,1,226,21.149c-.093.1-.19.2-.291.3-.754.72-.788,1.749-.389,2.034l.033.022,55.315,32.146-.033-.022c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.308,30.308,0,0,0,2.265-3.419c1.046-1.519,1.938-3.149,2.981-4.67,2.233-3.246,4.285-6.7,6.269-10.113a1.8,1.8,0,0,1,.621-.672",
    transform: "translate(-225.065 -2.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71160",
    "data-name": "Path 71160",
    className: "cls-23",
    d: "M293.448,34.42a1.8,1.8,0,0,0-.621.672c-1.984,3.418-4.036,6.867-6.269,10.113-1.042,1.521-1.934,3.151-2.981,4.67a30.308,30.308,0,0,1-2.265,3.419q-.14.154-.291.3c-.753.719-.788,1.748-.389,2.034l.033.022L225.35,23.5l-.033-.022c-.4-.286-.365-1.314.389-2.034.1-.1.2-.2.291-.3a30.24,30.24,0,0,0,2.265-3.419c1.046-1.519,1.938-3.149,2.981-4.671,2.233-3.246,4.284-6.695,6.269-10.113a1.794,1.794,0,0,1,.621-.672Zm0,0L238.133,2.274a1.794,1.794,0,0,0-.621.672c-1.985,3.418-4.036,6.867-6.269,10.113-1.043,1.521-1.935,3.152-2.981,4.671A30.24,30.24,0,0,1,226,21.149c-.093.1-.19.2-.291.3-.754.72-.788,1.749-.389,2.034l.033.022,55.315,32.146-.033-.022c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.308,30.308,0,0,0,2.265-3.419c1.046-1.519,1.938-3.149,2.981-4.67,2.233-3.246,4.285-6.7,6.269-10.113a1.8,1.8,0,0,1,.621-.672",
    transform: "translate(-225.065 -2.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71161",
    "data-name": "Path 71161",
    className: "cls-26",
    d: "M265.5,28.9c1.178.818,1.555,1.75,1.119,2.77-1.34,2.235-2.725,4.449-4.187,6.576-1.043,1.521-1.935,3.152-2.981,4.671a30.3,30.3,0,0,1-2.265,3.419c-.093.1-.191.2-.291.3-.753.719-.787,1.749-.39,2.034l.034.022-26-15.11-.033-.022c-.4-.286-.365-1.315.389-2.035.1-.1.2-.2.291-.3a30.334,30.334,0,0,0,2.265-3.419c1.046-1.519,1.937-3.149,2.981-4.67,1.463-2.127,2.848-4.341,4.187-6.576.908-1.138,1.847-2.315,24.882,12.34",
    transform: "translate(-228.506 -11.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71162",
    "data-name": "Path 71162",
    className: "cls-27",
    d: "M263.33,25.674c1.178.818,1.555,1.75,1.119,2.77-1.34,2.235-2.725,4.449-4.187,6.575-1.044,1.521-1.936,3.152-2.982,4.671a30.334,30.334,0,0,1-2.265,3.419c-.093.1-.191.2-.291.3-.753.719-.787,1.748-.39,2.034l.034.022-26-15.11c-.011-.007-.022-.014-.033-.022-.4-.286-.365-1.315.389-2.034.1-.1.2-.2.291-.3a30.379,30.379,0,0,0,2.265-3.42c1.046-1.519,1.938-3.149,2.981-4.67,1.463-2.127,2.848-4.341,4.187-6.576.7-.883,1.682-1.008,2.99-.382Zm.791-1.351L242.23,11.6c-2.028-.945-3.562-.624-4.827,1.011-1.4,2.314-2.784,4.528-4.246,6.655-1.043,1.521-1.935,3.152-2.982,4.671a30.218,30.218,0,0,1-2.265,3.419q-.14.154-.291.3c-.754.719-.788,1.748-.39,2.034l.034.022,28.21,16.394-.033-.022c-.4-.285-.365-1.315.389-2.034.1-.1.2-.2.292-.3a30.305,30.305,0,0,0,2.264-3.419c1.046-1.519,1.938-3.149,2.982-4.671,1.462-2.127,2.847-4.34,4.187-6.576a3.5,3.5,0,0,0-1.433-4.763",
    transform: "translate(-226.333 -8.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71163",
    "data-name": "Path 71163",
    className: "cls-26",
    d: "M353.309,79.312a1.755,1.755,0,0,1,.541,2.434c-1.34,2.235-2.725,4.449-4.188,6.575-1.043,1.521-1.935,3.152-2.981,4.671a30.369,30.369,0,0,1-2.265,3.419c-.093.1-.19.2-.292.3-.753.719-.787,1.749-.389,2.034a.292.292,0,0,0,.034.022l-20-11.624-.034-.022c-.4-.286-.364-1.315.389-2.034.1-.1.2-.2.291-.3a30.3,30.3,0,0,0,2.265-3.419c1.047-1.519,1.938-3.15,2.982-4.671,1.462-2.127,2.847-4.34,4.186-6.576a1.8,1.8,0,0,1,2.413-.718c5.349,2.526,11.934,6.935,17.049,9.908",
    transform: "translate(-290.291 -46.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71164",
    "data-name": "Path 71164",
    className: "cls-27",
    d: "M351.129,76.415a1.756,1.756,0,0,1,.542,2.434c-1.34,2.235-2.725,4.449-4.188,6.575-1.043,1.521-1.935,3.152-2.981,4.671a30.33,30.33,0,0,1-2.265,3.419c-.093.1-.19.2-.291.3-.754.719-.787,1.749-.389,2.034l.034.022-20-11.624-.034-.022c-.4-.286-.364-1.315.389-2.034.1-.1.2-.2.292-.3a30.249,30.249,0,0,0,2.264-3.419c1.047-1.519,1.938-3.15,2.982-4.671,1.462-2.127,2.848-4.34,4.186-6.576a1.806,1.806,0,0,1,2.413-.718Zm.791-1.351-17.05-9.908c-1.653-.724-3.047-.281-4.259,1.352-1.391,2.307-2.776,4.521-4.239,6.648-1.043,1.521-1.935,3.152-2.982,4.671a30.277,30.277,0,0,1-2.264,3.419c-.094.1-.191.2-.291.3-.754.72-.788,1.749-.389,2.034a.245.245,0,0,0,.033.022L342.7,96.513l-.033-.022c-.4-.286-.365-1.315.389-2.034q.152-.144.291-.3a30.272,30.272,0,0,0,2.265-3.419c1.046-1.518,1.938-3.149,2.982-4.67,1.463-2.127,2.848-4.341,4.187-6.576,1.229-2.549-.01-3.869-.859-4.429",
    transform: "translate(-288.112 -43.727)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67432",
    "data-name": "Group 67432",
    transform: "translate(67.285 19.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67431",
    "data-name": "Group 67431",
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71166",
    "data-name": "Path 71166",
    className: "cls-29",
    d: "M263.366,88.795c-3.115.255-5.987-1.58-9.549.478L231.6,76.359c3.562-2.057,6.434-.223,9.549-.477ZM237.92,74.007c-3.115.254-5.987-1.58-9.55.477l-28.21-16.394c3.563-2.057,6.435-.223,9.549-.478Zm26.458,15.376L209.063,57.239c-3.114.254-5.986-1.58-9.549.477l55.315,32.146c3.563-2.058,6.435-.223,9.549-.477",
    transform: "translate(-199.514 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71167",
    "data-name": "Path 71167",
    className: "cls-30",
    d: "M264.378,89.384c-3.114.255-5.986-1.58-9.549.477L199.514,57.715c3.563-2.057,6.435-.223,9.549-.477Zm0,0L209.063,57.239c-3.114.254-5.986-1.58-9.549.477l55.315,32.146c3.563-2.058,6.435-.223,9.549-.477",
    transform: "translate(-199.514 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71168",
    "data-name": "Path 71168",
    className: "cls-31",
    d: "M240.253,75.365c-3.114.254-5.987-1.58-9.549.477l-26-15.11c3.563-2.057,6.435-.223,9.55-.477Z",
    transform: "translate(-202.953 -58.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71169",
    "data-name": "Path 71169",
    className: "cls-27",
    d: "M238.082,74.1c-3.114.254-5.987-1.58-9.55.477l-26-15.11c3.563-2.057,6.435-.223,9.55-.477Zm1.105.642L210.977,58.351c-3.115.254-5.986-1.58-9.55.477l28.211,16.394c3.563-2.057,6.435-.223,9.55-.477",
    transform: "translate(-200.782 -57.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71170",
    "data-name": "Path 71170",
    className: "cls-31",
    d: "M327.483,126.056c-3.114.254-5.986-1.58-9.549.477l-20-11.624c3.563-2.057,6.435-.223,9.55-.477l20,11.625Z",
    transform: "translate(-264.74 -94.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71171",
    "data-name": "Path 71171",
    className: "cls-27",
    d: "M325.3,124.79c-3.114.254-5.986-1.58-9.549.477l-20-11.624c3.563-2.057,6.435-.223,9.549-.477l20,11.625Zm1.109.644-22.22-12.912c-3.115.254-5.987-1.58-9.549.477l22.22,12.913c3.562-2.057,6.434-.223,9.549-.478",
    transform: "translate(-262.562 -93.366)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67434",
    "data-name": "Group 67434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67433",
    "data-name": "Group 67433",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71173",
    "data-name": "Path 71173",
    className: "cls-30",
    d: "M197.285,59.753l.16-.095L252.76,91.8c-.053.031-.107.062-.161.095a1.73,1.73,0,0,0-.2.143c-.745.621-.89,1.823-.434,2.087L196.652,61.983c-.455-.264-.311-1.466.434-2.087a1.709,1.709,0,0,1,.2-.143",
    transform: "translate(-130.16 -39.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71174",
    "data-name": "Path 71174",
    className: "cls-27",
    d: "M251.321,93.76h0L196.006,61.614a.871.871,0,0,1-.384-.715,2.246,2.246,0,0,1,.781-1.8,2,2,0,0,1,.231-.165l.165-.1.132-.076.132.076,55.706,32.372-.391.226-.156.092a1.468,1.468,0,0,0-.168.121A1.718,1.718,0,0,0,251.459,93a.408.408,0,0,0,.124.306h0ZM196.932,59.367l-.026.015a1.449,1.449,0,0,0-.168.12,1.717,1.717,0,0,0-.595,1.353.4.4,0,0,0,.125.307l54.663,31.767a2.268,2.268,0,0,1,.787-1.683l.029-.024Z",
    transform: "translate(-129.646 -38.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71175",
    "data-name": "Path 71175",
    className: "cls-30",
    d: "M198.085,60.362,253.4,92.507a.978.978,0,0,0-.185.083L197.9,60.445a.973.973,0,0,1,.184-.083",
    transform: "translate(-131.159 -40.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71176",
    "data-name": "Path 71176",
    className: "cls-27",
    d: "M252.184,92.333,196.347,59.884l.394-.226a1.222,1.222,0,0,1,.234-.1l.111-.036.1.058,55.826,32.442-.562.179a.7.7,0,0,0-.135.06Z",
    transform: "translate(-130.13 -39.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71177",
    "data-name": "Path 71177",
    className: "cls-24",
    d: "M361.465,153.033c3.563-2.058,6.435-.223,9.549-.477q-.139.154-.291.3c-.753.719-.787,1.748-.388,2.034a.906.906,0,0,1-.2.043c-2.763.248-5.562-1.554-8.7.255l-.13.077-.028.017c-.033.02-.066.036-.1.051-1,.473-1.031-1.267-.08-2.06a1.769,1.769,0,0,1,.2-.143l.161-.095",
    transform: "translate(-238.865 -100.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71178",
    "data-name": "Path 71178",
    className: "cls-30",
    d: "M336.946,195.1c.19-.188.376-.393.56-.607a1.763,1.763,0,0,1-.56.607",
    transform: "translate(-223.313 -128.901)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67436",
    "data-name": "Group 67436",
    transform: "translate(56.578 20.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67435",
    "data-name": "Group 67435",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71179",
    "data-name": "Path 71179",
    className: "cls-4",
    d: "M232.23,92.164a1.723,1.723,0,0,0-.454.4c-1.56,1.893-3.121,3.755-4.547,5.821-.764,1.105-1.477,2.225-2.307,3.261-.6.749-.981,1.563-1.556,2.247a4.234,4.234,0,0,1-.631.619c-.818.64-.821,1.689-.354,1.96l-22.22-12.913c-.467-.271-.464-1.32.353-1.96a4.231,4.231,0,0,0,.631-.618c.574-.685.959-1.5,1.556-2.248.831-1.037,1.544-2.156,2.306-3.261,1.426-2.065,2.987-3.928,4.548-5.821a1.719,1.719,0,0,1,.453-.4ZM206.784,77.377a1.721,1.721,0,0,0-.454.4c-1.56,1.893-3.122,3.756-4.547,5.821-.764,1.106-1.476,2.224-2.306,3.261-.6.748-.982,1.563-1.556,2.248a4.241,4.241,0,0,1-.63.618c-.818.641-.822,1.69-.354,1.961L168.725,75.3c-.467-.271-.464-1.32.354-1.96a4.247,4.247,0,0,0,.631-.619c.574-.685.959-1.5,1.556-2.248.83-1.036,1.543-2.155,2.306-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.716,1.716,0,0,1,.454-.4Zm26.459,15.376L177.928,60.607a1.72,1.72,0,0,0-.454.4c-1.561,1.893-3.121,3.755-4.548,5.821-.763,1.105-1.476,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.268,4.268,0,0,1-.631.618c-.817.641-.821,1.689-.354,1.961l55.315,32.145c-.467-.271-.464-1.32.354-1.96a4.245,4.245,0,0,0,.63-.619c.574-.685.959-1.5,1.556-2.248.831-1.037,1.544-2.156,2.307-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.731,1.731,0,0,1,.454-.4",
    transform: "translate(-167.765 -60.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71180",
    "data-name": "Path 71180",
    className: "cls-23",
    d: "M233.243,92.753a1.731,1.731,0,0,0-.454.4c-1.56,1.893-3.122,3.755-4.547,5.821-.763,1.105-1.476,2.224-2.307,3.261-.6.749-.981,1.563-1.556,2.248a4.245,4.245,0,0,1-.63.619c-.818.64-.821,1.69-.354,1.96L168.079,74.921c-.467-.272-.464-1.32.354-1.961a4.268,4.268,0,0,0,.631-.618c.574-.685.959-1.5,1.556-2.248.83-1.036,1.543-2.156,2.306-3.261,1.427-2.066,2.987-3.928,4.548-5.821a1.72,1.72,0,0,1,.454-.4Zm0,0L177.928,60.607a1.72,1.72,0,0,0-.454.4c-1.561,1.893-3.121,3.755-4.548,5.821-.763,1.105-1.476,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.268,4.268,0,0,1-.631.618c-.817.641-.821,1.689-.354,1.961l55.315,32.145c-.467-.271-.464-1.32.354-1.96a4.245,4.245,0,0,0,.63-.619c.574-.685.959-1.5,1.556-2.248.831-1.037,1.544-2.156,2.307-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.731,1.731,0,0,1,.454-.4",
    transform: "translate(-167.765 -60.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71181",
    "data-name": "Path 71181",
    className: "cls-26",
    d: "M209.118,78.734a1.723,1.723,0,0,0-.454.4c-1.56,1.893-3.121,3.756-4.548,5.821-.763,1.106-1.476,2.224-2.306,3.261-.6.748-.982,1.563-1.556,2.248a4.247,4.247,0,0,1-.631.618c-.818.641-.821,1.689-.354,1.961l-26-15.11c-.467-.271-.464-1.32.354-1.96a4.266,4.266,0,0,0,.631-.618c.574-.685.958-1.5,1.556-2.248.831-1.037,1.543-2.156,2.306-3.262,1.426-2.066,2.987-3.928,4.547-5.821a1.724,1.724,0,0,1,.454-.4Z",
    transform: "translate(-171.205 -62.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71182",
    "data-name": "Path 71182",
    className: "cls-27",
    d: "M206.947,77.473a1.723,1.723,0,0,0-.454.4c-1.56,1.893-3.121,3.756-4.548,5.821-.763,1.106-1.476,2.224-2.306,3.261-.6.748-.982,1.563-1.556,2.248a4.248,4.248,0,0,1-.631.618c-.817.641-.821,1.689-.354,1.961l-26-15.11c-.467-.271-.464-1.32.354-1.96a4.233,4.233,0,0,0,.631-.618c.574-.685.958-1.5,1.556-2.248.83-1.037,1.543-2.156,2.306-3.261,1.426-2.066,2.987-3.928,4.548-5.821a1.723,1.723,0,0,1,.454-.4Zm1.1.642-28.21-16.394a1.724,1.724,0,0,0-.454.4c-1.56,1.893-3.121,3.755-4.547,5.821-.764,1.106-1.476,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.248,4.248,0,0,1-.631.618c-.818.64-.821,1.689-.354,1.96L198.2,92.428c-.467-.271-.464-1.32.354-1.961a4.227,4.227,0,0,0,.63-.618c.575-.685.959-1.5,1.556-2.248.831-1.037,1.543-2.156,2.306-3.261,1.426-2.065,2.987-3.928,4.547-5.821a1.716,1.716,0,0,1,.454-.4",
    transform: "translate(-169.034 -61.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71183",
    "data-name": "Path 71183",
    className: "cls-26",
    d: "M296.347,129.426a1.714,1.714,0,0,0-.454.4c-1.561,1.893-3.122,3.756-4.548,5.821-.763,1.106-1.475,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.249,4.249,0,0,1-.631.618c-.818.64-.821,1.689-.354,1.96l-20-11.625c-.467-.271-.464-1.32.354-1.96a4.267,4.267,0,0,0,.631-.618c.574-.684.959-1.5,1.556-2.247.83-1.037,1.543-2.156,2.306-3.261,1.426-2.066,2.987-3.928,4.548-5.821a1.71,1.71,0,0,1,.454-.4Z",
    transform: "translate(-232.991 -98.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71184",
    "data-name": "Path 71184",
    className: "cls-27",
    d: "M294.168,128.161a1.714,1.714,0,0,0-.454.4c-1.561,1.893-3.122,3.756-4.548,5.821-.763,1.106-1.475,2.225-2.306,3.262-.6.748-.982,1.563-1.556,2.248a4.246,4.246,0,0,1-.631.619c-.818.64-.821,1.689-.354,1.96l-20-11.625c-.467-.271-.464-1.32.354-1.96a4.282,4.282,0,0,0,.631-.618c.574-.684.959-1.5,1.556-2.247.83-1.037,1.543-2.156,2.306-3.261,1.426-2.066,2.987-3.928,4.548-5.821a1.719,1.719,0,0,1,.454-.4Zm1.109.644-22.22-12.912a1.712,1.712,0,0,0-.453.4c-1.561,1.893-3.122,3.755-4.548,5.821-.763,1.105-1.475,2.225-2.306,3.261-.6.749-.982,1.563-1.556,2.248a4.232,4.232,0,0,1-.631.618c-.818.641-.821,1.689-.353,1.96l22.22,12.913c-.467-.271-.464-1.32.354-1.96a4.233,4.233,0,0,0,.631-.619c.575-.684.959-1.5,1.556-2.247.83-1.036,1.543-2.156,2.307-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.724,1.724,0,0,1,.454-.4",
    transform: "translate(-230.813 -97.248)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67438",
    "data-name": "Group 67438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67437",
    "data-name": "Group 67437",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71186",
    "data-name": "Path 71186",
    className: "cls-24",
    d: "M341.948,155.762a.98.98,0,0,1,.185-.083c-.951.793-.923,2.532.08,2.059-1.917,2.332-3.713,4.65-5.445,7.213a44.079,44.079,0,0,1-2.682,3.818c-.184.214-.371.42-.56.607a6.542,6.542,0,0,1-.572.511,1.856,1.856,0,0,1-.185.126.745.745,0,0,1-.538.114c-.593-.141-.665-1.317.223-2.013a4.245,4.245,0,0,0,.63-.619c.574-.685.959-1.5,1.556-2.248.831-1.037,1.544-2.156,2.307-3.261,1.426-2.066,2.987-3.928,4.547-5.821a1.731,1.731,0,0,1,.454-.4",
    transform: "translate(-219.892 -103.177)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67440",
    "data-name": "Group 67440",
    transform: "translate(8.347 32.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67439",
    "data-name": "Group 67439",
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71187",
    "data-name": "Path 71187",
    className: "cls-4",
    d: "M92.806,131.946c-1.05-.666-1.134-1.481-.217-2.076C111.8,118.751,111.8,118.751,113.784,119.8l11.336,6.57c1.05.665,1.136,1.48.22,2.074-19.211,11.121-19.211,11.121-21.2,10.068-3.778-2.19-7.6-4.3-11.336-6.57M61.024,143.224c-1.421-.885-1.724-1.915-.753-2.563,19.854-11.492,19.854-11.492,19.978-11.548a5.131,5.131,0,0,1,4.224.538l17.071,9.895c1.421.885,1.724,1.915.753,2.564C82.446,153.6,82.446,153.6,82.319,153.659a5.136,5.136,0,0,1-4.224-.539c-5.69-3.3-11.433-6.507-17.071-9.9m22.91-16.668c-.615-.424-.409-.922.65-1.57,19.208-11.118,19.208-11.118,20.327-10.573l4.028,2.335c.608.419.4.933-.65,1.573-19.205,11.117-19.205,11.117-20.328,10.57-1.208-.7-2.847-1.588-4.027-2.334m-6.977,29.206c.561.358,1.1.742,1.671,1.093l-28.39-16.5c1.455.736,1.455.736,1.894.976,1.683,1.033,19.487,11.365,24.114,13.993.213.131.5.3.711.436m-2.619-34.52c-.863-.573-.192-1.211.523-1.646,19.216-11.123,19.216-11.123,20.454-10.5l5.068,2.937c.863.573.193,1.211-.521,1.645-19.218,11.124-19.218,11.124-20.457,10.5-1.52-.881-3.574-2.011-5.068-2.937M43.86,136.554c.379.248.744.516,1.13.753L26.673,126.661c.979.474.979.474,1.21.6l15.482,8.985c.149.093.349.214.5.309M30.121,125.313c-1.271-.779-2.534-1.915-1.328-2.9C35.385,118.6,41.526,114,48.57,110.969c1.749-.753,3.883.16,5,.771l21.92,12.705c1.271.78,2.534,1.915,1.328,2.9-6.592,3.816-12.733,8.412-19.777,11.448-1.749.753-3.883-.16-5-.772-7.307-4.235-14.666-8.379-21.92-12.705m24.538-15.478c-1.126-.709-1.28-1.581-.38-2.171,17.684-10.236,17.684-10.236,17.8-10.288a4.248,4.248,0,0,1,3.562.316l12.675,7.347c1.127.71,1.281,1.581.383,2.169C71.01,117.444,71.01,117.444,70.9,117.5a4.252,4.252,0,0,1-3.564-.314c-4.225-2.449-8.495-4.821-12.675-7.347M129.6,127.548,74.281,95.4l-48.636,28.08c-.922.532-1.129,1.924-.628,2.216l55.315,32.146c-.5-.292-.295-1.684.628-2.216L129.6,127.548",
    transform: "translate(-24.751 -95.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71188",
    "data-name": "Path 71188",
    className: "cls-23",
    d: "M129.6,127.548,80.96,155.629c-.923.532-1.13,1.924-.628,2.216L25.017,125.7c-.5-.292-.295-1.684.628-2.216L74.281,95.4Zm0,0L74.281,95.4l-48.636,28.08c-.922.532-1.129,1.924-.628,2.216l55.315,32.146c-.5-.292-.295-1.684.628-2.216L129.6,127.548",
    transform: "translate(-24.751 -95.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71189",
    "data-name": "Path 71189",
    className: "cls-23",
    d: "M47.792,198.066c-.3-.194-.3-.194-15.977-9.294-.516-.277-.516-.277-1.131-.555q9.115,5.308,18.238,10.6l-.133-.081c-.3-.2-.695-.474-1-.672",
    transform: "translate(-28.683 -156.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71190",
    "data-name": "Path 71190",
    className: "cls-31",
    d: "M59.373,143.138c-6.592,3.815-13.53,7.036-19.777,11.448-.241.17-.62.683,1.068,1.764,23.869,13.835,23.869,13.835,24.966,13.325,6.593-3.816,13.53-7.036,19.777-11.447.241-.171.62-.684-1.068-1.766C60.415,142.6,60.415,142.6,59.373,143.138",
    transform: "translate(-34.448 -126.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71191",
    "data-name": "Path 71191",
    className: "cls-27",
    d: "M62.91,167.987c-1.035.385-2.475-.3-3.046-.62-23.87-13.835-23.87-13.835-22.988-14.469,6.592-3.816,12.872-8.172,19.777-11.448a3.957,3.957,0,0,1,3.047.62C83.568,155.9,83.568,155.9,82.687,156.539c-6.592,3.816-13.014,7.927-19.777,11.447m-7.364-27.179c-6.592,3.816-13.707,6.729-19.777,11.448-1.3,1.012.273,2.249,1.328,2.9,24.774,14.36,24.774,14.36,26.92,13.477,6.592-3.817,13.708-6.729,19.777-11.448,1.3-1.013-.273-2.25-1.328-2.9-25.008-14.5-25.008-14.5-26.92-13.476",
    transform: "translate(-31.727 -125.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71192",
    "data-name": "Path 71192",
    className: "cls-31",
    d: "M132.587,103.1c-5.871,3.4-11.9,6.526-17.614,10.2-.457.293-.408.7.123,1.037,13.532,7.844,13.532,7.844,14.463,7.417,5.871-3.4,11.9-6.527,17.613-10.2.457-.293.41-.7-.12-1.036-13.608-7.887-13.608-7.887-14.466-7.418",
    transform: "translate(-84.339 -100.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71193",
    "data-name": "Path 71193",
    className: "cls-27",
    d: "M126.825,120.01a1.991,1.991,0,0,1-1.788-.07c-13.584-7.873-13.584-7.873-12.8-8.384,18.363-10.629,18.363-10.629,19.4-10.123,13.58,7.871,13.58,7.871,12.794,8.382-5.871,3.4-11.659,6.941-17.613,10.2m1.921-19.291c-17.685,10.237-17.685,10.237-17.775,10.3-.442.317-.9,1.158.542,2.065,14.634,8.482,14.634,8.482,16.422,7.568,17.683-10.235,17.683-10.235,17.774-10.3.441-.317.9-1.156-.545-2.063-14.687-8.513-14.687-8.513-16.419-7.57",
    transform: "translate(-81.605 -98.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71194",
    "data-name": "Path 71194",
    className: "cls-31",
    d: "M192.986,138.349c-18.089,10.471-18.089,10.471-18.254,10.79,4.948,2.868,4.948,2.868,5.809,2.4,18.088-10.471,18.088-10.471,18.254-10.79-4.968-2.879-4.968-2.879-5.809-2.4",
    transform: "translate(-124.152 -123.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71195",
    "data-name": "Path 71195",
    className: "cls-27",
    d: "M177.854,149.673a2.951,2.951,0,0,1-1.027.371l-4.782-2.772a1.444,1.444,0,0,1,.641-.594c18.11-10.483,18.11-10.483,18.64-10.567l4.782,2.772a1.447,1.447,0,0,1-.641.594c-5.871,3.4-11.718,6.839-17.613,10.2m11.335-13.834c-19.218,11.125-19.218,11.125-18.136,11.842,6.185,3.586,6.185,3.586,7.911,2.636,19.216-11.123,19.216-11.123,18.134-11.841-6.207-3.6-6.207-3.6-7.909-2.637",
    transform: "translate(-121.464 -121.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71196",
    "data-name": "Path 71196",
    className: "cls-31",
    d: "M221.707,154.287c-18.1,10.476-18.1,10.476-18.3,10.761,3.716,2.154,3.716,2.154,4.57,1.682,18.11-10.483,18.11-10.483,18.3-10.764-3.727-2.16-3.727-2.16-4.566-1.68",
    transform: "translate(-143.153 -134.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71197",
    "data-name": "Path 71197",
    className: "cls-27",
    d: "M205.267,164.839a3.734,3.734,0,0,1-.98.4l-3.59-2.08a2.152,2.152,0,0,1,.692-.566c18.119-10.489,18.119-10.489,18.59-10.6l3.589,2.08a2.035,2.035,0,0,1-.688.568c-5.871,3.4-11.724,6.827-17.613,10.2m12.628-13.085c-19.205,11.117-19.205,11.117-18.263,11.766,5.014,2.906,5.014,2.906,6.742,1.961,19.207-11.119,19.207-11.119,18.262-11.769-5.048-2.926-5.048-2.926-6.742-1.958",
    transform: "translate(-140.448 -132.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71198",
    "data-name": "Path 71198",
    className: "cls-31",
    d: "M246.266,168.932c-18.4,10.653-18.4,10.653-17.653,11.139,12.047,6.982,12.047,6.982,12.964,6.548,18.4-10.653,18.4-10.653,17.652-11.139-12.109-7.019-12.109-7.019-12.963-6.548",
    transform: "translate(-159.708 -144.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71199",
    "data-name": "Path 71199",
    className: "cls-27",
    d: "M238.685,184.859a1.84,1.84,0,0,1-1.629.022c-12.046-6.983-12.046-6.983-11.3-7.513,18.36-10.628,18.36-10.628,19.242-10.218,12.047,6.983,12.047,6.983,11.3,7.513-5.871,3.4-11.671,6.922-17.613,10.2m3.583-18.329c-17.687,10.238-17.687,10.238-17.775,10.3-.447.315-.942,1.132.379,1.971,13.141,7.616,13.141,7.616,14.92,6.7,17.686-10.238,17.686-10.238,17.775-10.3.446-.315.94-1.131-.382-1.97-13.189-7.645-13.189-7.645-14.917-6.7",
    transform: "translate(-156.816 -142.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71200",
    "data-name": "Path 71200",
    className: "cls-31",
    d: "M152.546,197.2c-6.592,3.816-13.429,7.21-19.777,11.448-.31.207-.659.668.489,1.43,18.4,10.665,18.4,10.665,19.539,10.18,6.592-3.817,13.429-7.21,19.777-11.448.31-.207.658-.668-.49-1.43-18.514-10.731-18.514-10.731-19.54-10.179",
    transform: "translate(-96.14 -162.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71201",
    "data-name": "Path 71201",
    className: "cls-27",
    d: "M150.07,218.536a2.86,2.86,0,0,1-2.468-.285c-18.4-10.666-18.4-10.666-17.561-11.325,20.666-11.962,20.666-11.962,22.245-11.163,18.4,10.665,18.4,10.665,17.561,11.325-6.592,3.816-13.064,7.84-19.777,11.448m-1.362-23.7c-6.592,3.816-13.607,6.9-19.777,11.447-1.391,1.025.063,2.134.753,2.563,19.529,11.319,19.529,11.319,21.5,10.333,6.592-3.817,13.606-6.9,19.777-11.448,1.39-1.024-.063-2.134-.753-2.563-19.6-11.358-19.6-11.358-21.5-10.333",
    transform: "translate(-93.412 -161.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71202",
    "data-name": "Path 71202",
    className: "cls-23",
    d: "M127.046,244.1c-.394-.251-.394-.251-24.825-14.429-.623-.342-1.268-.641-1.894-.977l28.39,16.5L128.4,245c-.407-.268-.945-.635-1.356-.9",
    transform: "translate(-74.839 -183.745)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67442",
    "data-name": "Group 67442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67441",
    "data-name": "Group 67441",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71204",
    "data-name": "Path 71204",
    className: "cls-24",
    d: "M189.671,220.935c-1.2.69-1.2-1.444-.006-2.134L238.3,190.72a4.227,4.227,0,0,1-.63.619c-.888.7-.816,1.872-.223,2.013l-47.776,27.584",
    transform: "translate(-125.109 -126.401)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67444",
    "data-name": "Group 67444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67443",
    "data-name": "Group 67443",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71205",
    "data-name": "Path 71205",
    className: "cls-23",
    d: "M162.068,168.168a.385.385,0,0,1-.208-.061l-.325-.208a.386.386,0,0,1,.416-.651l.325.208a.386.386,0,0,1-.208.712",
    transform: "translate(-106.94 -110.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71206",
    "data-name": "Path 71206",
    className: "cls-27",
    d: "M167.764,171.809a.385.385,0,0,1-.208-.061l-.509-.325a.386.386,0,0,1,.416-.651l.509.325a.386.386,0,0,1-.208.712m-1.528-.976a.386.386,0,0,1-.208-.061l-.509-.325a.386.386,0,0,1,.416-.651l.509.325a.386.386,0,0,1-.208.712",
    transform: "translate(-109.58 -112.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71207",
    "data-name": "Path 71207",
    className: "cls-27",
    d: "M178.351,178.574a.384.384,0,0,1-.207-.061l-.509-.325a.386.386,0,1,1,.416-.651l.509.325a.386.386,0,0,1-.208.712m-1.527-.976a.385.385,0,0,1-.208-.061l-.509-.326a.386.386,0,1,1,.416-.651l.509.326a.386.386,0,0,1-.208.712m-1.528-.976a.385.385,0,0,1-.208-.061l-.509-.325a.386.386,0,1,1,.416-.651l.509.325a.386.386,0,0,1-.208.712",
    transform: "translate(-115.585 -116.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71208",
    "data-name": "Path 71208",
    className: "cls-27",
    d: "M188.7,185.188a.387.387,0,0,1-.208-.061l-.326-.208a.386.386,0,0,1,.417-.651l.134.086.14-.076a.386.386,0,1,1,.368.68l-.34.184a.387.387,0,0,1-.184.047",
    transform: "translate(-124.591 -122.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71209",
    "data-name": "Path 71209",
    className: "cls-27",
    d: "M194.122,180.308a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.368.68l-.637.344a.382.382,0,0,1-.183.047m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.387.387,0,0,1,.368.68l-.637.344a.383.383,0,0,1-.183.047",
    transform: "translate(-128.399 -118.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71210",
    "data-name": "Path 71210",
    className: "cls-27",
    d: "M205.441,132.069a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.367.68l-.636.344a.384.384,0,0,1-.183.047m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.368.68l-.636.344a.383.383,0,0,1-.183.047M209.259,130a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.367.68l-.636.344a.384.384,0,0,1-.183.046m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.368.68l-.636.344a.385.385,0,0,1-.183.047m1.908-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,1,1,.368.68l-.636.344a.388.388,0,0,1-.183.046m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,1,1,.368.68l-.636.344a.384.384,0,0,1-.183.047m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.368.68l-.636.344a.387.387,0,0,1-.183.046m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,1,1,.368.68l-.636.344a.384.384,0,0,1-.183.047m1.909-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.367.68l-.636.344a.384.384,0,0,1-.183.047m1.908-1.032a.386.386,0,0,1-.184-.726l.636-.344a.386.386,0,0,1,.368.68l-.636.344a.384.384,0,0,1-.183.047m1.732-1.241a.386.386,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.48l-.449.567a.386.386,0,0,1-.3.147m1.346-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.48l-.449.567a.385.385,0,0,1-.3.147m1.347-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.48l-.449.567a.385.385,0,0,1-.3.147m1.347-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.479l-.449.567a.387.387,0,0,1-.3.147m1.346-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.479l-.449.567a.387.387,0,0,1-.3.147m1.347-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.48l-.449.567a.387.387,0,0,1-.3.147m1.347-1.7a.387.387,0,0,1-.3-.626l.449-.567a.386.386,0,0,1,.606.48l-.449.567a.385.385,0,0,1-.3.147m1.608-1.305a.386.386,0,0,1-.1-.759l.7-.191a.386.386,0,0,1,.2.745l-.7.191a.384.384,0,0,1-.1.014m2.093-.573a.386.386,0,0,1-.1-.759l.7-.191a.386.386,0,1,1,.2.745l-.7.191a.385.385,0,0,1-.1.014m5.023-.042h-.021l-.722-.038a.386.386,0,0,1,.041-.771l.722.038a.386.386,0,0,1-.02.772m-2.167-.114h-.021l-.722-.038a.386.386,0,0,1,.041-.771l.722.038a.386.386,0,0,1-.02.772",
    transform: "translate(-135.901 -71.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71211",
    "data-name": "Path 71211",
    className: "cls-27",
    d: "M316.012,109.376h-.021l-.385-.02a.386.386,0,0,1-.365-.406.391.391,0,0,1,.406-.366l.172.009.1-.141a.386.386,0,0,1,.632.444l-.222.316a.386.386,0,0,1-.316.164",
    transform: "translate(-208.927 -71.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71212",
    "data-name": "Path 71212",
    className: "cls-27",
    d: "M320.146,100.059a.387.387,0,0,1-.316-.608l.459-.653a.386.386,0,0,1,.632.444l-.459.653a.386.386,0,0,1-.316.165m1.375-1.958a.386.386,0,0,1-.316-.608l.458-.653a.386.386,0,0,1,.632.444l-.458.653a.387.387,0,0,1-.317.164",
    transform: "translate(-211.923 -64.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71213",
    "data-name": "Path 71213",
    className: "cls-27",
    d: "M328.3,84.6a.387.387,0,0,1-.316-.608l.459-.653a.386.386,0,0,1,.632.444l-.459.653a.386.386,0,0,1-.316.165m1.375-1.958a.387.387,0,0,1-.316-.608l.459-.653a.386.386,0,1,1,.632.444l-.459.653a.385.385,0,0,1-.316.165m1.376-1.958a.381.381,0,0,1-.222-.07.386.386,0,0,1-.094-.538l.458-.653a.386.386,0,0,1,.632.444l-.458.653a.387.387,0,0,1-.317.164",
    transform: "translate(-217.329 -52.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71214",
    "data-name": "Path 71214",
    className: "cls-27",
    d: "M340.281,75.232a.382.382,0,0,1-.222-.07.587.587,0,0,1,.249-1.142l.353.157a.386.386,0,0,1,.159.575l-.222.316a.386.386,0,0,1-.316.164",
    transform: "translate(-225.181 -49.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71215",
    "data-name": "Path 71215",
    className: "cls-27",
    d: "M332.352,71.28a.385.385,0,0,1-.157-.034l-.565-.252a.386.386,0,0,1,.315-.706l.566.252a.386.386,0,0,1-.158.739m-1.7-.757a.385.385,0,0,1-.157-.034l-.566-.252a.386.386,0,0,1,.315-.706l.566.252a.386.386,0,0,1-.158.739",
    transform: "translate(-218.513 -46.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71216",
    "data-name": "Path 71216",
    className: "cls-27",
    d: "M326.042,68.466a.386.386,0,0,1-.157-.034l-.353-.157a.386.386,0,0,1,.315-.706l.353.157a.386.386,0,0,1-.158.739",
    transform: "translate(-215.596 -44.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71217",
    "data-name": "Path 71217",
    className: "cls-34",
    d: "M159.085,164.963c0,.634-.89,1.148-1.988,1.148s-1.988-.514-1.988-1.148.89-1.148,1.988-1.148,1.988.513,1.988,1.148",
    transform: "translate(-102.799 -108.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71218",
    "data-name": "Path 71218",
    className: "cls-35",
    d: "M318.948,61.787c.608.179.85,1.178.54,2.231s-1.055,1.762-1.663,1.583-.85-1.178-.54-2.232,1.054-1.761,1.663-1.582",
    transform: "translate(-210.193 -40.931)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_71219",
    "data-name": "Path 71219",
    className: "cls-36",
    d: "M345.607,114.448l22.541-6.228-1.025,1.673-19.795,5.555Z",
    transform: "translate(-229.053 -71.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71220",
    "data-name": "Path 71220",
    className: "cls-36",
    d: "M375.3,92.429l1.654-.61.43-12.014-1.489-.865Z",
    transform: "translate(-248.731 -52.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71221",
    "data-name": "Path 71221",
    className: "cls-37",
    d: "M345.607,126.687l1.086,6.405,1.921,1.088-1.286-6.493Z",
    transform: "translate(-229.053 -83.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71222",
    "data-name": "Path 71222",
    className: "cls-36",
    d: "M298.852,147.657l-24.726,2.468,2.282,1.3,24.988-2.339Z",
    transform: "translate(-181.679 -97.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71223",
    "data-name": "Path 71223",
    className: "cls-36",
    d: "M277.411,28.617l-6.644,18.507,2.12,1.131,6.282-18.616Z",
    transform: "translate(-179.452 -18.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71224",
    "data-name": "Path 71224",
    className: "cls-37",
    d: "M241.645,77.609l-14.819-2.995,3.234,1.963,13.7,2.163Z",
    transform: "translate(-150.33 -49.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71225",
    "data-name": "Path 71225",
    className: "cls-36",
    d: "M283.912,60.362l13.136,8.063-1.028,1.644-12.8-7.906Z",
    transform: "translate(-187.708 -40.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71226",
    "data-name": "Path 71226",
    className: "cls-36",
    d: "M196.2,76.219l-13.525,4.427L181.672,82.7l16.563-5.3Z",
    transform: "translate(-120.404 -50.515)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67446",
    "data-name": "Group 67446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67445",
    "data-name": "Group 67445",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71227",
    "data-name": "Path 71227",
    className: "cls-11",
    d: "M26.525,183.087a3.906,3.906,0,0,1-.342-.213,2.773,2.773,0,0,1-.238-.165c-.088-.073-.175-.143-.26-.216a1.874,1.874,0,0,1-.273-.257,3.152,3.152,0,0,1-.741-1.174.8.8,0,0,1-.057-.163,2.367,2.367,0,0,0,.035.672,2.956,2.956,0,0,0,.758,1.578l-.478.9,53.94,30.457,4.69,2.65a.337.337,0,0,0,.035.02c.046.025.089.044.138.072a.478.478,0,0,0,.056.03,12.178,12.178,0,0,0,3.745,1.205,13.67,13.67,0,0,0,7.241-.842c.24-.1.477-.216.7-.331a41.359,41.359,0,0,1-9.424-3.611,4.6,4.6,0,0,1-.485.073c-.1.014-.194.028-.287.037a10.5,10.5,0,0,1-5.769-.825,2.839,2.839,0,0,1-.289-.147.359.359,0,0,1-.035-.023Z",
    transform: "translate(-16.307 -119.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67448",
    "data-name": "Group 67448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67447",
    "data-name": "Group 67447",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71228",
    "data-name": "Path 71228",
    className: "cls-38",
    d: "M273.456,187.7a2.985,2.985,0,0,1,.237.284.113.113,0,0,0,.011.019.483.483,0,0,1,.029.076c1.172,1.825-1.471,2.406-2.98,2.4a16.311,16.311,0,0,0-2.977.015c-1.23.345-.864.768-1.735,1.407-1.292.859-4.443.308-5.639-.979-1.789-2.065.785-2.242,2.222-2.839.938-.375.961-.912,1.613-1.475a4.411,4.411,0,0,1,2.11-.76c1.784-.317,5.509.155,7.1,1.841.007,0,.008,0,.012.007m-12.3,2.9a4.584,4.584,0,0,0,4.715.684c.79-.532.793-1.086,1.958-1.248.759-.089,1.642.042,2.415.009,1.142,0,3.145-.242,3.105-1.234a1.161,1.161,0,0,0-.232-.611.344.344,0,0,0-.026-.063s0-.007-.006-.01a1.051,1.051,0,0,0-.23-.256c-1.4-1.388-4.708-1.766-6.3-1.5a4.215,4.215,0,0,0-1.9.635,8.512,8.512,0,0,1-1.466,1.227c-1.11.621-2.839.662-2.527,1.619a2.2,2.2,0,0,0,.5.744",
    transform: "translate(-172.178 -123.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71229",
    "data-name": "Path 71229",
    className: "cls-39",
    d: "M274.487,188.927c-1.4-1.388-4.708-1.766-6.3-1.5a4.219,4.219,0,0,0-1.9.635,8.5,8.5,0,0,1-1.466,1.228c-1.11.621-2.84.662-2.527,1.619.278-.55,1.6-.671,2.51-1.179a8.538,8.538,0,0,0,1.466-1.227,4.207,4.207,0,0,1,1.9-.636c1.768-.3,5.647.2,6.693,1.987l.12.01a1.163,1.163,0,0,0-.233-.611.3.3,0,0,0-.026-.063s0-.007-.005-.01a1.862,1.862,0,0,0-.23-.256",
    transform: "translate(-173.81 -124.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71230",
    "data-name": "Path 71230",
    className: "cls-40",
    d: "M262.365,191.776a2.2,2.2,0,0,0,.5.744,4.584,4.584,0,0,0,4.715.684c.789-.532.793-1.086,1.958-1.248.759-.089,1.642.042,2.415.009,1.142,0,3.144-.242,3.105-1.234l-.12-.01c-1.045-1.784-4.924-2.284-6.693-1.987a4.211,4.211,0,0,0-1.9.636,8.535,8.535,0,0,1-1.466,1.227c-.91.507-2.232.628-2.51,1.179",
    transform: "translate(-173.884 -125.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67450",
    "data-name": "Group 67450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67449",
    "data-name": "Group 67449",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71231",
    "data-name": "Path 71231",
    className: "cls-41",
    d: "M314.922,2.372l.063-.034c-.021.011-.043.022-.063.034",
    transform: "translate(-208.716 -1.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71232",
    "data-name": "Path 71232",
    className: "cls-41",
    d: "M315.671,1.965c-.017.007-.03.016-.047.023.033-.016.066-.031.1-.045l-.053.022",
    transform: "translate(-209.181 -1.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71233",
    "data-name": "Path 71233",
    className: "cls-42",
    d: "M319.506.086a6.626,6.626,0,0,0-3.428.548,3.43,3.43,0,0,1,2.4-.006c2.854.962,6.764,4.108,5.756,9.331-.726,3.783-4.939,9.484-5.526,9.328.112.1,1.075-.287,1.168-.318.981-.329,4.8-5.544,5.526-9.327,1.008-5.222-3.044-8.592-5.9-9.554",
    transform: "translate(-209.482 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71234",
    "data-name": "Path 71234",
    className: "cls-42",
    d: "M319.409,17.693a2.609,2.609,0,0,1-.692-.137c-1.868-.632-3.464-3.187-3.567-5.715a3.567,3.567,0,0,1,1.287-3.252c-1.489-.044-2.539,1.394-2.455,3.57.1,2.527,1.7,5.083,3.567,5.715a2.034,2.034,0,0,0,1.859-.181",
    transform: "translate(-208.091 -5.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71235",
    "data-name": "Path 71235",
    className: "cls-35",
    d: "M319.345,10.771c1.008-5.223-2.9-8.368-5.756-9.331a3.428,3.428,0,0,0-2.4.006l-.053.022c-.034.014-.067.03-.1.046-.059.027-.117.056-.174.087l-.063.035c-1.351.777-2.191,2.609-2.092,5.046.151,3.857,3.7,13.046,5.114,13.417.588.156,4.8-5.544,5.526-9.327M314.05,13c-1.869-.632-3.464-3.187-3.567-5.715-.084-2.176.966-3.614,2.455-3.57a2.582,2.582,0,0,1,.749.136,5.563,5.563,0,0,1,3.566,5.714,4.021,4.021,0,0,1-1.344,3.253A2.034,2.034,0,0,1,314.05,13",
    transform: "translate(-204.59 -0.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71236",
    "data-name": "Path 71236",
    className: "cls-41",
    d: "M166.519,84.622l-.06-.04.06.04",
    transform: "translate(-110.322 -56.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71237",
    "data-name": "Path 71237",
    className: "cls-41",
    d: "M165.732,84.154c.016.008.029.018.044.027-.032-.018-.063-.036-.1-.053l.052.026",
    transform: "translate(-109.805 -55.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71238",
    "data-name": "Path 71238",
    className: "cls-43",
    d: "M142.412,81.568a6.628,6.628,0,0,1,3.377.807,3.428,3.428,0,0,0-2.4-.189c-2.92.742-7.058,3.581-6.451,8.865.436,3.828,4.2,9.832,4.8,9.721-.119.09-1.05-.368-1.14-.406-.953-.4-4.364-5.894-4.8-9.721-.607-5.284,3.69-8.335,6.609-9.078",
    transform: "translate(-89.966 -54.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71239",
    "data-name": "Path 71239",
    className: "cls-43",
    d: "M149,99.2a2.61,2.61,0,0,0,.7-.083c1.91-.488,3.7-2.914,3.991-5.426a3.565,3.565,0,0,0-1.036-3.341c1.488.069,2.426,1.584,2.176,3.747-.3,2.512-2.081,4.939-3.992,5.426A2.034,2.034,0,0,1,149,99.2",
    transform: "translate(-98.748 -59.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71240",
    "data-name": "Path 71240",
    className: "cls-34",
    d: "M143.98,101.825c1.439-.262,5.677-9.154,6.122-12.989.284-2.422-.413-4.312-1.7-5.19l-.06-.04c-.055-.035-.11-.068-.167-.1-.032-.018-.063-.036-.1-.053l-.051-.026a3.432,3.432,0,0,0-2.4-.189c-2.92.742-7.058,3.581-6.451,8.865.436,3.827,4.2,9.832,4.8,9.721M142.451,94.4a4.02,4.02,0,0,1-1.092-3.346,5.563,5.563,0,0,1,3.991-5.426,2.59,2.59,0,0,1,.757-.079c1.488.069,2.426,1.584,2.176,3.747-.3,2.512-2.081,4.939-3.992,5.426a2.034,2.034,0,0,1-1.84-.323",
    transform: "translate(-92.203 -55.082)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67452",
    "data-name": "Group 67452",
    transform: "translate(-4480.64 -23134.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63833",
    "data-name": "Group 63833",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63318",
    "data-name": "Group 63318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63317",
    "data-name": "Group 63317",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63310",
    "data-name": "Group 63310",
    className: "cls-45",
    transform: "translate(1.766 9.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63309",
    "data-name": "Group 63309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63308",
    "data-name": "Group 63308",
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62271",
    "data-name": "Path 62271",
    className: "cls-47",
    d: "M50.382,235.976l2.161-1.257-.381-.22h-1.2l-8.964,5.175.381.22h1.2l.936-.541,2.378,1.373-2.524,1.458c-.29.173.037.6.909,1.107a9.044,9.044,0,0,0,3.642,1.188.982.982,0,0,0,.4-.065l.016.009-.547.316c-.29.173.037.6.909,1.107a9.044,9.044,0,0,0,3.642,1.188.98.98,0,0,0,.4-.065L53.8,247h.716v.2l4.516,2.607h.615v-8.478Z",
    transform: "translate(-41.994 -234.499)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63313",
    "data-name": "Group 63313",
    className: "cls-48",
    transform: "translate(33.257 25.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63312",
    "data-name": "Group 63312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63311",
    "data-name": "Group 63311",
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62272",
    "data-name": "Path 62272",
    className: "cls-47",
    d: "M799.248,596.393l-.172.1.346.2-8.354,4.823-.272.08h.752l8.354-4.823Z",
    transform: "translate(-790.795 -596.393)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63316",
    "data-name": "Group 63316",
    className: "cls-45",
    transform: "translate(19.717 20.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63315",
    "data-name": "Group 63315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63314",
    "data-name": "Group 63314",
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62273",
    "data-name": "Path 62273",
    className: "cls-47",
    d: "M491.357,499.115h0l-.2-.114a.08.08,0,0,0-.036-.006h-1.192a1.092,1.092,0,0,0-.311.078l-3.7-2.134.465-.269-2-1.157-1.16-.2-8.793,5.909a8.962,8.962,0,0,0-3.52-1.119.886.886,0,0,0-.436.081l-1.551.9c-.29.173.037.6.909,1.107a9.044,9.044,0,0,0,3.642,1.188,1.141,1.141,0,0,0,.4-.056l-.563.325,2.679,1.547h2.494l.16-.092.241.139h.085l.192.111a.165.165,0,0,0,.094.025h1.166a.963.963,0,0,0,.4-.114l.227-.109,1.585-.466,8.354-4.823-.472-.272.668-.329c.139-.068.2-.126.173-.146",
    transform: "translate(-468.82 -495.314)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62274",
    "data-name": "Path 62274",
    className: "cls-51",
    d: "M417.288,432.838l1.844,1.064v-1.091l-1.844-1.065Z",
    transform: "translate(-399.739 -413.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62275",
    "data-name": "Path 62275",
    className: "cls-52",
    d: "M417.288,422.719l1.844,1.065.687-.4-1.844-1.065Z",
    transform: "translate(-399.739 -404.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62276",
    "data-name": "Path 62276",
    className: "cls-53",
    d: "M0,137.966l.381.22,8.964-5.175-.381-.22Z",
    transform: "translate(0 -127.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62277",
    "data-name": "Path 62277",
    className: "cls-54",
    d: "M0,257.293l.381.22v-1.449L0,255.844Z",
    transform: "translate(0 -245.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62278",
    "data-name": "Path 62278",
    className: "cls-52",
    d: "M18.025,138.024v1.449l-8.964,5.175V143.2Z",
    transform: "translate(-8.681 -132.219)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63320",
    "data-name": "Group 63320",
    transform: "translate(2.528 13.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63319",
    "data-name": "Group 63319",
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23255",
    "data-name": "Rectangle 23255",
    className: "cls-56",
    width: 2.696,
    height: 2.597,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.781, 0.451)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63322",
    "data-name": "Group 63322",
    transform: "translate(2.994 12.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63321",
    "data-name": "Group 63321",
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23256",
    "data-name": "Rectangle 23256",
    className: "cls-58",
    width: 9.079,
    height: 9.176,
    transform: "translate(-3.152 1.704) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63324",
    "data-name": "Group 63324",
    transform: "translate(3.881 12.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63323",
    "data-name": "Group 63323",
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23257",
    "data-name": "Rectangle 23257",
    className: "cls-60",
    width: 7.833,
    height: 8.105,
    transform: "translate(-2.687 1.552) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63326",
    "data-name": "Group 63326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63325",
    "data-name": "Group 63325",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62282",
    "data-name": "Path 62282",
    className: "cls-61",
    d: "M74.7,325.69c-.8-1.392-2.107-2.144-2.91-1.68s-.8,1.969,0,3.361,2.107,2.144,2.91,1.68.8-1.969,0-3.361",
    transform: "translate(-68.197 -310.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62283",
    "data-name": "Path 62283",
    className: "cls-19",
    d: "M91.673,348.618c-.5-.872-1.32-1.343-1.823-1.053s-.5,1.233,0,2.105,1.32,1.343,1.823,1.053.5-1.233,0-2.105",
    transform: "translate(-85.71 -332.866)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63328",
    "data-name": "Group 63328",
    transform: "translate(3.924 14.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63327",
    "data-name": "Group 63327",
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23259",
    "data-name": "Rectangle 23259",
    className: "cls-63",
    width: 3.692,
    height: 3.918,
    transform: "translate(-1.45 0.773) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63345",
    "data-name": "Group 63345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63344",
    "data-name": "Group 63344",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63331",
    "data-name": "Group 63331",
    className: "cls-64",
    transform: "translate(5.316 17.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63330",
    "data-name": "Group 63330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63329",
    "data-name": "Group 63329",
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62285",
    "data-name": "Path 62285",
    className: "cls-66",
    d: "M126.411,411.837a.278.278,0,0,0,.081.186.538.538,0,0,0,.49.13.558.558,0,0,0,.1-.09,1.077,1.077,0,0,1-.671-.227",
    transform: "translate(-126.411 -411.837)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63334",
    "data-name": "Group 63334",
    className: "cls-67",
    transform: "translate(3.924 14.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63333",
    "data-name": "Group 63333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63332",
    "data-name": "Group 63332",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62286",
    "data-name": "Path 62286",
    className: "cls-66",
    d: "M94.077,354.289c-.019-.03-.038-.06-.056-.091a1.614,1.614,0,0,1-.137-1.729.565.565,0,0,0-.243.073.988.988,0,0,0-.29,1.1,2.076,2.076,0,0,0,.726.651",
    transform: "translate(-93.311 -352.469)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62287",
    "data-name": "Path 62287",
    className: "cls-69",
    d: "M102.539,352.426a1.614,1.614,0,0,0,.137,1.73,1.707,1.707,0,0,0,1.353.994,1.614,1.614,0,0,0-.137-1.729,1.707,1.707,0,0,0-1.353-.994",
    transform: "translate(-98.042 -337.603)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63337",
    "data-name": "Group 63337",
    className: "cls-70",
    transform: "translate(6.115 16.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63336",
    "data-name": "Group 63336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63335",
    "data-name": "Group 63335",
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62288",
    "data-name": "Path 62288",
    className: "cls-47",
    d: "M145.428,394.086H145.4l.058.208a1.915,1.915,0,0,0-.03-.208",
    transform: "translate(-145.4 -394.086)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63340",
    "data-name": "Group 63340",
    className: "cls-70",
    transform: "translate(4.772 16.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63339",
    "data-name": "Group 63339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63338",
    "data-name": "Group 63338",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62289",
    "data-name": "Path 62289",
    className: "cls-47",
    d: "M113.791,391.237l-.087-.312h-.225l.078.282a.291.291,0,0,0,.028.065c.049.085.128.13.177.1s.045-.076.028-.137",
    transform: "translate(-113.48 -390.925)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63343",
    "data-name": "Group 63343",
    className: "cls-70",
    transform: "translate(4.304 14.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63342",
    "data-name": "Group 63342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63341",
    "data-name": "Group 63341",
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62290",
    "data-name": "Path 62290",
    className: "cls-47",
    d: "M103.951,353.781a1.859,1.859,0,0,1,.158.119,2.662,2.662,0,0,0-.218-.48,1.707,1.707,0,0,0-1.353-.994,1.614,1.614,0,0,0,.137,1.73c.018.031.037.061.056.091a.768.768,0,0,1,.277-.573l.349,1.25a1.076,1.076,0,0,0,.671.226.82.82,0,0,0,.181-.443Z",
    transform: "translate(-102.346 -352.424)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63347",
    "data-name": "Group 63347",
    transform: "translate(4.661 16.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63346",
    "data-name": "Group 63346",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23266",
    "data-name": "Rectangle 23266",
    className: "cls-75",
    width: 0.514,
    height: 0.525,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.183, 0.099)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63349",
    "data-name": "Group 63349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63348",
    "data-name": "Group 63348",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62292",
    "data-name": "Path 62292",
    className: "cls-61",
    d: "M111.043,387.781c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-106.168 -371.366)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63351",
    "data-name": "Group 63351",
    transform: "translate(4.431 15.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63350",
    "data-name": "Group 63350",
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23268",
    "data-name": "Rectangle 23268",
    className: "cls-77",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63353",
    "data-name": "Group 63353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63352",
    "data-name": "Group 63352",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62294",
    "data-name": "Path 62294",
    className: "cls-78",
    d: "M105.566,369.352c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-100.922 -353.713)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63355",
    "data-name": "Group 63355",
    transform: "translate(5.217 16.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63354",
    "data-name": "Group 63354",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23270",
    "data-name": "Rectangle 23270",
    className: "cls-80",
    width: 0.514,
    height: 0.525,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.183, 0.099)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63357",
    "data-name": "Group 63357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63356",
    "data-name": "Group 63356",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62296",
    "data-name": "Path 62296",
    className: "cls-78",
    d: "M124.264,401.739c-.049-.084-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-118.833 -384.737)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63359",
    "data-name": "Group 63359",
    transform: "translate(4.544 15.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63358",
    "data-name": "Group 63358",
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23272",
    "data-name": "Rectangle 23272",
    className: "cls-82",
    width: 2.087,
    height: 2.131,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.745, 0.401)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63361",
    "data-name": "Group 63361",
    transform: "translate(4.897 15.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63360",
    "data-name": "Group 63360",
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23273",
    "data-name": "Rectangle 23273",
    className: "cls-84",
    width: 1.008,
    height: 0.765,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63363",
    "data-name": "Group 63363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63362",
    "data-name": "Group 63362",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62299",
    "data-name": "Path 62299",
    className: "cls-61",
    d: "M108.916,371.916c-.2-.343-.52-.529-.718-.415s-.2.486,0,.829.52.529.718.415.2-.486,0-.829",
    transform: "translate(-103.505 -355.845)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63365",
    "data-name": "Group 63365",
    transform: "translate(4.661 14.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63364",
    "data-name": "Group 63364",
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23275",
    "data-name": "Rectangle 23275",
    className: "cls-86",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63367",
    "data-name": "Group 63367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63366",
    "data-name": "Group 63366",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62301",
    "data-name": "Path 62301",
    className: "cls-78",
    d: "M111.043,357.247c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-106.168 -342.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62302",
    "data-name": "Path 62302",
    className: "cls-51",
    d: "M124.269,359.331l.074-.043a2.148,2.148,0,0,0-.269-.247.184.184,0,0,0,.018.187c.049.085.128.13.177.1",
    transform: "translate(-118.839 -343.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62303",
    "data-name": "Path 62303",
    className: "cls-78",
    d: "M124.269,359.331a.09.09,0,0,0,.036-.083,2.1,2.1,0,0,0-.231-.206.184.184,0,0,0,.018.187c.049.085.128.13.177.1",
    transform: "translate(-118.839 -343.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62304",
    "data-name": "Path 62304",
    className: "cls-78",
    d: "M137.354,373.549q-.033-.058-.069-.112a.209.209,0,0,0,.028.169.214.214,0,0,0,.127.108c-.027-.055-.055-.11-.087-.165",
    transform: "translate(-131.504 -357.732)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63369",
    "data-name": "Group 63369",
    transform: "translate(6.003 16.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63368",
    "data-name": "Group 63368",
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23277",
    "data-name": "Rectangle 23277",
    className: "cls-88",
    width: 0.329,
    height: 0.391,
    transform: "translate(-0.163 0.087) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63371",
    "data-name": "Group 63371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63370",
    "data-name": "Group 63370",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62306",
    "data-name": "Path 62306",
    className: "cls-61",
    d: "M142.859,390.849a.08.08,0,0,0-.073,0c-.049.028-.049.12,0,.2a.211.211,0,0,0,.13.109,2.03,2.03,0,0,0-.057-.311",
    transform: "translate(-136.746 -374.402)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63373",
    "data-name": "Group 63373",
    transform: "translate(5.773 16.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63372",
    "data-name": "Group 63372",
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23279",
    "data-name": "Rectangle 23279",
    className: "cls-90",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63375",
    "data-name": "Group 63375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63374",
    "data-name": "Group 63374",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62308",
    "data-name": "Path 62308",
    className: "cls-78",
    d: "M137.486,403.049c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-131.499 -385.992)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63377",
    "data-name": "Group 63377",
    transform: "translate(7.418 15.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63376",
    "data-name": "Group 63376",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23281",
    "data-name": "Rectangle 23281",
    className: "cls-92",
    width: 9.079,
    height: 9.176,
    transform: "translate(-3.152 1.704) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63379",
    "data-name": "Group 63379",
    transform: "translate(8.305 15.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63378",
    "data-name": "Group 63378",
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23282",
    "data-name": "Rectangle 23282",
    className: "cls-94",
    width: 7.833,
    height: 8.105,
    transform: "translate(-2.687 1.552) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63381",
    "data-name": "Group 63381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63380",
    "data-name": "Group 63380",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62311",
    "data-name": "Path 62311",
    className: "cls-61",
    d: "M179.9,386.424c-.8-1.392-2.107-2.144-2.91-1.68s-.8,1.969,0,3.361,2.107,2.144,2.91,1.68.8-1.969,0-3.361",
    transform: "translate(-168.968 -368.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62312",
    "data-name": "Path 62312",
    className: "cls-19",
    d: "M196.868,409.352c-.5-.872-1.32-1.343-1.823-1.053s-.5,1.233,0,2.105,1.32,1.343,1.823,1.053.5-1.233,0-2.105",
    transform: "translate(-186.481 -391.046)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63383",
    "data-name": "Group 63383",
    transform: "translate(8.348 17.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63382",
    "data-name": "Group 63382",
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23284",
    "data-name": "Rectangle 23284",
    className: "cls-96",
    width: 3.692,
    height: 3.918,
    transform: "translate(-1.45 0.773) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63400",
    "data-name": "Group 63400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63399",
    "data-name": "Group 63399",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63386",
    "data-name": "Group 63386",
    className: "cls-64",
    transform: "translate(9.74 19.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63385",
    "data-name": "Group 63385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63384",
    "data-name": "Group 63384",
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62314",
    "data-name": "Path 62314",
    className: "cls-66",
    d: "M231.606,472.571a.278.278,0,0,0,.081.186.537.537,0,0,0,.49.13.558.558,0,0,0,.1-.09,1.078,1.078,0,0,1-.671-.227",
    transform: "translate(-231.606 -472.571)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63389",
    "data-name": "Group 63389",
    className: "cls-67",
    transform: "translate(8.348 17.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63388",
    "data-name": "Group 63388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63387",
    "data-name": "Group 63387",
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62315",
    "data-name": "Path 62315",
    className: "cls-66",
    d: "M199.272,415.023c-.019-.03-.038-.06-.056-.091a1.614,1.614,0,0,1-.137-1.73.567.567,0,0,0-.243.073.988.988,0,0,0-.29,1.1,2.076,2.076,0,0,0,.726.651",
    transform: "translate(-198.506 -413.203)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62316",
    "data-name": "Path 62316",
    className: "cls-69",
    d: "M207.734,413.161a1.614,1.614,0,0,0,.137,1.729,1.707,1.707,0,0,0,1.353.994,1.614,1.614,0,0,0-.137-1.729,1.706,1.706,0,0,0-1.353-.994",
    transform: "translate(-198.813 -395.784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63392",
    "data-name": "Group 63392",
    className: "cls-70",
    transform: "translate(10.539 19.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63391",
    "data-name": "Group 63391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63390",
    "data-name": "Group 63390",
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62317",
    "data-name": "Path 62317",
    className: "cls-47",
    d: "M250.623,454.821H250.6l.058.208a1.907,1.907,0,0,0-.03-.208",
    transform: "translate(-250.595 -454.821)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63395",
    "data-name": "Group 63395",
    className: "cls-70",
    transform: "translate(9.197 18.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63394",
    "data-name": "Group 63394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63393",
    "data-name": "Group 63393",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62318",
    "data-name": "Path 62318",
    className: "cls-47",
    d: "M218.986,451.971l-.087-.312h-.225l.078.282a.29.29,0,0,0,.028.065c.049.085.128.13.177.1s.045-.076.028-.137",
    transform: "translate(-218.675 -451.659)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63398",
    "data-name": "Group 63398",
    className: "cls-70",
    transform: "translate(8.728 17.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63397",
    "data-name": "Group 63397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63396",
    "data-name": "Group 63396",
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62319",
    "data-name": "Path 62319",
    className: "cls-47",
    d: "M209.146,414.516a1.877,1.877,0,0,1,.158.119,2.662,2.662,0,0,0-.218-.48,1.707,1.707,0,0,0-1.353-.994,1.614,1.614,0,0,0,.137,1.729c.018.031.037.061.056.091a.768.768,0,0,1,.277-.573l.349,1.25a1.075,1.075,0,0,0,.671.226.819.819,0,0,0,.181-.443Z",
    transform: "translate(-207.541 -413.159)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63402",
    "data-name": "Group 63402",
    transform: "translate(9.085 18.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63401",
    "data-name": "Group 63401",
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23291",
    "data-name": "Rectangle 23291",
    className: "cls-99",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63404",
    "data-name": "Group 63404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63403",
    "data-name": "Group 63403",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62321",
    "data-name": "Path 62321",
    className: "cls-61",
    d: "M216.238,448.516c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-206.939 -429.547)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63406",
    "data-name": "Group 63406",
    transform: "translate(8.855 18.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63405",
    "data-name": "Group 63405",
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23293",
    "data-name": "Rectangle 23293",
    className: "cls-101",
    width: 0.514,
    height: 0.525,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.183, 0.099)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63408",
    "data-name": "Group 63408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63407",
    "data-name": "Group 63407",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62323",
    "data-name": "Path 62323",
    className: "cls-78",
    d: "M210.761,430.086c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-201.693 -411.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63410",
    "data-name": "Group 63410",
    transform: "translate(9.641 19.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63409",
    "data-name": "Group 63409",
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23295",
    "data-name": "Rectangle 23295",
    className: "cls-103",
    width: 0.514,
    height: 0.525,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.183, 0.099)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63412",
    "data-name": "Group 63412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63411",
    "data-name": "Group 63411",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62325",
    "data-name": "Path 62325",
    className: "cls-78",
    d: "M229.459,462.473c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-219.604 -442.917)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63414",
    "data-name": "Group 63414",
    transform: "translate(8.968 17.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63413",
    "data-name": "Group 63413",
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23297",
    "data-name": "Rectangle 23297",
    className: "cls-105",
    width: 2.087,
    height: 2.131,
    transform: "translate(-0.745 0.401) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63416",
    "data-name": "Group 63416",
    transform: "translate(9.321 17.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63415",
    "data-name": "Group 63415",
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23298",
    "data-name": "Rectangle 23298",
    className: "cls-107",
    width: 1.008,
    height: 0.765
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63418",
    "data-name": "Group 63418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63417",
    "data-name": "Group 63417",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62328",
    "data-name": "Path 62328",
    className: "cls-61",
    d: "M214.111,432.651c-.2-.344-.52-.529-.718-.415s-.2.486,0,.829.52.529.718.415.2-.486,0-.829",
    transform: "translate(-204.276 -414.026)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63420",
    "data-name": "Group 63420",
    transform: "translate(9.085 17.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63419",
    "data-name": "Group 63419",
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23300",
    "data-name": "Rectangle 23300",
    className: "cls-109",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63422",
    "data-name": "Group 63422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63421",
    "data-name": "Group 63421",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62330",
    "data-name": "Path 62330",
    className: "cls-78",
    d: "M216.238,417.981c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-206.939 -400.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62331",
    "data-name": "Path 62331",
    className: "cls-51",
    d: "M229.464,420.064l.074-.043a2.142,2.142,0,0,0-.269-.247.184.184,0,0,0,.018.187c.049.085.128.13.177.1",
    transform: "translate(-219.61 -402.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62332",
    "data-name": "Path 62332",
    className: "cls-78",
    d: "M229.464,420.064a.089.089,0,0,0,.036-.083,2.089,2.089,0,0,0-.231-.206.184.184,0,0,0,.018.187c.049.085.128.13.177.1",
    transform: "translate(-219.61 -402.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62333",
    "data-name": "Path 62333",
    className: "cls-78",
    d: "M242.549,434.283c-.022-.038-.045-.076-.069-.112a.208.208,0,0,0,.028.169.213.213,0,0,0,.127.108c-.027-.055-.055-.11-.087-.164",
    transform: "translate(-232.275 -415.912)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63424",
    "data-name": "Group 63424",
    transform: "translate(10.427 18.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63423",
    "data-name": "Group 63423",
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23302",
    "data-name": "Rectangle 23302",
    className: "cls-111",
    width: 0.329,
    height: 0.391,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.163, 0.087)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63426",
    "data-name": "Group 63426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63425",
    "data-name": "Group 63425",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62335",
    "data-name": "Path 62335",
    className: "cls-61",
    d: "M248.054,451.584a.081.081,0,0,0-.073,0c-.049.028-.049.12,0,.2a.211.211,0,0,0,.13.109,2.032,2.032,0,0,0-.057-.311",
    transform: "translate(-237.517 -432.583)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63428",
    "data-name": "Group 63428",
    transform: "translate(10.197 19.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63427",
    "data-name": "Group 63427",
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23304",
    "data-name": "Rectangle 23304",
    className: "cls-113",
    width: 0.514,
    height: 0.525,
    transform: "translate(-0.183 0.099) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63430",
    "data-name": "Group 63430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63429",
    "data-name": "Group 63429",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62337",
    "data-name": "Path 62337",
    className: "cls-78",
    d: "M242.681,463.783c-.049-.085-.128-.13-.177-.1s-.049.12,0,.2.128.13.177.1.049-.12,0-.2",
    transform: "translate(-232.27 -444.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62338",
    "data-name": "Path 62338",
    className: "cls-54",
    d: "M61.852,288.7a1.736,1.736,0,0,0-.647-.741L58.683,286.5a.869.869,0,0,0-.742-.116l-.284.111-.284-.439a2.292,2.292,0,0,0-.742-.741l-2.522-1.456a.534.534,0,0,0-.647-.006l-.686.632a.636.636,0,0,0-.17.478v1.491l.316.182c0-1.61,1.13-2.262,2.524-1.457a5.1,5.1,0,0,1,1.729,1.79l.966.558a1.809,1.809,0,0,1,1.729.206,5.578,5.578,0,0,1,2.524,4.371l.316.182V290.8a1.6,1.6,0,0,0-.17-.674Z",
    transform: "translate(-50.393 -271.814)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63432",
    "data-name": "Group 63432",
    transform: "translate(7.264 13.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63431",
    "data-name": "Group 63431",
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23306",
    "data-name": "Rectangle 23306",
    className: "cls-115",
    width: 9.68,
    height: 9.692,
    transform: "translate(-3.065 1.75) rotate(-29.73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63437",
    "data-name": "Group 63437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63436",
    "data-name": "Group 63436",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63435",
    "data-name": "Group 63435",
    className: "cls-116",
    transform: "translate(7.642 13.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63434",
    "data-name": "Group 63434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63433",
    "data-name": "Group 63433",
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62340",
    "data-name": "Path 62340",
    className: "cls-52",
    d: "M188.236,321.349l-.686-1.424a1.737,1.737,0,0,0-.647-.741l-2.523-1.456a.869.869,0,0,0-.742-.116l-.284.111-1.654.955.162-.041a1.039,1.039,0,0,1,.57.216l2.522,1.456a4.16,4.16,0,0,1,.817.643l1.173,1.142a1.427,1.427,0,0,1,.377.555l.557,1.169.527-.3v-1.491a1.6,1.6,0,0,0-.17-.674",
    transform: "translate(-181.7 -317.57)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63439",
    "data-name": "Group 63439",
    transform: "translate(3.132 10.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63438",
    "data-name": "Group 63438",
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23309",
    "data-name": "Rectangle 23309",
    className: "cls-119",
    width: 7.297,
    height: 6.477,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.698, 0.98)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63462",
    "data-name": "Group 63462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63461",
    "data-name": "Group 63461",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63442",
    "data-name": "Group 63442",
    className: "cls-116",
    transform: "translate(3.388 10.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63441",
    "data-name": "Group 63441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63440",
    "data-name": "Group 63440",
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62342",
    "data-name": "Path 62342",
    className: "cls-52",
    d: "M86.19,258.17a2.292,2.292,0,0,0-.742-.741l-2.522-1.456a.574.574,0,0,0-.583-.054h0l-1.775,1.025c.119-.03.165.012.411.154l2.522,1.456a5.838,5.838,0,0,1,.834.6l.486.407,1.654-.955Z",
    transform: "translate(-80.567 -255.862)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62343",
    "data-name": "Path 62343",
    className: "cls-54",
    d: "M309.877,437.02v2.292l4.516,2.607v-2.292Z",
    transform: "translate(-296.845 -418.641)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23311",
    "data-name": "Rectangle 23311",
    className: "cls-121",
    width: 0.676,
    height: 5.215,
    transform: "translate(13.032 18.379) rotate(-60.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62344",
    "data-name": "Path 62344",
    className: "cls-122",
    d: "M329.722,450.77l.332.191v-2.292l-.332-.191Z",
    transform: "translate(-315.855 -429.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62345",
    "data-name": "Path 62345",
    className: "cls-122",
    d: "M389.53,483.007V485.3l.332.191V483.2Z",
    transform: "translate(-373.148 -462.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23312",
    "data-name": "Rectangle 23312",
    className: "cls-123",
    width: 0.676,
    height: 0.383,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 13.867, 18.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62346",
    "data-name": "Path 62346",
    className: "cls-53",
    d: "M318.991,408.363l-1.073.619,4.516,2.607,1.073-.619Z",
    transform: "translate(-304.548 -391.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62347",
    "data-name": "Path 62347",
    className: "cls-69",
    d: "M337.763,420.44l.332.191,1.073-.619-.332-.191Z",
    transform: "translate(-323.558 -402.164)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23313",
    "data-name": "Rectangle 23313",
    className: "cls-123",
    width: 0.676,
    height: 0.383,
    transform: "translate(16.382 20.313) rotate(-60.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62348",
    "data-name": "Path 62348",
    className: "cls-69",
    d: "M398.644,454.351l-1.073.619.332.191,1.073-.619Z",
    transform: "translate(-380.851 -435.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62349",
    "data-name": "Path 62349",
    className: "cls-52",
    d: "M418.67,470.36l-1.073.619-.338.586v2.292l.338.2,1.073-.619.338-.586v-2.292Z",
    transform: "translate(-399.711 -450.579)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63445",
    "data-name": "Group 63445",
    className: "cls-116",
    transform: "translate(13.459 17.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63444",
    "data-name": "Group 63444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63443",
    "data-name": "Group 63443",
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62350",
    "data-name": "Path 62350",
    className: "cls-52",
    d: "M321.009,408.363l-.984.568,4.03,2.327.754.126.716-.413Z",
    transform: "translate(-320.025 -408.363)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62351",
    "data-name": "Path 62351",
    className: "cls-125",
    d: "M212.117,0l-.533.308,17.048,9.843.1-.556Z",
    transform: "translate(-202.686 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62352",
    "data-name": "Path 62352",
    className: "cls-126",
    d: "M222.479,17.007l-16.793-9.7-.065.352.44.254-.634,3.448,13.411,7.743Z",
    transform: "translate(-196.788 -7.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62353",
    "data-name": "Path 62353",
    className: "cls-127",
    d: "M203.141,111.454l-13.411-7.743-.689,1.1,12.8,7.392Z",
    transform: "translate(-181.09 -99.349)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63448",
    "data-name": "Group 63448",
    className: "cls-128",
    transform: "translate(7.95 4.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63447",
    "data-name": "Group 63447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63446",
    "data-name": "Group 63446",
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62354",
    "data-name": "Path 62354",
    className: "cls-130",
    d: "M191.632,104.811l-.255,1.351-2.34-1.351.689-1.1Z",
    transform: "translate(-189.037 -103.711)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62355",
    "data-name": "Path 62355",
    className: "cls-131",
    d: "M133.249,129.869l-2.449,1.414,12.8,7.392,2.449-1.414Z",
    transform: "translate(-125.299 -124.407)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63451",
    "data-name": "Group 63451",
    className: "cls-132",
    transform: "translate(5.501 5.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63450",
    "data-name": "Group 63450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63449",
    "data-name": "Group 63449",
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62356",
    "data-name": "Path 62356",
    className: "cls-130",
    d: "M133.14,132.634l-2.34-1.351,2.449-1.414,2.34,1.351Z",
    transform: "translate(-130.8 -129.869)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63454",
    "data-name": "Group 63454",
    className: "cls-134",
    transform: "translate(8.639 0.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63453",
    "data-name": "Group 63453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63452",
    "data-name": "Group 63452",
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62357",
    "data-name": "Path 62357",
    className: "cls-136",
    d: "M205.427,25.174l1.906,1.1-1.271-4.548Z",
    transform: "translate(-205.427 -21.726)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62358",
    "data-name": "Path 62358",
    className: "cls-137",
    d: "M42.414,19.754l.44.254,7.05-4.07-.44-.254Z",
    transform: "translate(-40.63 -15.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62359",
    "data-name": "Path 62359",
    className: "cls-138",
    d: "M52.878,25.8l3.277,1.892L58.6,26.274l.689-1.1.634-3.448Z",
    transform: "translate(-50.654 -20.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62360",
    "data-name": "Path 62360",
    className: "cls-139",
    d: "M131.553,67.095l-3.539,1.292,5.448,2.194L137,69.288Z",
    transform: "translate(-122.63 -64.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62361",
    "data-name": "Path 62361",
    className: "cls-140",
    d: "M261.107,119.257l-3.539,1.292,2.171,1.568,3.539-1.292Z",
    transform: "translate(-246.736 -114.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62362",
    "data-name": "Path 62362",
    className: "cls-139",
    d: "M312.735,156.547l3.341,1.345-3.539,1.292-3.341-1.345Z",
    transform: "translate(-296.193 -149.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62363",
    "data-name": "Path 62363",
    className: "cls-141",
    d: "M40.361,97.813l-3.848,2.973,5.448,2.194,3.848-2.973Z",
    transform: "translate(-34.977 -93.699)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63457",
    "data-name": "Group 63457",
    className: "cls-132",
    transform: "translate(5.384 2.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63456",
    "data-name": "Group 63456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63455",
    "data-name": "Group 63455",
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62364",
    "data-name": "Path 62364",
    className: "cls-143",
    d: "M131.553,67.095l-3.539,1.292.372.15L132.55,67.5Z",
    transform: "translate(-128.014 -67.095)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63460",
    "data-name": "Group 63460",
    className: "cls-144",
    transform: "translate(1.536 4.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63459",
    "data-name": "Group 63459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63458",
    "data-name": "Group 63458",
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62365",
    "data-name": "Path 62365",
    className: "cls-143",
    d: "M36.512,100.786l3.848-2.973.372.15-3.224,3.224Z",
    transform: "translate(-36.512 -97.813)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62366",
    "data-name": "Path 62366",
    className: "cls-146",
    d: "M169.915,149.976l-3.848,2.973,2.171,1.568,3.848-2.973Z",
    transform: "translate(-159.083 -143.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62367",
    "data-name": "Path 62367",
    className: "cls-141",
    d: "M221.544,187.265l-3.848,2.973,3.341,1.345,3.848-2.973Z",
    transform: "translate(-208.54 -179.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62368",
    "data-name": "Path 62368",
    className: "cls-146",
    d: "M300.981,219.249l-3.848,2.973,4.409,3.184,3.848-2.973Z",
    transform: "translate(-284.636 -210.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62369",
    "data-name": "Path 62369",
    className: "cls-140",
    d: "M392.173,188.531l-3.539,1.292,4.409,3.184,3.539-1.292Z",
    transform: "translate(-372.29 -180.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62370",
    "data-name": "Path 62370",
    className: "cls-147",
    d: "M408.728,200.889l-1.181,6.422,8.452-4.88,1.181-6.422Z",
    transform: "translate(-390.407 -187.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62371",
    "data-name": "Path 62371",
    className: "cls-148",
    d: "M464.523,511.94l-1.105-.638v1.024l1.105.638Z",
    transform: "translate(-443.929 -489.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62372",
    "data-name": "Path 62372",
    className: "cls-52",
    d: "M795.7,380.192l-.137-.238.567-.328a.382.382,0,0,0,.165-.285v-.435h.275v.435a.649.649,0,0,1-.3.523Z",
    transform: "translate(-762.106 -362.971)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63464",
    "data-name": "Group 63464",
    transform: "translate(33.741 13.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63463",
    "data-name": "Group 63463",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23321",
    "data-name": "Rectangle 23321",
    className: "cls-150",
    width: 2.94,
    height: 2.343,
    transform: "translate(-1.184 2.064) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63469",
    "data-name": "Group 63469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63468",
    "data-name": "Group 63468",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63467",
    "data-name": "Group 63467",
    className: "cls-144",
    transform: "translate(34.327 13.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63466",
    "data-name": "Group 63466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63465",
    "data-name": "Group 63465",
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62374",
    "data-name": "Path 62374",
    className: "cls-152",
    d: "M816.573,324.438h-.335v.159h.06Z",
    transform: "translate(-816.238 -324.438)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62375",
    "data-name": "Path 62375",
    className: "cls-52",
    d: "M807.809,322.613l-.669.386a.339.339,0,0,0-.153.265v1.857c0,.1.069.137.153.088l.669-.386a.339.339,0,0,0,.153-.265V322.7c0-.1-.069-.137-.153-.089",
    transform: "translate(-773.049 -309.025)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63474",
    "data-name": "Group 63474",
    transform: "translate(33.458 12.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63473",
    "data-name": "Group 63473",
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63472",
    "data-name": "Group 63472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63471",
    "data-name": "Group 63471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63470",
    "data-name": "Group 63470",
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23324",
    "data-name": "Rectangle 23324",
    width: 1.03,
    height: 0.767,
    transform: "translate(-0.009 -0.02)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAIAAADm2DRVAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAJgAAAABExXeQAAAEa0lEQVRYCc2XP4/cRBjGba+99zUiAVIkcspJRIJPQJeaUIQGAUqTFLQRVdIlRQqEQpcUXEooE1GjoHCKICdRwQe5XXvze953PR6P98/d7l4uc6vZmfHY8/PzPvPOXj6bzbL3spTnSvXf38d8WOLF02fJQp9/deODq1f4JOOhm5+TZgBB41hhsYUNEPkML+2eDJqfvr+brMT7yzRW51lWFEUy4dbDe4l+uyQb6gRJ0zR108wagTUCnIFFGRV5XhRQ5jmVSgK3MzJ0imMXmOq6nk5r32XiAjHPytEIKuEVeVWWC+F2QIafYoM709SAEKuWZC6WhOEqHAC5YmVZjscVoAHuwe+/al6WbbU3h+GDwkVCJwpSeRc2X89rSWaaZXmdTxTOUQvHS/qG2JBsyOR+gmNiTKBMRSe1qINs9MGqmxywqkK/GTKCO85zlKMRLLEJ2TB8kmrKnyzliKaZgBjEW4wGzRi0WGp7GhWBrUe1mS7PIePDPj2bzxYz1Y3HTnwq1DKXSG1fBqa4ARwiVRWfajwux1W1tzcmyMwBi316Ws0Whg+BAHEslCCOUgmdYDKoGCVpE2Vmmdu4a8RdvElRASzZmHwqsiQj4JUA5NGb6+SgdCjsQdLD6qJsZwmPxxVFU8qUkPlNa8iG4ZMkCp8jyUZWLILoZ5bn0euxMJklEb2ECl/de7DuUjIkjQ8Zv5X1feuZSOJwtWQwxQOfn0KqDkDpzYq2gisdjq0FZEsshTSsP6+NSW3xyFK0FIgVUt248y1Izx79HIHpvKIrOKvjSylZYiluYU1CZ39a3+CoZDXryioABX/ET/f2lU8/AWv/s2uHjx4PrzJiYLrCszIlNZWObImlfOsZkASSQu3Wk06U0zD5Ysvruetb97dkiaUYdm2MQMq4NrTM7/KTQ0mo+GH9ldHpyzvf9cfO0CuT8KGCCAyBWiKZTgxKLavxBO+4IybfkLJZQl2ScD2zuaVYGiAIPHAiQSFLB4xyyAkpeUbUDZaKxtY0TXc9MnnVkoP9+ZNDOEwPVheHutN5w8mUp9ZlhHu/PMbma0DSyxyPPhQa8xlKHxxSJxOVkwkZdDqZ1Ccn1NaYTDVov2FWZ4Tf/j86O5ZDhDiGhsa1Nz882L+0//G/r167vbo42t5bG777h70U5attX8+zxvWvb/7zxysCJzjbe0TUAr/UVBtYahluG9De9TnZ5WsHHx3sv3n5l3HxW2pVluIBG1mqt3Db8QhS90LJ1XBMZT88+ZEzkR1g9yyViiy1haVanug7EIWGX+zI6H9x+5sVKYHwwbRN8ox4QlMS8E+Bubm3PbvTiRmsevzy6PjPo3CfN3ZoqeTJdEFrz82eaj3NmOe/COL7GWH3bZoR4ietbM93QQfX04xbIUAhl23Lg28lSHcRlm5vdmDRb40wFyDI4Dt3nbSksxgbHo82XqoZcwF6J0wmRSSSQXZoqc9s+rurYjDTrxu4YLIQwE6rVpYLJrOkYb9/Bon0wslaiQbf7y/ZW4cePkRC7NfTAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63476",
    "data-name": "Group 63476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63475",
    "data-name": "Group 63475",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23326",
    "data-name": "Rectangle 23326",
    width: 1.051,
    height: 0.757,
    transform: "translate(33.434 12.975)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAEgAAAAAM64R1AAABL0lEQVQ4Eb2USwrCMBRFGz/4RQU/qO2gCo4F3YJjHTp0jY5dg1sQd1LvK70l/SVpBwZC8pK8c+8LaVUURV6TdtufQ1Pe8/P+cr/FSZ3RIjAE64AzDzJVnUos8DagW3Rf76jo3qGaabTAJXWFnoEjpqBnrMQBPknggQalmIgs0b3KSiwCPeQSxpHOGSsRkFYQscAlR2DiXGA6mPMB1jMtFXGAz5FJl3kBiWcZshao6+4UanHZdITFSud4PRsYNH5saSUldNnTnRfcQ6BbkldYil9XyVWtEwHev4y88wDwsU6qW4ncK93zWRLuA77Q4a7z9DuBmwuS6JxXE8eAS1zZ6lRyBIWuOYr7fiXdcSOtRM7D0QtDfF2ATx0Zkmd8XRkRV2j+nE2k0a8+L2KL/yLyA3KdSM/eyS4kAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62377",
    "data-name": "Path 62377",
    className: "cls-52",
    d: "M813.105,324.439c-.076,0-.137.036-.137.079s.062.079.137.079.138-.036.138-.079-.062-.079-.138-.079",
    transform: "translate(-778.778 -310.795)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63478",
    "data-name": "Group 63478",
    transform: "translate(34.19 13.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63477",
    "data-name": "Group 63477",
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23328",
    "data-name": "Rectangle 23328",
    className: "cls-156",
    width: 0.249,
    height: 0.527,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63480",
    "data-name": "Group 63480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63479",
    "data-name": "Group 63479",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62379",
    "data-name": "Path 62379",
    className: "cls-52",
    d: "M470.427,237.776l-.86-4.32-6.3-3.635-8.239,4.757v4.262l7.254,4.188,8.14-4.7Zm-.842-.537-.467-.27a.957.957,0,0,1-.357-.409l-.133-.275a.958.958,0,0,0-.357-.409l-1.468-.847v-2.624l1.976,1.141a.913.913,0,0,1,.394.58l.587,2.951c.03.151-.057.231-.177.162",
    transform: "translate(-435.895 -220.156)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63482",
    "data-name": "Group 63482",
    transform: "translate(18.205 21.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63481",
    "data-name": "Group 63481",
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23330",
    "data-name": "Rectangle 23330",
    className: "cls-158",
    width: 2.499,
    height: 2.565,
    transform: "translate(-0.841 0.486) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63484",
    "data-name": "Group 63484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63483",
    "data-name": "Group 63483",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62381",
    "data-name": "Path 62381",
    className: "cls-54",
    d: "M425.92,502.35l1.178.68v.266c-.867-.04-1.47.624-1.47,1.8l-.318-.184V502.9Z",
    transform: "translate(-407.422 -481.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62382",
    "data-name": "Path 62382",
    className: "cls-53",
    d: "M439.827,496.426l.451-.26v.52Z",
    transform: "translate(-421.33 -475.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62383",
    "data-name": "Path 62383",
    className: "cls-52",
    d: "M467.828,518.784l.25-.122-.25-.144Z",
    transform: "translate(-448.153 -496.711)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63486",
    "data-name": "Group 63486",
    transform: "translate(18.671 21.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63485",
    "data-name": "Group 63485",
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23332",
    "data-name": "Rectangle 23332",
    className: "cls-160",
    width: 8.526,
    height: 8.697,
    transform: "translate(-3.032 1.634) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63488",
    "data-name": "Group 63488",
    transform: "translate(19.557 21.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63487",
    "data-name": "Group 63487",
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23333",
    "data-name": "Rectangle 23333",
    className: "cls-162",
    width: 7.279,
    height: 7.626,
    transform: "translate(-2.567 1.482) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63490",
    "data-name": "Group 63490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63489",
    "data-name": "Group 63489",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62386",
    "data-name": "Path 62386",
    className: "cls-163",
    d: "M447.466,540.907c-.8-1.392-2.107-2.144-2.91-1.68s-.8,1.969,0,3.361,2.107,2.144,2.91,1.68.8-1.969,0-3.361",
    transform: "translate(-425.282 -516.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62387",
    "data-name": "Path 62387",
    className: "cls-19",
    d: "M464.434,563.835c-.5-.872-1.32-1.343-1.823-1.053s-.5,1.233,0,2.105,1.32,1.343,1.823,1.053.5-1.233,0-2.105",
    transform: "translate(-442.794 -539.032)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63492",
    "data-name": "Group 63492",
    transform: "translate(19.6 23.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63491",
    "data-name": "Group 63491",
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23335",
    "data-name": "Rectangle 23335",
    className: "cls-165",
    width: 3.692,
    height: 3.918,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.45, 0.773)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63497",
    "data-name": "Group 63497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63496",
    "data-name": "Group 63496",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63495",
    "data-name": "Group 63495",
    className: "cls-166",
    transform: "translate(19.6 23.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63494",
    "data-name": "Group 63494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63493",
    "data-name": "Group 63493",
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62389",
    "data-name": "Path 62389",
    className: "cls-66",
    d: "M466.77,569.417a1.615,1.615,0,0,1-.138-1.729h0a.566.566,0,0,0-.243.073.988.988,0,0,0-.29,1.1,2.206,2.206,0,0,0,.59.573,2.321,2.321,0,0,0,.116.229,1.512,1.512,0,0,0,1.083.841.647.647,0,0,0,.161-.02.562.562,0,0,0,.072-.07,1.709,1.709,0,0,1-1.351-.994",
    transform: "translate(-466.059 -567.687)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62390",
    "data-name": "Path 62390",
    className: "cls-18",
    d: "M475.3,567.644a1.614,1.614,0,0,0,.137,1.73,1.707,1.707,0,0,0,1.353.994,1.614,1.614,0,0,0-.137-1.729,1.707,1.707,0,0,0-1.353-.994",
    transform: "translate(-455.126 -543.77)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63499",
    "data-name": "Group 63499",
    transform: "translate(19.89 23.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63498",
    "data-name": "Group 63498",
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23338",
    "data-name": "Rectangle 23338",
    className: "cls-169",
    width: 3.062,
    height: 3.241,
    transform: "translate(-1.186 0.638) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63504",
    "data-name": "Group 63504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63503",
    "data-name": "Group 63503",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63502",
    "data-name": "Group 63502",
    className: "cls-166",
    transform: "translate(20.311 23.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63501",
    "data-name": "Group 63501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63500",
    "data-name": "Group 63500",
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62392",
    "data-name": "Path 62392",
    className: "cls-66",
    d: "M484.163,571.408a2.244,2.244,0,0,0-.857-.874l-.359.207c.327-.189.858.117,1.186.685s.327,1.18,0,1.369l.359-.207a2.243,2.243,0,0,0-.329-1.179",
    transform: "translate(-482.947 -570.534)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62393",
    "data-name": "Path 62393",
    className: "cls-19",
    d: "M474.383,577.277c-.327-.567-.858-.874-1.186-.685s-.327.8,0,1.369.858.874,1.186.685.327-.8,0-1.369",
    transform: "translate(-453.062 -552.29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63506",
    "data-name": "Group 63506",
    transform: "translate(20.614 24.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63505",
    "data-name": "Group 63505",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23341",
    "data-name": "Rectangle 23341",
    className: "cls-172",
    width: 0.281,
    height: 0.352,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.054, 0.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63508",
    "data-name": "Group 63508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63507",
    "data-name": "Group 63507",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62395",
    "data-name": "Path 62395",
    className: "cls-173",
    d: "M492.272,582.248a.123.123,0,0,0-.024-.011.127.127,0,0,0,0,.026.253.253,0,0,0,.115.2.136.136,0,0,0,.024.011.133.133,0,0,0,0-.027.253.253,0,0,0-.115-.2",
    transform: "translate(-471.543 -557.751)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63510",
    "data-name": "Group 63510",
    transform: "translate(20.614 25.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63509",
    "data-name": "Group 63509",
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23343",
    "data-name": "Rectangle 23343",
    className: "cls-175",
    width: 0.281,
    height: 0.352,
    transform: "translate(-0.054 0.01) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63512",
    "data-name": "Group 63512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63511",
    "data-name": "Group 63511",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62397",
    "data-name": "Path 62397",
    className: "cls-173",
    d: "M492.272,615.526a.13.13,0,0,0-.024-.011.127.127,0,0,0,0,.026.253.253,0,0,0,.115.2l.024.011a.131.131,0,0,0,0-.026.253.253,0,0,0-.115-.2",
    transform: "translate(-471.543 -589.629)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63514",
    "data-name": "Group 63514",
    transform: "translate(21.22 25.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63513",
    "data-name": "Group 63513",
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23345",
    "data-name": "Rectangle 23345",
    className: "cls-177",
    width: 0.281,
    height: 0.352,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.054, 0.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63516",
    "data-name": "Group 63516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63515",
    "data-name": "Group 63515",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62399",
    "data-name": "Path 62399",
    className: "cls-173",
    d: "M506.682,607.206a.016.016,0,1,0-.027.016.253.253,0,0,0,.115.2.118.118,0,0,0,.024.011.123.123,0,0,0,0-.026.253.253,0,0,0-.115-.2",
    transform: "translate(-485.347 -581.659)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63518",
    "data-name": "Group 63518",
    transform: "translate(20.008 24.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63517",
    "data-name": "Group 63517",
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23347",
    "data-name": "Rectangle 23347",
    className: "cls-179",
    width: 0.281,
    height: 0.352,
    transform: "translate(-0.054 0.01) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63520",
    "data-name": "Group 63520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63519",
    "data-name": "Group 63519",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62401",
    "data-name": "Path 62401",
    className: "cls-173",
    d: "M477.862,590.568a.134.134,0,0,0-.024-.011.124.124,0,0,0,0,.026.253.253,0,0,0,.115.2.123.123,0,0,0,.024.011.128.128,0,0,0,0-.026.253.253,0,0,0-.115-.2",
    transform: "translate(-457.739 -565.721)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63522",
    "data-name": "Group 63522",
    transform: "translate(21.043 24.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63521",
    "data-name": "Group 63521",
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23349",
    "data-name": "Rectangle 23349",
    className: "cls-181",
    width: 0.302,
    height: 0.353,
    transform: "translate(-0.065 0.009) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63524",
    "data-name": "Group 63524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63523",
    "data-name": "Group 63523",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62403",
    "data-name": "Path 62403",
    className: "cls-173",
    d: "M502.442,593a.237.237,0,1,0,.105.1.209.209,0,0,0-.105-.1",
    transform: "translate(-481.309 -568.058)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63526",
    "data-name": "Group 63526",
    transform: "translate(20.186 25.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63525",
    "data-name": "Group 63525",
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23351",
    "data-name": "Rectangle 23351",
    className: "cls-183",
    width: 0.302,
    height: 0.353,
    transform: "translate(-0.065 0.009) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63528",
    "data-name": "Group 63528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63527",
    "data-name": "Group 63527",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62405",
    "data-name": "Path 62405",
    className: "cls-173",
    d: "M482.063,604.762a.236.236,0,1,0,.105.1.209.209,0,0,0-.105-.1",
    transform: "translate(-461.787 -579.328)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63530",
    "data-name": "Group 63530",
    transform: "translate(21.043 25.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63529",
    "data-name": "Group 63529",
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23353",
    "data-name": "Rectangle 23353",
    className: "cls-185",
    width: 0.302,
    height: 0.353,
    transform: "translate(-0.065 0.009) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63532",
    "data-name": "Group 63532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63531",
    "data-name": "Group 63531",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62407",
    "data-name": "Path 62407",
    className: "cls-173",
    d: "M502.442,616.527a.237.237,0,1,0,.105.1.209.209,0,0,0-.105-.1",
    transform: "translate(-481.309 -590.599)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63534",
    "data-name": "Group 63534",
    transform: "translate(20.186 24.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63533",
    "data-name": "Group 63533",
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23355",
    "data-name": "Rectangle 23355",
    className: "cls-187",
    width: 0.302,
    height: 0.353,
    transform: "translate(-0.065 0.009) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63536",
    "data-name": "Group 63536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63535",
    "data-name": "Group 63535",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62409",
    "data-name": "Path 62409",
    className: "cls-173",
    d: "M482.063,581.231a.237.237,0,1,0,.105.1.209.209,0,0,0-.105-.1",
    transform: "translate(-461.787 -556.787)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63538",
    "data-name": "Group 63538",
    transform: "translate(20.41 24.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63537",
    "data-name": "Group 63537",
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23357",
    "data-name": "Rectangle 23357",
    className: "cls-189",
    width: 0.7,
    height: 0.874,
    transform: "translate(-0.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63540",
    "data-name": "Group 63540",
    transform: "translate(18.948 19.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63539",
    "data-name": "Group 63539",
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23358",
    "data-name": "Rectangle 23358",
    className: "cls-191",
    width: 8.965,
    height: 10.076,
    transform: "translate(-3.388 1.735) rotate(-27.112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63566",
    "data-name": "Group 63566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63565",
    "data-name": "Group 63565",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62412",
    "data-name": "Path 62412",
    className: "cls-192",
    d: "M570.244,654.624v.406l1.868,1.079V655.7Z",
    transform: "translate(-546.262 -627.093)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63543",
    "data-name": "Group 63543",
    className: "cls-70",
    transform: "translate(23.982 27.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63542",
    "data-name": "Group 63542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63541",
    "data-name": "Group 63541",
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62413",
    "data-name": "Path 62413",
    className: "cls-194",
    d: "M570.244,654.624v.406l.189.109v-.406Z",
    transform: "translate(-570.244 -654.624)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62414",
    "data-name": "Path 62414",
    className: "cls-195",
    d: "M570.244,642.84l.9-.517,1.868,1.079-.9.517Z",
    transform: "translate(-546.262 -615.31)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63546",
    "data-name": "Group 63546",
    className: "cls-144",
    transform: "translate(23.982 27.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63545",
    "data-name": "Group 63545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63544",
    "data-name": "Group 63544",
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62415",
    "data-name": "Path 62415",
    className: "cls-194",
    d: "M570.433,642.949h.193l1.583.914.8-.462-1.868-1.079-.9.517Z",
    transform: "translate(-570.244 -642.322)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62416",
    "data-name": "Path 62416",
    className: "cls-192",
    d: "M570.244,624.606v.406l1.868,1.079v-.406Z",
    transform: "translate(-546.262 -598.338)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63549",
    "data-name": "Group 63549",
    className: "cls-70",
    transform: "translate(23.982 26.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63548",
    "data-name": "Group 63548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63547",
    "data-name": "Group 63547",
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62417",
    "data-name": "Path 62417",
    className: "cls-194",
    d: "M570.244,624.606v.406l.189.109v-.406Z",
    transform: "translate(-570.244 -624.606)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62418",
    "data-name": "Path 62418",
    className: "cls-195",
    d: "M570.244,612.823l.9-.517,1.868,1.079-.9.517Z",
    transform: "translate(-546.262 -586.555)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63552",
    "data-name": "Group 63552",
    className: "cls-144",
    transform: "translate(23.982 25.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63551",
    "data-name": "Group 63551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63550",
    "data-name": "Group 63550",
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62419",
    "data-name": "Path 62419",
    className: "cls-194",
    d: "M570.433,612.931h.193l1.583.914.8-.462L571.14,612.3l-.9.517Z",
    transform: "translate(-570.244 -612.305)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62420",
    "data-name": "Path 62420",
    className: "cls-192",
    d: "M570.244,594.589v.406l1.868,1.079v-.406Z",
    transform: "translate(-546.262 -569.583)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63555",
    "data-name": "Group 63555",
    className: "cls-70",
    transform: "translate(23.982 25.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63554",
    "data-name": "Group 63554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63553",
    "data-name": "Group 63553",
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62421",
    "data-name": "Path 62421",
    className: "cls-194",
    d: "M570.244,594.589v.406l.189.109V594.7Z",
    transform: "translate(-570.244 -594.589)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62422",
    "data-name": "Path 62422",
    className: "cls-195",
    d: "M570.244,582.805l.9-.517,1.868,1.079-.9.517Z",
    transform: "translate(-546.262 -557.799)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63558",
    "data-name": "Group 63558",
    className: "cls-144",
    transform: "translate(23.982 24.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63557",
    "data-name": "Group 63557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63556",
    "data-name": "Group 63556",
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62423",
    "data-name": "Path 62423",
    className: "cls-194",
    d: "M572.819,585.96l-1.868-1.079-.707.408.189.109h.482l1.438.83Z",
    transform: "translate(-570.243 -584.881)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62424",
    "data-name": "Path 62424",
    className: "cls-198",
    d: "M642.256,413.321l-3.708.186v.652a.232.232,0,0,0,.137.19l1.226.708a.729.729,0,0,0,.659,0l1.549-.894a.232.232,0,0,0,.137-.191Z",
    transform: "translate(-611.693 -395.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62425",
    "data-name": "Path 62425",
    className: "cls-199",
    d: "M642.119,390.873l-1.226-.708a.729.729,0,0,0-.659,0l-1.549.894a.2.2,0,0,0,0,.381l1.226.708a.729.729,0,0,0,.659,0l1.549-.894a.2.2,0,0,0,0-.381",
    transform: "translate(-611.694 -373.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62426",
    "data-name": "Path 62426",
    className: "cls-198",
    d: "M551.88,465.5l-3.708.186v.652a.232.232,0,0,0,.137.19l1.226.708a.729.729,0,0,0,.659,0l1.549-.894a.232.232,0,0,0,.137-.191Z",
    transform: "translate(-525.118 -445.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62427",
    "data-name": "Path 62427",
    className: "cls-199",
    d: "M551.744,443.051l-1.226-.708a.729.729,0,0,0-.659,0l-1.549.894a.2.2,0,0,0,0,.381l1.226.708a.729.729,0,0,0,.659,0l1.549-.894a.2.2,0,0,0,0-.381",
    transform: "translate(-525.119 -423.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62428",
    "data-name": "Path 62428",
    className: "cls-198",
    d: "M545.788,382.674c0-.21-.148-.3-.33-.19l-1.549.894a.729.729,0,0,0-.33.571v1.788c0,.21.148.3.33.19l1.549-.894a.729.729,0,0,0,.33-.571Z",
    transform: "translate(-520.719 -366.355)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63561",
    "data-name": "Group 63561",
    className: "cls-70",
    transform: "translate(20.807 16.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63560",
    "data-name": "Group 63560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63559",
    "data-name": "Group 63559",
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62429",
    "data-name": "Path 62429",
    className: "cls-201",
    d: "M496.159,384.075l-.909-.525a1.1,1.1,0,0,1-.5-.862v-1.475c0-.317.223-.446.5-.287l.909.525Z",
    transform: "translate(-494.753 -380.858)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63564",
    "data-name": "Group 63564",
    className: "cls-202",
    transform: "translate(20.807 16.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63563",
    "data-name": "Group 63563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63562",
    "data-name": "Group 63562",
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62430",
    "data-name": "Path 62430",
    className: "cls-194",
    d: "M494.752,381.214v1.475a.985.985,0,0,0,.117.436c0-.008,0-.015,0-.023v-1.475c0-.317.223-.446.5-.287l.793.458v-.347l-.909-.525c-.275-.159-.5-.03-.5.287",
    transform: "translate(-494.752 -380.858)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63568",
    "data-name": "Group 63568",
    transform: "translate(20.692 16.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63567",
    "data-name": "Group 63567",
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23368",
    "data-name": "Rectangle 23368",
    className: "cls-205",
    width: 2.729,
    height: 3.495,
    transform: "translate(-1.314 0.684) rotate(-27.499)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63579",
    "data-name": "Group 63579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63578",
    "data-name": "Group 63578",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63571",
    "data-name": "Group 63571",
    className: "cls-67",
    transform: "translate(20.692 17.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63570",
    "data-name": "Group 63570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63569",
    "data-name": "Group 63569",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62432",
    "data-name": "Path 62432",
    className: "cls-138",
    d: "M492.235,422.919a.985.985,0,0,1-.117-.437V422.4H492v.15a.84.84,0,0,0,.232.37Z",
    transform: "translate(-492.003 -422.399)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63574",
    "data-name": "Group 63574",
    className: "cls-70",
    transform: "translate(22.785 16.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63573",
    "data-name": "Group 63573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63572",
    "data-name": "Group 63572",
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62433",
    "data-name": "Path 62433",
    className: "cls-201",
    d: "M544.564,407.632l-.467-.27a.957.957,0,0,1-.357-.409l-.133-.275a.958.958,0,0,0-.357-.409l-1.468-.847V402.8l1.976,1.141a.914.914,0,0,1,.394.58l.587,2.951c.03.151-.057.231-.177.162",
    transform: "translate(-541.783 -402.798)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63577",
    "data-name": "Group 63577",
    className: "cls-202",
    transform: "translate(22.785 16.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63576",
    "data-name": "Group 63576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63575",
    "data-name": "Group 63575",
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62434",
    "data-name": "Path 62434",
    className: "cls-194",
    d: "M541.9,403.213l1.976,1.141a.861.861,0,0,1,.317.358l-.038-.192a.913.913,0,0,0-.394-.58l-1.976-1.141v2.624l.116.067Z",
    transform: "translate(-541.783 -402.799)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62435",
    "data-name": "Path 62435",
    className: "cls-138",
    d: "M539.035,404.385v2.624l.116-.067v-2.491Z",
    transform: "translate(-516.365 -387.378)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63581",
    "data-name": "Group 63581",
    transform: "translate(22.669 19.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63580",
    "data-name": "Group 63580",
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23373",
    "data-name": "Rectangle 23373",
    className: "cls-210",
    width: 3.721,
    height: 3.49,
    transform: "translate(-1.006 0.581) rotate(-29.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63598",
    "data-name": "Group 63598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63597",
    "data-name": "Group 63597",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63584",
    "data-name": "Group 63584",
    className: "cls-132",
    transform: "translate(22.669 19.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63583",
    "data-name": "Group 63583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63582",
    "data-name": "Group 63582",
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62437",
    "data-name": "Path 62437",
    className: "cls-212",
    d: "M539.15,465.193l-.116.067h.231Z",
    transform: "translate(-539.035 -465.193)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62438",
    "data-name": "Path 62438",
    className: "cls-126",
    d: "M461.327,346.562l-6.3-3.635V348.2l2.641,1.525a4.941,4.941,0,0,1,2.106,3.008l2.293,1.324V350.3Zm-3.335,1.244-.909-.525a1.1,1.1,0,0,1-.5-.862v-1.475c0-.317.223-.446.5-.287l.909.525Zm3.353,2.54-.467-.27a.956.956,0,0,1-.357-.409l-.133-.275a.958.958,0,0,0-.357-.409l-1.468-.847v-2.624l1.976,1.141a.913.913,0,0,1,.394.58l.587,2.951c.03.151-.057.231-.177.162",
    transform: "translate(-435.894 -328.505)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63587",
    "data-name": "Group 63587",
    className: "cls-213",
    transform: "translate(25.081 18.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63586",
    "data-name": "Group 63586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63585",
    "data-name": "Group 63585",
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62439",
    "data-name": "Path 62439",
    className: "cls-212",
    d: "M597.482,438.485l-.145-.727-.769-2.752-.181-.024.572,2.046-.043-.025c-.011-.007-.029,0-.029.047v1.085l.046.232c.017.085,0,.148-.046.174v.218a5.167,5.167,0,0,0,.153.961l.154.678v.451q-.032-.1-.068-.227l-.558-1.995-.181-.024.577,2.064c.167.6.24.658.3.658l.021,0c.019,0,.081-.019.081-.113v-.071l.12.526Z",
    transform: "translate(-596.386 -434.982)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62440",
    "data-name": "Path 62440",
    className: "cls-215",
    d: "M734.94,352.154l1.468.847a.958.958,0,0,1,.357.409l.133.275a.957.957,0,0,0,.357.409l.467.27c.082.048.15.024.173-.044a.188.188,0,0,1-.058-.022l-.467-.27a.957.957,0,0,1-.357-.409l-.133-.275a.957.957,0,0,0-.357-.409l-1.468-.847Z",
    transform: "translate(-704.032 -337.28)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63590",
    "data-name": "Group 63590",
    className: "cls-70",
    transform: "translate(30.908 12.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63589",
    "data-name": "Group 63589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63588",
    "data-name": "Group 63588",
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62441",
    "data-name": "Path 62441",
    className: "cls-216",
    d: "M737.721,296.113l-.467-.27a.956.956,0,0,1-.357-.409l-.133-.275a.959.959,0,0,0-.357-.409l-1.468-.847v-2.624l1.976,1.141a.913.913,0,0,1,.394.58l.587,2.951c.03.151-.057.231-.177.162",
    transform: "translate(-734.94 -291.279)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62442",
    "data-name": "Path 62442",
    className: "cls-217",
    d: "M461.328,330.161l-6.3-3.635.191-.72,5.291,3.055Z",
    transform: "translate(-435.895 -312.104)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63593",
    "data-name": "Group 63593",
    className: "cls-132",
    transform: "translate(19.243 13.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63592",
    "data-name": "Group 63592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63591",
    "data-name": "Group 63591",
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62443",
    "data-name": "Path 62443",
    className: "cls-212",
    d: "M457.555,326.126l.775.448.085-.319-.775-.448Z",
    transform: "translate(-457.555 -325.806)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62444",
    "data-name": "Path 62444",
    className: "cls-126",
    d: "M454.844,477.027a4,4,0,0,0-1.81-3.136l-2.495-1.44v-1.584l2.641,1.525a4.872,4.872,0,0,1,2.2,3.817v2.9l-.54-.312Z",
    transform: "translate(-431.591 -451.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62445",
    "data-name": "Path 62445",
    className: "cls-195",
    d: "M792.915,493.764l-.9-.517v1.035Z",
    transform: "translate(-758.71 -472.503)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63596",
    "data-name": "Group 63596",
    className: "cls-144",
    transform: "translate(33.309 20.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63595",
    "data-name": "Group 63595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63594",
    "data-name": "Group 63594",
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62446",
    "data-name": "Path 62446",
    className: "cls-194",
    d: "M792.915,493.764l-.9-.517v1.035Z",
    transform: "translate(-792.019 -493.247)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62447",
    "data-name": "Path 62447",
    className: "cls-220",
    d: "M585.383,293.593l.814,1.3,8.354-4.824-1.2-1.08Z",
    transform: "translate(-560.764 -276.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62448",
    "data-name": "Path 62448",
    className: "cls-126",
    d: "M615,620.427l-.327-.188v2.931l.327.189Z",
    transform: "translate(-588.82 -594.154)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63600",
    "data-name": "Group 63600",
    transform: "translate(25.85 25.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63599",
    "data-name": "Group 63599",
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23380",
    "data-name": "Rectangle 23380",
    className: "cls-222",
    width: 2.576,
    height: 2.178,
    transform: "translate(-0.518 0.3) rotate(-30.04)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63602",
    "data-name": "Group 63602",
    transform: "translate(32.461 21.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63601",
    "data-name": "Group 63601",
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23381",
    "data-name": "Rectangle 23381",
    className: "cls-224",
    width: 2.453,
    height: 2.178,
    transform: "matrix(0.866, -0.501, 0.501, 0.866, -0.572, 0.331)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63610",
    "data-name": "Group 63610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63609",
    "data-name": "Group 63609",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62451",
    "data-name": "Path 62451",
    className: "cls-125",
    d: "M614.912,616.931l-.241.139.326.188h.428l.027-.016Z",
    transform: "translate(-588.821 -590.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62452",
    "data-name": "Path 62452",
    className: "cls-125",
    d: "M459.567,220.954l7.973-4.6,5.291,3.055-7.973,4.6Z",
    transform: "translate(-440.24 -207.252)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63605",
    "data-name": "Group 63605",
    className: "cls-132",
    transform: "translate(19.327 9.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63604",
    "data-name": "Group 63604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63603",
    "data-name": "Group 63603",
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62453",
    "data-name": "Path 62453",
    className: "cls-212",
    d: "M467.54,216.35l-7.973,4.6.775.448h.118l7.914-4.569Z",
    transform: "translate(-459.567 -216.35)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63608",
    "data-name": "Group 63608",
    className: "cls-45",
    transform: "translate(26.063 12.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63607",
    "data-name": "Group 63607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63606",
    "data-name": "Group 63606",
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62454",
    "data-name": "Path 62454",
    className: "cls-47",
    d: "M622.183,302.248l-.13-.075-2.322,1.62h.243a.674.674,0,0,0,.33-.079l1.879-1.085a.2.2,0,0,0,0-.381",
    transform: "translate(-619.731 -302.173)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62455",
    "data-name": "Path 62455",
    className: "cls-217",
    d: "M550.28,283.273l1.861,1.075h.207l-1.861-1.075Z",
    transform: "translate(-527.138 -271.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62456",
    "data-name": "Path 62456",
    className: "cls-127",
    d: "M545.563,283.273l-.207.239,1.862,1.075.207-.239Z",
    transform: "translate(-522.421 -271.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62457",
    "data-name": "Path 62457",
    className: "cls-127",
    d: "M545.356,283.513v-.239h.207Z",
    transform: "translate(-522.421 -271.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62458",
    "data-name": "Path 62458",
    className: "cls-217",
    d: "M580.405,265.881l1.861,1.075h.207l-1.861-1.075Z",
    transform: "translate(-555.996 -254.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62459",
    "data-name": "Path 62459",
    className: "cls-127",
    d: "M575.688,265.881l-.207.239,1.861,1.075.207-.239Z",
    transform: "translate(-551.279 -254.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62460",
    "data-name": "Path 62460",
    className: "cls-127",
    d: "M575.482,266.12v-.239h.207Z",
    transform: "translate(-551.279 -254.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62461",
    "data-name": "Path 62461",
    className: "cls-217",
    d: "M490.03,318.059l4.183,2.415h.207l-4.183-2.415Z",
    transform: "translate(-469.421 -304.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62462",
    "data-name": "Path 62462",
    className: "cls-217",
    d: "M584.567,375.722h.414l-.207-.239Z",
    transform: "translate(-559.982 -359.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62463",
    "data-name": "Path 62463",
    className: "cls-227",
    d: "M589.7,375.483v.239l-.207-.239Z",
    transform: "translate(-564.699 -359.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62464",
    "data-name": "Path 62464",
    className: "cls-127",
    d: "M485.313,318.059l-.207.239,4.183,2.415.207-.239Z",
    transform: "translate(-464.704 -304.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62465",
    "data-name": "Path 62465",
    className: "cls-127",
    d: "M485.106,318.3v-.239h.207Z",
    transform: "translate(-464.704 -304.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62466",
    "data-name": "Path 62466",
    className: "cls-217",
    d: "M520.155,300.666l4.183,2.415h.207l-4.183-2.415Z",
    transform: "translate(-498.279 -288.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62467",
    "data-name": "Path 62467",
    className: "cls-217",
    d: "M614.692,358.329h.414l-.207-.239Z",
    transform: "translate(-588.84 -343.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62468",
    "data-name": "Path 62468",
    className: "cls-227",
    d: "M619.823,358.09v.239l-.207-.239Z",
    transform: "translate(-593.557 -343.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62469",
    "data-name": "Path 62469",
    className: "cls-127",
    d: "M515.438,300.666l-.207.239,4.183,2.415.207-.239Z",
    transform: "translate(-493.563 -288.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62470",
    "data-name": "Path 62470",
    className: "cls-127",
    d: "M515.231,300.906v-.239h.207Z",
    transform: "translate(-493.563 -288.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62471",
    "data-name": "Path 62471",
    className: "cls-217",
    d: "M610.531,248.488l4.183,2.415h.207l-4.183-2.415Z",
    transform: "translate(-584.854 -238.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62472",
    "data-name": "Path 62472",
    className: "cls-217",
    d: "M705.068,306.151h.414l-.207-.239Z",
    transform: "translate(-675.415 -293.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62473",
    "data-name": "Path 62473",
    className: "cls-227",
    d: "M710.2,305.912v.239l-.207-.239Z",
    transform: "translate(-680.132 -293.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62474",
    "data-name": "Path 62474",
    className: "cls-127",
    d: "M605.814,248.488l-.207.239,4.183,2.415L610,250.9Z",
    transform: "translate(-580.137 -238.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62475",
    "data-name": "Path 62475",
    className: "cls-127",
    d: "M605.607,248.727v-.239h.207Z",
    transform: "translate(-580.138 -238.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62476",
    "data-name": "Path 62476",
    className: "cls-217",
    d: "M640.656,231.095l4.183,2.415h.207l-4.183-2.415Z",
    transform: "translate(-613.713 -221.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62477",
    "data-name": "Path 62477",
    className: "cls-217",
    d: "M735.193,288.758h.414l-.207-.239Z",
    transform: "translate(-704.274 -276.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62478",
    "data-name": "Path 62478",
    className: "cls-227",
    d: "M740.324,288.519v.239l-.207-.239Z",
    transform: "translate(-708.991 -276.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62479",
    "data-name": "Path 62479",
    className: "cls-127",
    d: "M635.939,231.1l-.207.239,4.183,2.415.207-.239Z",
    transform: "translate(-608.996 -221.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62480",
    "data-name": "Path 62480",
    className: "cls-127",
    d: "M635.732,231.334V231.1h.207Z",
    transform: "translate(-608.996 -221.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63612",
    "data-name": "Group 63612",
    transform: "translate(24.561 12.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63611",
    "data-name": "Group 63611",
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23385",
    "data-name": "Rectangle 23385",
    className: "cls-229",
    width: 3.823,
    height: 1.782,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63683",
    "data-name": "Group 63683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63682",
    "data-name": "Group 63682",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62482",
    "data-name": "Path 62482",
    className: "cls-53",
    d: "M587.7,279.32l-1.012-.584a.728.728,0,0,0-.659,0l-1.879,1.085a.2.2,0,0,0,0,.381l1.012.584a.728.728,0,0,0,.659,0L587.7,279.7a.2.2,0,0,0,0-.381",
    transform: "translate(-559.452 -266.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62483",
    "data-name": "Path 62483",
    className: "cls-217",
    d: "M634.274,331.767l.651.376h.207l-.651-.376Z",
    transform: "translate(-607.599 -317.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62484",
    "data-name": "Path 62484",
    className: "cls-217",
    d: "M644.817,340.937h.414l-.207-.239Z",
    transform: "translate(-617.699 -326.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62485",
    "data-name": "Path 62485",
    className: "cls-227",
    d: "M649.948,340.7v.239l-.207-.239Z",
    transform: "translate(-622.415 -326.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62486",
    "data-name": "Path 62486",
    className: "cls-127",
    d: "M629.557,331.767l-.207.239.65.376.207-.239Z",
    transform: "translate(-602.882 -317.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62487",
    "data-name": "Path 62487",
    className: "cls-217",
    d: "M664.4,314.374l.65.376h.207l-.65-.376Z",
    transform: "translate(-636.457 -301.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62488",
    "data-name": "Path 62488",
    className: "cls-217",
    d: "M674.942,323.544h.414l-.207-.239Z",
    transform: "translate(-646.557 -309.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62489",
    "data-name": "Path 62489",
    className: "cls-227",
    d: "M680.073,323.3v.239l-.207-.239Z",
    transform: "translate(-651.274 -309.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62490",
    "data-name": "Path 62490",
    className: "cls-127",
    d: "M659.682,314.374l-.207.239.65.376.207-.239Z",
    transform: "translate(-631.741 -301.153)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63615",
    "data-name": "Group 63615",
    className: "cls-230",
    transform: "translate(27.735 13.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63614",
    "data-name": "Group 63614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63613",
    "data-name": "Group 63613",
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62491",
    "data-name": "Path 62491",
    className: "cls-47",
    d: "M659.609,314.69l.146-.274-.073-.042-.207.239Z",
    transform: "translate(-659.475 -314.374)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63618",
    "data-name": "Group 63618",
    className: "cls-213",
    transform: "translate(27.942 13.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63617",
    "data-name": "Group 63617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63616",
    "data-name": "Group 63616",
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62492",
    "data-name": "Path 62492",
    className: "cls-47",
    d: "M664.74,314.452l-.268-.035-.073-.042h.207Z",
    transform: "translate(-664.399 -314.374)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63621",
    "data-name": "Group 63621",
    className: "cls-230",
    transform: "translate(26.468 13.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63620",
    "data-name": "Group 63620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63619",
    "data-name": "Group 63619",
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62493",
    "data-name": "Path 62493",
    className: "cls-47",
    d: "M629.482,332.083l.148-.273-.073-.042-.207.239Z",
    transform: "translate(-629.35 -331.767)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63624",
    "data-name": "Group 63624",
    className: "cls-213",
    transform: "translate(26.675 13.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63623",
    "data-name": "Group 63623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63622",
    "data-name": "Group 63622",
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62494",
    "data-name": "Path 62494",
    className: "cls-47",
    d: "M634.615,331.845l-.268-.035-.073-.042h.207Z",
    transform: "translate(-634.274 -331.767)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63627",
    "data-name": "Group 63627",
    className: "cls-234",
    transform: "translate(23.142 11.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63626",
    "data-name": "Group 63626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63625",
    "data-name": "Group 63625",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62495",
    "data-name": "Path 62495",
    className: "cls-212",
    d: "M550.281,283.273l.372.215h.207l-.372-.215Z",
    transform: "translate(-550.281 -283.273)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63630",
    "data-name": "Group 63630",
    className: "cls-234",
    transform: "translate(22.935 11.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63629",
    "data-name": "Group 63629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63628",
    "data-name": "Group 63628",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62496",
    "data-name": "Path 62496",
    className: "cls-212",
    d: "M545.564,283.273l.372.215-.207.239-.372-.215Z",
    transform: "translate(-545.357 -283.273)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63633",
    "data-name": "Group 63633",
    className: "cls-237",
    transform: "translate(22.935 11.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63632",
    "data-name": "Group 63632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63631",
    "data-name": "Group 63631",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62497",
    "data-name": "Path 62497",
    className: "cls-212",
    d: "M545.357,283.513v-.239h.207Z",
    transform: "translate(-545.357 -283.274)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63636",
    "data-name": "Group 63636",
    className: "cls-234",
    transform: "translate(24.409 11.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63635",
    "data-name": "Group 63635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63634",
    "data-name": "Group 63634",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62498",
    "data-name": "Path 62498",
    className: "cls-212",
    d: "M580.406,265.881l.372.215h.207l-.372-.215Z",
    transform: "translate(-580.406 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63639",
    "data-name": "Group 63639",
    className: "cls-234",
    transform: "translate(24.202 11.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63638",
    "data-name": "Group 63638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63637",
    "data-name": "Group 63637",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62499",
    "data-name": "Path 62499",
    className: "cls-212",
    d: "M575.689,265.881l.372.215-.207.239-.372-.215Z",
    transform: "translate(-575.482 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63642",
    "data-name": "Group 63642",
    className: "cls-237",
    transform: "translate(24.202 11.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63641",
    "data-name": "Group 63641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63640",
    "data-name": "Group 63640",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62500",
    "data-name": "Path 62500",
    className: "cls-212",
    d: "M575.482,266.121v-.239h.207Z",
    transform: "translate(-575.482 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63645",
    "data-name": "Group 63645",
    className: "cls-234",
    transform: "translate(20.609 13.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63644",
    "data-name": "Group 63644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63643",
    "data-name": "Group 63643",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62501",
    "data-name": "Path 62501",
    className: "cls-212",
    d: "M490.03,318.059l.372.215h.207l-.372-.215Z",
    transform: "translate(-490.03 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63648",
    "data-name": "Group 63648",
    className: "cls-234",
    transform: "translate(20.401 13.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63647",
    "data-name": "Group 63647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63646",
    "data-name": "Group 63646",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62502",
    "data-name": "Path 62502",
    className: "cls-212",
    d: "M485.313,318.059l.372.215-.207.239-.372-.215Z",
    transform: "translate(-485.106 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63651",
    "data-name": "Group 63651",
    className: "cls-237",
    transform: "translate(20.401 13.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63650",
    "data-name": "Group 63650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63649",
    "data-name": "Group 63649",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62503",
    "data-name": "Path 62503",
    className: "cls-212",
    d: "M485.106,318.3v-.239h.207Z",
    transform: "translate(-485.106 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63654",
    "data-name": "Group 63654",
    className: "cls-234",
    transform: "translate(21.875 12.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63653",
    "data-name": "Group 63653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63652",
    "data-name": "Group 63652",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62504",
    "data-name": "Path 62504",
    className: "cls-212",
    d: "M520.155,300.666l.372.215h.207l-.372-.215Z",
    transform: "translate(-520.155 -300.666)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63657",
    "data-name": "Group 63657",
    className: "cls-234",
    transform: "translate(21.668 12.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63656",
    "data-name": "Group 63656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63655",
    "data-name": "Group 63655",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62505",
    "data-name": "Path 62505",
    className: "cls-212",
    d: "M515.438,300.666l.372.215-.207.239-.372-.215Z",
    transform: "translate(-515.231 -300.666)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63660",
    "data-name": "Group 63660",
    className: "cls-237",
    transform: "translate(21.668 12.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63659",
    "data-name": "Group 63659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63658",
    "data-name": "Group 63658",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62506",
    "data-name": "Path 62506",
    className: "cls-212",
    d: "M515.231,300.906v-.239h.207Z",
    transform: "translate(-515.231 -300.667)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63663",
    "data-name": "Group 63663",
    className: "cls-234",
    transform: "translate(25.676 10.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63662",
    "data-name": "Group 63662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63661",
    "data-name": "Group 63661",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62507",
    "data-name": "Path 62507",
    className: "cls-212",
    d: "M610.532,248.488l.372.215h.207l-.372-.215Z",
    transform: "translate(-610.532 -248.488)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63666",
    "data-name": "Group 63666",
    className: "cls-234",
    transform: "translate(25.469 10.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63665",
    "data-name": "Group 63665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63664",
    "data-name": "Group 63664",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62508",
    "data-name": "Path 62508",
    className: "cls-212",
    d: "M605.815,248.488l.372.215-.207.239-.372-.215Z",
    transform: "translate(-605.608 -248.488)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63669",
    "data-name": "Group 63669",
    className: "cls-237",
    transform: "translate(25.469 10.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63668",
    "data-name": "Group 63668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63667",
    "data-name": "Group 63667",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62509",
    "data-name": "Path 62509",
    className: "cls-212",
    d: "M605.608,248.728v-.239h.207Z",
    transform: "translate(-605.608 -248.489)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63672",
    "data-name": "Group 63672",
    className: "cls-234",
    transform: "translate(26.943 9.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63671",
    "data-name": "Group 63671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63670",
    "data-name": "Group 63670",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62510",
    "data-name": "Path 62510",
    className: "cls-212",
    d: "M640.657,231.1l.372.215h.207l-.372-.215Z",
    transform: "translate(-640.657 -231.096)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63675",
    "data-name": "Group 63675",
    className: "cls-234",
    transform: "translate(26.736 9.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63674",
    "data-name": "Group 63674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63673",
    "data-name": "Group 63673",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62511",
    "data-name": "Path 62511",
    className: "cls-212",
    d: "M635.94,231.1l.372.215-.207.239-.372-.215Z",
    transform: "translate(-635.733 -231.096)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63678",
    "data-name": "Group 63678",
    className: "cls-237",
    transform: "translate(26.736 9.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63677",
    "data-name": "Group 63677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63676",
    "data-name": "Group 63676",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62512",
    "data-name": "Path 62512",
    className: "cls-212",
    d: "M635.733,231.335V231.1h.207Z",
    transform: "translate(-635.733 -231.096)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62513",
    "data-name": "Path 62513",
    className: "cls-199",
    d: "M627.663,395.594l-.725-.35-1.025.591c-.582-.251-1.453.252-2.035,1.175l-4.707,2.718.137.69.428.952,7.926-4.576Z",
    transform: "translate(-593.131 -378.622)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63681",
    "data-name": "Group 63681",
    className: "cls-70",
    transform: "translate(25.745 13.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63680",
    "data-name": "Group 63680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63679",
    "data-name": "Group 63679",
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62514",
    "data-name": "Path 62514",
    className: "cls-216",
    d: "M620.158,328.188,613.39,332.1c-.227.131-.459,0-.518-.3l-.695-3.49,7.591-4.383.695,3.49a.766.766,0,0,1-.3.775",
    transform: "translate(-612.177 -323.923)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63685",
    "data-name": "Group 63685",
    transform: "translate(26.697 13.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63684",
    "data-name": "Group 63684",
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23410",
    "data-name": "Rectangle 23410",
    className: "cls-241",
    width: 10.863,
    height: 10.575,
    transform: "translate(-3.508 6.298) rotate(-60.884)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63687",
    "data-name": "Group 63687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63686",
    "data-name": "Group 63686",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62516",
    "data-name": "Path 62516",
    className: "cls-215",
    d: "M613.094,314.669l-8.354,4.823.744,3.739.428.952,7.926-4.576v-1.2Zm.055,4.721-6.768,3.908c-.227.131-.459,0-.518-.3l-.695-3.49,7.591-4.383.695,3.49a.766.766,0,0,1-.3.775",
    transform: "translate(-579.307 -301.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62517",
    "data-name": "Path 62517",
    className: "cls-242",
    d: "M679.939,475.9l.088.051,1.237-.714-.088-.051Z",
    transform: "translate(-651.344 -455.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62518",
    "data-name": "Path 62518",
    className: "cls-243",
    d: "M680.027,492.213l-.088-.051.1.092.088.051Z",
    transform: "translate(-651.344 -471.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62519",
    "data-name": "Path 62519",
    className: "cls-52",
    d: "M683.26,476.391l-1.237.714.1.092,1.159-.669Z",
    transform: "translate(-653.34 -456.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62520",
    "data-name": "Path 62520",
    className: "cls-242",
    d: "M647.581,480.526l.088.051,2.03-1.172-.088-.051Z",
    transform: "translate(-620.346 -459.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62521",
    "data-name": "Path 62521",
    className: "cls-52",
    d: "M651.7,480.557l-2.03,1.172.027.136,2.03-1.172Z",
    transform: "translate(-622.343 -460.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62522",
    "data-name": "Path 62522",
    className: "cls-244",
    d: "M647.669,507.279l-.088-.051.027.136.088.051Z",
    transform: "translate(-620.346 -485.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62523",
    "data-name": "Path 62523",
    className: "cls-242",
    d: "M752.912,433.77l.088.051,1.237-.714-.088-.051Z",
    transform: "translate(-721.248 -414.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62524",
    "data-name": "Path 62524",
    className: "cls-243",
    d: "M753,450.082l-.088-.051.1.092.088.051Z",
    transform: "translate(-721.248 -431.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62525",
    "data-name": "Path 62525",
    className: "cls-52",
    d: "M756.233,434.259l-1.236.714.1.092,1.159-.669Z",
    transform: "translate(-723.245 -415.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62526",
    "data-name": "Path 62526",
    className: "cls-242",
    d: "M720.554,438.395l.088.051,2.03-1.172-.088-.051Z",
    transform: "translate(-690.251 -418.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62527",
    "data-name": "Path 62527",
    className: "cls-52",
    d: "M724.668,438.426l-2.03,1.172.027.136,2.03-1.172Z",
    transform: "translate(-692.247 -419.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62528",
    "data-name": "Path 62528",
    className: "cls-244",
    d: "M720.642,465.147l-.088-.051.027.136.088.051Z",
    transform: "translate(-690.251 -445.537)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63689",
    "data-name": "Group 63689",
    transform: "translate(25.192 22.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63688",
    "data-name": "Group 63688",
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23412",
    "data-name": "Rectangle 23412",
    className: "cls-246",
    width: 0.753,
    height: 2.306
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63697",
    "data-name": "Group 63697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63696",
    "data-name": "Group 63696",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63692",
    "data-name": "Group 63692",
    className: "cls-213",
    transform: "translate(25.192 22.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63691",
    "data-name": "Group 63691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63690",
    "data-name": "Group 63690",
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62530",
    "data-name": "Path 62530",
    className: "cls-212",
    d: "M599.014,538.451l.13.114.414,1.137a3.047,3.047,0,0,0,.209.48v-.42c-.017-.043-.035-.09-.054-.141l-.3-.819.241.211.111.378v-.506Z",
    transform: "translate(-599.014 -538.451)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62531",
    "data-name": "Path 62531",
    className: "cls-125",
    d: "M599.014,582.948l.753.26v.174Z",
    transform: "translate(-573.822 -558.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62532",
    "data-name": "Path 62532",
    className: "cls-248",
    d: "M626.73,605.513l-.439-.253.439-.1Z",
    transform: "translate(-599.952 -579.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62533",
    "data-name": "Path 62533",
    className: "cls-52",
    d: "M643.665,509.882v.353l-6.94,4.007v-.353Z",
    transform: "translate(-609.947 -488.438)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63695",
    "data-name": "Group 63695",
    className: "cls-213",
    transform: "translate(22.669 21.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63694",
    "data-name": "Group 63694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63693",
    "data-name": "Group 63693",
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62534",
    "data-name": "Path 62534",
    className: "cls-212",
    d: "M539.628,500.656l-.112-.4-.481.421.116.414.252.145c.136.078.246.015.246-.142v-.314a.424.424,0,0,0-.019-.122",
    transform: "translate(-539.034 -500.254)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63699",
    "data-name": "Group 63699",
    transform: "translate(22.554 20.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63698",
    "data-name": "Group 63698",
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23416",
    "data-name": "Rectangle 23416",
    className: "cls-251",
    width: 1.075,
    height: 1.291,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, -0.471, 0.25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63713",
    "data-name": "Group 63713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63712",
    "data-name": "Group 63712",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62536",
    "data-name": "Path 62536",
    className: "cls-163",
    d: "M536.782,491.461v.314c0,.157-.11.22-.246.142l-.252-.145v-.881l.252.145a.543.543,0,0,1,.246.426",
    transform: "translate(-513.731 -470.245)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63702",
    "data-name": "Group 63702",
    className: "cls-144",
    transform: "translate(33.783 12.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63701",
    "data-name": "Group 63701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63700",
    "data-name": "Group 63700",
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62537",
    "data-name": "Path 62537",
    className: "cls-52",
    d: "M803.57,300.946l.294.17-.212-1.066-.368-.543Z",
    transform: "translate(-803.284 -299.507)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63705",
    "data-name": "Group 63705",
    className: "cls-67",
    transform: "translate(25.428 12.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63704",
    "data-name": "Group 63704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63703",
    "data-name": "Group 63703",
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62538",
    "data-name": "Path 62538",
    className: "cls-254",
    d: "M604.631,304.33l.368.543,8.354-4.823-.368-.543Z",
    transform: "translate(-604.631 -299.507)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63708",
    "data-name": "Group 63708",
    className: "cls-67",
    transform: "translate(25.796 13.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63707",
    "data-name": "Group 63707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63706",
    "data-name": "Group 63706",
    className: "cls-255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62539",
    "data-name": "Path 62539",
    className: "cls-52",
    d: "M621.734,312.41l-8.354,4.823.212,1.066,8.354-4.823Z",
    transform: "translate(-613.38 -312.41)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63711",
    "data-name": "Group 63711",
    className: "cls-67",
    transform: "translate(25.428 17.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63710",
    "data-name": "Group 63710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63709",
    "data-name": "Group 63709",
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62540",
    "data-name": "Path 62540",
    className: "cls-256",
    d: "M604.918,415.638l.294.17L605,414.742l-.368-.543Z",
    transform: "translate(-604.631 -414.199)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63718",
    "data-name": "Group 63718",
    transform: "translate(24.234 21.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63717",
    "data-name": "Group 63717",
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63716",
    "data-name": "Group 63716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63715",
    "data-name": "Group 63715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63714",
    "data-name": "Group 63714",
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23422",
    "data-name": "Rectangle 23422",
    width: 1.03,
    height: 0.767,
    transform: "translate(-0.01 -0.017)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAIAAADm2DRVAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAJgAAAABExXeQAAAEXUlEQVRYCcWYvW7UQBDH7YvvgMcAJBoCCIIED4Ao+egSCiQaQDQpoCMlaRFUBAq+hBK6iAYJngAkIoFIQQPPAfGdzW9m7LVvvY6T4xKsiz27O7v78/xn13bi1Ucr0fgRR/HMTI8jSeTST2ZiPY6emuU37ruHpfjS4TPe8GD0+8mg3x8MksGgf+jgAQCpvHh9np/nvHfFXnDoOIpiQscRbN6XyhYygRIqu5i9LzzVJGEybc/Nq7hUXfbJCpNBkyvR/8Li7sNkkSNyxp5F6uPrt8Gxk2AtISvrnVFWTO/689smWJyD+1EbWaEmGLnpOj0gG+nJ3SWYzP7wau3Ow2VvhhY1Pa+pFonTvQtXDIvbzrLsx8bX98/feJMEyGS7iGPdXMV5ilsaNDC5xIJpNBptpcOtrXR95aVHFlKT1LLssvM0tluYLKVsekI1EqxsCJocgri+8uLq7RuOL0BWUOXVKnDekxn1lILJsNIUKqJWwA2H2dvHz46dPnn83JzNElBTG1zcJoMpejVTCpw/W+lv/hAxTeWaDtN0JOfhaPXxUzdfIGau7V8M5CNUbgSLk8in+lm4VESpscjhs/lp4/unLyfOn6VjK9nEe0UzpXRiVU2xLMMst+QskmbuHtDUyIJqlpm2ezrkc1llcSIkKpmolQ5FskI7CtjkVw0Lvs3PG2uqaSBmvP7gwTtj8bqhm23n6wZM/NytM5/GZmRiSbprcKxoYQPd+dcNwraweCtAVkas7ryd3ZRP9wFNKfg0pwiNoRluloWZ3DSELUBWNtO5o3+TKWOjkjSXEJHZglieiaLmepVS5UT+dfbcXDhmvmNLuS4funDo3KSO0FiIhLKAk4qWkapqmOYXb3asTXFvCZnHhKMqlo1vnqCUMUO8lpSqoKLowepTY7LKBEyWQ90DW4TUZ4AaFWBAPt3EVT1IkJKjABJcgrcDJuKEfB5DMns+QGZO8sBEozya0XJ96Yl2klKy9BSGTBfhZElKJVeh8iZrFuvyea2BFSCRlxs1BYSu3odaDkspwaqjlNHSSI31qo9g9jZM5hAgswadnsBIuvR6/HrGaLlNSllU2DYlPmhqEROzg4nxg/LZvO4cJlOavNdDFySNoeTbmD6mHEU4VEZlKuTckXw7YTI4mfXykeLFw/Fi8IHeT+TgPwnyb4QYT/n8tOeJEGXwSaBU0H9Kqfq8zpZIcB88EFyVGUwa5cKd5wkQiIklK02TDErB0sVIjdfXK3amlOdvRSGjZ7MNiDRHy36ep7x763NTGPiTtKc5EqPZ0avZuXxeR4kEVfcXbjZ3NeoBAgpBsQ0Lg2UhYF0HN7y85kvR1alqL8h4X1u65u91ldcurcnk8yYp1iaPBYYLhs3r0Fn0HjKd/m0ORcysuU3Tts5e/cQp5Y1jxbF3WoYOroZgz3olvd792mg+++o+u7XHYmaddxW5qaRUEDpAZn68VfIls03mTVe7JlwrmXO17wVXnK5kbtim8ReW3AB+9gKHzwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63720",
    "data-name": "Group 63720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63719",
    "data-name": "Group 63719",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62542",
    "data-name": "Path 62542",
    className: "cls-52",
    d: "M576.735,516.237a.235.235,0,0,0-.214-.2l-.007,0a.13.13,0,0,1,0-.027v-.435h-.275v.435a.3.3,0,0,0,.137.27.255.255,0,0,0,.129.034.349.349,0,0,0,.173-.05Z",
    transform: "translate(-552.002 -493.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63722",
    "data-name": "Group 63722",
    transform: "translate(25.075 21.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63721",
    "data-name": "Group 63721",
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23425",
    "data-name": "Rectangle 23425",
    className: "cls-260",
    width: 0.318,
    height: 0.338,
    transform: "translate(-0.125 0.067) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63724",
    "data-name": "Group 63724",
    transform: "translate(23.785 19.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63723",
    "data-name": "Group 63723",
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23426",
    "data-name": "Rectangle 23426",
    className: "cls-262",
    width: 2.94,
    height: 2.343,
    transform: "translate(-1.184 2.064) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63729",
    "data-name": "Group 63729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63728",
    "data-name": "Group 63728",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63727",
    "data-name": "Group 63727",
    className: "cls-144",
    transform: "translate(24.371 19.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63726",
    "data-name": "Group 63726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63725",
    "data-name": "Group 63725",
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62545",
    "data-name": "Path 62545",
    className: "cls-152",
    d: "M580.011,458.785a.108.108,0,0,0-.108.011l-.107.062a.117.117,0,0,1-.059.016h-.231v.159h.06l.275-.159.1-.057a.108.108,0,0,1,.108-.011Z",
    transform: "translate(-579.506 -458.775)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62546",
    "data-name": "Path 62546",
    className: "cls-52",
    d: "M571.078,459.29l-.669.386a.339.339,0,0,0-.153.265V461.8c0,.1.069.137.153.088l.669-.386a.339.339,0,0,0,.153-.265v-1.857c0-.1-.069-.137-.153-.088",
    transform: "translate(-546.273 -439.954)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63734",
    "data-name": "Group 63734",
    transform: "translate(24.234 18.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63733",
    "data-name": "Group 63733",
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63732",
    "data-name": "Group 63732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63731",
    "data-name": "Group 63731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63730",
    "data-name": "Group 63730",
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23429",
    "data-name": "Rectangle 23429",
    width: 1.03,
    height: 1.312,
    transform: "translate(-0.01 -0.013)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAABBCAIAAADzKQu3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAQQAAAABv19zNAAAFTElEQVRoBc2aP4/cRBjGd6P7IhRICBEUiUjkAyDqlKGhTMqIP10ooYooEqGgUCABUi6UKQFRQ0SCAkmkFAnfI+ezl9/zvvZ4Zmzv3t2u7XX2dsfe9cxvn+eZ1+O7LFer1WK+7dU/z3h8+PGVLsJB99BkR3798T4PH64Lt5xFs5gJMhi+/v1BpsjUZHgHFs+Bo6qq47J84/zbn3xzMxykMZ2bvUwlWHCV5fOHf7949OStixcC3ESade1DqsKYyrLiH89vXnj3xve3A9nomiHVt599EcYjUm6fpKIlrFq2f//469nDx++8/55/eETNeu0zmRQsqSQmyWWyVaWxPvjvsZONpRk6xTFHKtPm2FIlnaChLdVKkHitvEoc3rr70fVrwO1es95IIUfDZAopWRYv08mplsvac5dtl2RZpBjHNJF3RXEs7zzqLpiZyEGq2SJAGRtR++rwu9242Rsps0xSQWahMp0wUbuWfCyTbY1WtWQL5sHTPx/tgKwbKZQIFcGxHK3OO29XK3hyooaMV+C2IuuJ1GpFyJtomzx4JzoJxsYTK4iOTBHUYvHlvbvnL108I1nXvto7MwoKIhX4mmPMPjGtkerK9as+MSE9NVmXyZWwqefaSB1aeKe3bA4SdDENQ3nqY+lOR/bLD4e//fRzOD8p6KaMMQnLNseqltrCSXkDJqTCvuyNk5K9fPLU1wg+iJgonlalXC1XDoW0a5pZlSLpw1BNpDIm3z1RPUMqsPwErYDrgu7FE4z62sdLPRMFtc47+ogj5T1nz5s1u/PpDbLlp7lUddm0hCtG2mScxCrtIrPJPgppxtHd3UCWYaHP0ZFKFV5aQTfnmuIOmLwbtm8oUl0sjqwji7EsVdRP9FK5kkoVOZNgRod7GyK10b6Mb5AsruxgCagAQljQCcykAk1rBNMq6zrsnpbJT+wnI1g8GM7rQsElWSaaQqIrAVWkvI8d2Re+ySAZTGEVijAgBQeNyXQrWSP4BTnrsN49VaR6u+jRLBQI98uwZF+BdKTK5NI1Zqm7MdnY2c5mX9ZNTubllA8xqjjMNbCYkoKz7LvL3lEGtxMm7zkhw8dYMPkoKxUsgi6xtHrpL87b27dOs4DFzPMJSMOU06wk8sxBRIq7cDd93RIf377daubzkR4ZG5GQSQ+zz/j6sZDqJAX9DKAtWRCM4Esnfho40ibetHvUGg+LoVoyNHPBvIpqYqqC+QLQ5mDEBtYYDsbf/ZzvBMGQRppJNhrcJOoSnaXe1equqOJ+t2/Xif78g8veFxPw9WtdtZkBR0VRHMnVLPiQhTvp7QmGepBmQbDaQV7QzKxEvC4WPg51t8PjtZveI8YJDpzKlqy8RNniM6hFLR3bR4dJNMM4g/HlDVHTeiuDYz7uUJg1XbWaIRSiIFbYuqeBNY1gDN2S1XnKqlZE51ZGB8ZtHngZ0yDY5qkCTq1mNwKYTDDGPBfI4HEfVcyshUiBKm6Hg6M2WjeBSXRKbUVAZuWoKFnnkWYykHeXXjJSMNWL7Myxd9uceayMTjfgPvD0QOELt26GQ3vSGCCb2roeNRIy5zEH50eLyVqattXzZSY61JI1gtUDzw7XkjW/pQRJ95LUiYnEGRgmIuOaxIdsIaQ1ULr+GTh9xMMJmV0ubbCZ9RJDSmYWYuMegOVkwZ352VLN4HGk+cFSzYxHdHsAlpDtA0+IU0KmOmHFQvfA7UdmaqU5sxqmpz2QLyVTxmaSqDNsSta8vQ94GVlACo0GdvLXjEzj6xowP1gyNyeXZe2AB/7fqygW3NXZ3yL4VZ7+ZMotZ3biZL/R8HH/BzauqKDQEZ5hAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63736",
    "data-name": "Group 63736",
    transform: "translate(25.075 18.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63735",
    "data-name": "Group 63735",
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23431",
    "data-name": "Rectangle 23431",
    className: "cls-267",
    width: 0.318,
    height: 0.338,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.125, 0.067)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63738",
    "data-name": "Group 63738",
    transform: "translate(24.234 19.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63737",
    "data-name": "Group 63737",
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23432",
    "data-name": "Rectangle 23432",
    className: "cls-269",
    width: 0.275,
    height: 0.159
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63740",
    "data-name": "Group 63740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63739",
    "data-name": "Group 63739",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62550",
    "data-name": "Path 62550",
    className: "cls-52",
    d: "M660.987,535.628l4.094-2.364.344-1.223-.227-.131-4.866,2.81.364.21Z",
    transform: "translate(-632.562 -509.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62551",
    "data-name": "Path 62551",
    className: "cls-147",
    d: "M773.74,532.7l-.32-.185-.047.168.182.105-.3,1.055.138.079Z",
    transform: "translate(-740.739 -510.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62552",
    "data-name": "Path 62552",
    className: "cls-147",
    d: "M666.711,586.753l.132.13.32.185-.369-.363Z",
    transform: "translate(-638.672 -562.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62553",
    "data-name": "Path 62553",
    className: "cls-138",
    d: "M640.539,432.091l-7.926,4.576v2.8l1.517-.876.369.363,4.154-2.4.369-.789,1.517-.876Z",
    transform: "translate(-606.008 -413.919)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23433",
    "data-name": "Rectangle 23433",
    className: "cls-270",
    width: 0.428,
    height: 2.931,
    transform: "translate(26.177 26.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62554",
    "data-name": "Path 62554",
    className: "cls-138",
    d: "M639.009,516.788l-.344,1.223-4.179,2.413-.344-.826-1.53.883v2.931l7.926-4.576V515.9Z",
    transform: "translate(-606.008 -494.208)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63742",
    "data-name": "Group 63742",
    transform: "translate(33.188 18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63741",
    "data-name": "Group 63741",
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23435",
    "data-name": "Rectangle 23435",
    className: "cls-272",
    width: 2.078,
    height: 2.596,
    transform: "translate(-1.041 0.597) rotate(-29.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63744",
    "data-name": "Group 63744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63743",
    "data-name": "Group 63743",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62556",
    "data-name": "Path 62556",
    className: "cls-273",
    d: "M632.112,642.489l-.1-.242-1.51.872h-.093v.353Z",
    transform: "translate(-603.897 -615.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62557",
    "data-name": "Path 62557",
    className: "cls-274",
    d: "M624.471,648l-1.7.983H622.6l-.169.1h.428l1.741-1.005Z",
    transform: "translate(-596.256 -620.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62558",
    "data-name": "Path 62558",
    className: "cls-147",
    d: "M668.584,641.147l-.08.046.1.242.131.075Z",
    transform: "translate(-640.39 -614.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62559",
    "data-name": "Path 62559",
    className: "cls-138",
    d: "M622.433,662.969h.169v.353l-.169.1Z",
    transform: "translate(-596.256 -635.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23436",
    "data-name": "Rectangle 23436",
    className: "cls-275",
    width: 0.167,
    height: 0.353,
    transform: "translate(26.346 27.882)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63746",
    "data-name": "Group 63746",
    transform: "translate(26.936 22.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63745",
    "data-name": "Group 63745",
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23438",
    "data-name": "Rectangle 23438",
    className: "cls-277",
    width: 1.781,
    height: 2.063,
    transform: "matrix(0.864, -0.504, 0.504, 0.864, -0.783, 0.457)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63748",
    "data-name": "Group 63748",
    transform: "translate(26.967 22.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63747",
    "data-name": "Group 63747",
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23439",
    "data-name": "Rectangle 23439",
    className: "cls-279",
    width: 1.515,
    height: 1.843,
    transform: "translate(-0.562 0.233) rotate(-22.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63750",
    "data-name": "Group 63750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63749",
    "data-name": "Group 63749",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62562",
    "data-name": "Path 62562",
    className: "cls-274",
    d: "M789.345,532.848l-.169.1v.161l-1.174.678-.051.18,1.394-.8Z",
    transform: "translate(-754.813 -510.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62563",
    "data-name": "Path 62563",
    className: "cls-280",
    d: "M817.072,522.879v-.442l.169-.1v.442Z",
    transform: "translate(-782.71 -500.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62564",
    "data-name": "Path 62564",
    className: "cls-273",
    d: "M790.33,525.261v-.6l-.972.561-.2.72Z",
    transform: "translate(-755.968 -502.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62565",
    "data-name": "Path 62565",
    className: "cls-274",
    d: "M781.434,557.455l-.169.1v.161l-1.521.878-.051.18,1.741-1.005Z",
    transform: "translate(-746.903 -534.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62566",
    "data-name": "Path 62566",
    className: "cls-280",
    d: "M817.072,554.39v-.139l.169-.1v.139Z",
    transform: "translate(-782.71 -530.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62567",
    "data-name": "Path 62567",
    className: "cls-273",
    d: "M782.419,556.77v-.3l-1.421.82-.1.358Z",
    transform: "translate(-748.057 -533.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62568",
    "data-name": "Path 62568",
    className: "cls-273",
    d: "M631.764,617.084l-.2-.486-1.06.612h-.093v.656Z",
    transform: "translate(-603.897 -590.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62569",
    "data-name": "Path 62569",
    className: "cls-274",
    d: "M624.124,628.157l-1.355.783H622.6l-.169.1h.428l1.394-.8Z",
    transform: "translate(-596.256 -601.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62570",
    "data-name": "Path 62570",
    className: "cls-147",
    d: "M657.908,615.5l-.08.046.2.486.131.075Z",
    transform: "translate(-630.163 -589.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62571",
    "data-name": "Path 62571",
    className: "cls-138",
    d: "M622.433,631.156h.169v.656l-.169.1Z",
    transform: "translate(-596.256 -604.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23440",
    "data-name": "Rectangle 23440",
    className: "cls-275",
    width: 0.167,
    height: 0.656,
    transform: "translate(26.346 26.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62572",
    "data-name": "Path 62572",
    className: "cls-52",
    d: "M682.082,585.361l3.281-1.894.253-.9-3.787,2.186Z",
    transform: "translate(-653.154 -558.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62573",
    "data-name": "Path 62573",
    className: "cls-270",
    d: "M622.433,518.269v3.754h.428v-2.8Z",
    transform: "translate(-596.256 -496.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62574",
    "data-name": "Path 62574",
    className: "cls-52",
    d: "M668.1,470.236l-3.957,2.284-.688-1.652,5.332-3.079Z",
    transform: "translate(-635.552 -448.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62575",
    "data-name": "Path 62575",
    className: "cls-274",
    d: "M682.413,524.077l-3.872,2.236.053.128,3.957-2.284Z",
    transform: "translate(-650.004 -502.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62576",
    "data-name": "Path 62576",
    className: "cls-147",
    d: "M771.443,467.79l-.191.11-.634,2.257.138.079Z",
    transform: "translate(-738.209 -448.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62577",
    "data-name": "Path 62577",
    className: "cls-52",
    d: "M640.513,547l-.032.018.187,1.208a.359.359,0,0,0,.1.21.411.411,0,0,0,.317-.06Z",
    transform: "translate(-613.545 -523.991)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63752",
    "data-name": "Group 63752",
    transform: "translate(33.188 18.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63751",
    "data-name": "Group 63751",
    className: "cls-281"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23442",
    "data-name": "Rectangle 23442",
    className: "cls-282",
    width: 2.398,
    height: 1.364,
    transform: "matrix(0.273, -0.962, 0.962, 0.273, -0.596, 2.104)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63766",
    "data-name": "Group 63766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63765",
    "data-name": "Group 63765",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62579",
    "data-name": "Path 62579",
    className: "cls-52",
    d: "M793.9,451.467a1.184,1.184,0,0,0,.521-.812l.17-1.294-.119.068Z",
    transform: "translate(-760.516 -430.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62580",
    "data-name": "Path 62580",
    className: "cls-274",
    d: "M679.995,564.1l-4.095,2.364.053.128,4.179-2.413Z",
    transform: "translate(-647.475 -540.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62581",
    "data-name": "Path 62581",
    className: "cls-274",
    d: "M689.773,602.079l-3.2,1.845.053.128,3.281-1.894Z",
    transform: "translate(-657.702 -576.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62582",
    "data-name": "Path 62582",
    className: "cls-147",
    d: "M762.974,582.567l-.191.11-.2.71.138.079Z",
    transform: "translate(-730.512 -558.067)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63755",
    "data-name": "Group 63755",
    className: "cls-283",
    transform: "translate(24.228 15.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63754",
    "data-name": "Group 63754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63753",
    "data-name": "Group 63753",
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62583",
    "data-name": "Path 62583",
    className: "cls-212",
    d: "M576.443,378.025l-.239-.138a.167.167,0,0,1,.072.128c0,.081-.077.152-.19.189l.278-.009c.16-.005.289-.079.3-.169Z",
    transform: "translate(-576.086 -377.887)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63758",
    "data-name": "Group 63758",
    className: "cls-283",
    transform: "translate(24.239 15.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63757",
    "data-name": "Group 63757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63756",
    "data-name": "Group 63756",
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62584",
    "data-name": "Path 62584",
    className: "cls-212",
    d: "M576.62,376.109l-.257.013.345.2.143-.165a.464.464,0,0,0-.231-.047",
    transform: "translate(-576.363 -376.108)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63761",
    "data-name": "Group 63761",
    className: "cls-283",
    transform: "translate(24.584 15.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63760",
    "data-name": "Group 63760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63759",
    "data-name": "Group 63759",
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62585",
    "data-name": "Path 62585",
    className: "cls-212",
    d: "M584.709,377.25l-.143.165h.219a.222.222,0,0,0-.077-.165",
    transform: "translate(-584.566 -377.25)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63764",
    "data-name": "Group 63764",
    className: "cls-132",
    transform: "translate(23.555 15.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63763",
    "data-name": "Group 63763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63762",
    "data-name": "Group 63762",
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62586",
    "data-name": "Path 62586",
    className: "cls-212",
    d: "M560.875,375.822l-.089-.052a.584.584,0,0,0-.219-.04h-.107c-.209,0-.378.1-.378.218s.169.218.378.218h.107c.209,0,.378-.1.378-.218a.166.166,0,0,0-.07-.126",
    transform: "translate(-560.082 -375.73)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63768",
    "data-name": "Group 63768",
    transform: "translate(23.555 15.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63767",
    "data-name": "Group 63767",
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23448",
    "data-name": "Rectangle 23448",
    className: "cls-289",
    width: 0.756,
    height: 0.597,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63770",
    "data-name": "Group 63770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63769",
    "data-name": "Group 63769",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62588",
    "data-name": "Path 62588",
    className: "cls-53",
    d: "M560.459,371.914c-.209,0-.378.1-.378.218s.169.218.378.218.378-.1.378-.218-.169-.218-.378-.218",
    transform: "translate(-536.526 -356.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62589",
    "data-name": "Path 62589",
    className: "cls-290",
    d: "M561.359,372.457c-.187,0-.339.087-.339.2s.152.2.339.2.339-.088.339-.2-.152-.2-.339-.2",
    transform: "translate(-537.426 -356.793)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63772",
    "data-name": "Group 63772",
    transform: "translate(23.749 15.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63771",
    "data-name": "Group 63771",
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23450",
    "data-name": "Rectangle 23450",
    className: "cls-292",
    width: 0.587,
    height: 0.568,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -0.209, 0.337)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63793",
    "data-name": "Group 63793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63792",
    "data-name": "Group 63792",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62591",
    "data-name": "Path 62591",
    className: "cls-293",
    d: "M566.35,366.74c.059-.1.153-.156.212-.122s.058.143,0,.245-.153.156-.212.122-.058-.143,0-.245",
    transform: "translate(-542.49 -351.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63777",
    "data-name": "Group 63777",
    className: "cls-294",
    transform: "translate(23.594 15.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63776",
    "data-name": "Group 63776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63775",
    "data-name": "Group 63775",
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63774",
    "data-name": "Group 63774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63773",
    "data-name": "Group 63773",
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23451",
    "data-name": "Rectangle 23451",
    className: "cls-297",
    width: 0.677,
    height: 0.887,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63782",
    "data-name": "Group 63782",
    className: "cls-294",
    transform: "translate(23.634 14.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63781",
    "data-name": "Group 63781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63780",
    "data-name": "Group 63780",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63779",
    "data-name": "Group 63779",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63778",
    "data-name": "Group 63778",
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23453",
    "data-name": "Rectangle 23453",
    className: "cls-300",
    width: 0.598,
    height: 0.345,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63785",
    "data-name": "Group 63785",
    className: "cls-294",
    transform: "translate(23.692 14.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63784",
    "data-name": "Group 63784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63783",
    "data-name": "Group 63783",
    className: "cls-301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62594",
    "data-name": "Path 62594",
    className: "cls-302",
    d: "M563.588,356.562c-.133,0-.241.062-.241.139s.108.139.241.139.241-.062.241-.139-.108-.139-.241-.139",
    transform: "translate(-563.347 -356.562)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63788",
    "data-name": "Group 63788",
    className: "cls-283",
    transform: "translate(31.617 11.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63787",
    "data-name": "Group 63787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63786",
    "data-name": "Group 63786",
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62595",
    "data-name": "Path 62595",
    className: "cls-212",
    d: "M752.286,278.187l-.318-.184a.136.136,0,0,1,.016.062c0,.081-.077.151-.19.189l.278-.009a.446.446,0,0,0,.215-.058",
    transform: "translate(-751.794 -278.003)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63791",
    "data-name": "Group 63791",
    className: "cls-132",
    transform: "translate(30.944 11.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63790",
    "data-name": "Group 63790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63789",
    "data-name": "Group 63789",
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62596",
    "data-name": "Path 62596",
    className: "cls-212",
    d: "M736.168,274.721h.107c.209,0,.378-.1.378-.218a.135.135,0,0,0-.016-.062l-.255-.148a.639.639,0,0,0-.107-.009h-.107c-.209,0-.378.1-.378.218s.169.218.378.218",
    transform: "translate(-735.79 -274.285)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63795",
    "data-name": "Group 63795",
    transform: "translate(30.944 11.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63794",
    "data-name": "Group 63794",
    className: "cls-304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23459",
    "data-name": "Rectangle 23459",
    className: "cls-305",
    width: 0.756,
    height: 0.597,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63797",
    "data-name": "Group 63797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63796",
    "data-name": "Group 63796",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62598",
    "data-name": "Path 62598",
    className: "cls-53",
    d: "M736.168,270.469c-.209,0-.378.1-.378.218s.169.218.378.218.378-.1.378-.218-.169-.218-.378-.218",
    transform: "translate(-704.846 -259.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62599",
    "data-name": "Path 62599",
    className: "cls-290",
    d: "M737.068,271.011c-.187,0-.339.088-.339.2s.152.2.339.2.339-.088.339-.2-.152-.2-.339-.2",
    transform: "translate(-705.746 -259.613)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63799",
    "data-name": "Group 63799",
    transform: "translate(31.139 11.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63798",
    "data-name": "Group 63798",
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23461",
    "data-name": "Rectangle 23461",
    className: "cls-307",
    width: 0.587,
    height: 0.568,
    transform: "translate(-0.209 0.337) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63832",
    "data-name": "Group 63832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63831",
    "data-name": "Group 63831",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62601",
    "data-name": "Path 62601",
    className: "cls-293",
    d: "M742.059,265.294c.058-.1.153-.156.212-.122s.058.143,0,.245-.153.156-.212.122-.058-.143,0-.245",
    transform: "translate(-710.809 -254.01)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63804",
    "data-name": "Group 63804",
    className: "cls-294",
    transform: "translate(30.984 10.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63803",
    "data-name": "Group 63803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63802",
    "data-name": "Group 63802",
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63801",
    "data-name": "Group 63801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63800",
    "data-name": "Group 63800",
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23462",
    "data-name": "Rectangle 23462",
    className: "cls-309",
    width: 0.677,
    height: 0.887
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63809",
    "data-name": "Group 63809",
    className: "cls-294",
    transform: "translate(31.023 10.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63808",
    "data-name": "Group 63808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63807",
    "data-name": "Group 63807",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63806",
    "data-name": "Group 63806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63805",
    "data-name": "Group 63805",
    className: "cls-310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23464",
    "data-name": "Rectangle 23464",
    className: "cls-311",
    width: 0.598,
    height: 0.345
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63812",
    "data-name": "Group 63812",
    className: "cls-294",
    transform: "translate(31.081 10.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63811",
    "data-name": "Group 63811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63810",
    "data-name": "Group 63810",
    className: "cls-301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62604",
    "data-name": "Path 62604",
    className: "cls-302",
    d: "M739.3,255.117c-.133,0-.241.062-.241.139s.108.139.241.139.241-.062.241-.139-.108-.139-.241-.139",
    transform: "translate(-739.056 -255.117)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62605",
    "data-name": "Path 62605",
    className: "cls-312",
    d: "M31.968,146.082l-.621,3.378,15.163,8.754.621-3.378Z",
    transform: "translate(-30.028 -139.939)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63815",
    "data-name": "Group 63815",
    className: "cls-213",
    transform: "translate(1.318 6.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63814",
    "data-name": "Group 63814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63813",
    "data-name": "Group 63813",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62606",
    "data-name": "Path 62606",
    className: "cls-212",
    d: "M47.13,154.836l-15.163-8.754-.621,3.378.421.243.529-2.877,2.828,1.632-.529,2.877.421.243.529-2.877,2.828,1.632-.529,2.877.421.243.529-2.877,2.828,1.632-.529,2.877.421.243.529-2.877,2.828,1.632-.529,2.877.421.243.529-2.877,1.749,1.009Z",
    transform: "translate(-31.346 -146.082)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62607",
    "data-name": "Path 62607",
    className: "cls-127",
    d: "M22.679,226.4l-.381.431,15.435,8.911.108-.588Z",
    transform: "translate(-21.36 -216.877)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63818",
    "data-name": "Group 63818",
    className: "cls-134",
    transform: "translate(0.938 9.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63817",
    "data-name": "Group 63817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63816",
    "data-name": "Group 63816",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62608",
    "data-name": "Path 62608",
    className: "cls-315",
    d: "M22.3,226.83l.8-.188-.421-.243Z",
    transform: "translate(-22.298 -226.399)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63821",
    "data-name": "Group 63821",
    className: "cls-134",
    transform: "translate(4.186 11.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63820",
    "data-name": "Group 63820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63819",
    "data-name": "Group 63819",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62609",
    "data-name": "Path 62609",
    className: "cls-315",
    d: "M99.537,271.422l.8-.188-.421-.243Z",
    transform: "translate(-99.537 -270.991)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63824",
    "data-name": "Group 63824",
    className: "cls-134",
    transform: "translate(7.434 13.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63823",
    "data-name": "Group 63823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63822",
    "data-name": "Group 63822",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62610",
    "data-name": "Path 62610",
    className: "cls-315",
    d: "M176.775,316.014l.8-.188-.421-.243Z",
    transform: "translate(-176.775 -315.583)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63827",
    "data-name": "Group 63827",
    className: "cls-134",
    transform: "translate(10.683 15.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63826",
    "data-name": "Group 63826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63825",
    "data-name": "Group 63825",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62611",
    "data-name": "Path 62611",
    className: "cls-315",
    d: "M254.014,360.606l.8-.188-.421-.243Z",
    transform: "translate(-254.014 -360.175)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63830",
    "data-name": "Group 63830",
    className: "cls-134",
    transform: "translate(13.931 17.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63829",
    "data-name": "Group 63829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63828",
    "data-name": "Group 63828",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62612",
    "data-name": "Path 62612",
    className: "cls-315",
    d: "M331.252,405.2l.8-.188-.421-.243Z",
    transform: "translate(-331.252 -404.767)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62613",
    "data-name": "Path 62613",
    className: "cls-125",
    d: "M23.8,108.722l-.533.308,16.241,9.377.1-.556Z",
    transform: "translate(-22.289 -104.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62614",
    "data-name": "Path 62614",
    className: "cls-138",
    d: "M23.028,142.345l-.73,3.966.381-.431L23.3,142.5Z",
    transform: "translate(-21.361 -136.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62615",
    "data-name": "Path 62615",
    className: "cls-138",
    d: "M100.266,186.938l-.73,3.966.381-.431.621-3.378Z",
    transform: "translate(-95.35 -179.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62616",
    "data-name": "Path 62616",
    className: "cls-138",
    d: "M177.5,231.532l-.73,3.966.381-.431.621-3.378Z",
    transform: "translate(-169.34 -221.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62617",
    "data-name": "Path 62617",
    className: "cls-138",
    d: "M254.742,276.125l-.73,3.966.381-.431.621-3.378Z",
    transform: "translate(-243.33 -264.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62618",
    "data-name": "Path 62618",
    className: "cls-138",
    d: "M331.981,320.719l-.73,3.966.381-.431.621-3.378Z",
    transform: "translate(-317.32 -307.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62619",
    "data-name": "Path 62619",
    className: "cls-126",
    d: "M19.7,123.249l-.4,2.163L3.062,116.035l-.887,4.822L19.223,130.7l1.181-6.422,1.3.751v-.623Zm-14.238-.732-2.442-1.41.73-3.966,2.442,1.41Zm3.248,1.875-2.442-1.41L7,119.017l2.442,1.41Zm3.248,1.875-2.442-1.41.73-3.966,2.442,1.41Zm3.248,1.875-2.442-1.41.729-3.966,2.442,1.41Zm3.248,1.875-2.442-1.41.73-3.966,2.442,1.41Z",
    transform: "translate(-2.084 -111.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62620",
    "data-name": "Path 62620",
    className: "cls-316",
    d: "M427.371,171.534l-8.452,4.88,2,1.157,8.452-4.88Z",
    transform: "translate(-401.301 -164.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62621",
    "data-name": "Path 62621",
    className: "cls-138",
    d: "M475.008,199.661l-8.452,4.88v-.623l8.452-4.88Z",
    transform: "translate(-446.935 -190.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67455",
    "data-name": "Group 67455",
    transform: "translate(-4517.533 -23194.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71242",
    "data-name": "Path 71242",
    className: "cls-35",
    d: "M113.251,127.668c.532-.307.963-.062.965.549a2.111,2.111,0,0,1-.959,1.659c-.53.306-.962.06-.964-.549a2.11,2.11,0,0,1,.958-1.659",
    transform: "translate(-73.759 -113.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71243",
    "data-name": "Path 71243",
    className: "cls-35",
    d: "M105.458,136.448a2.656,2.656,0,0,1,.492,1.738,6.067,6.067,0,0,1-.5,2.332,7.69,7.69,0,0,1-1.294,2.124,8.493,8.493,0,0,1-2.195,1.724l-3.239,1.87-.038-13.281,1.817-1.049a10.783,10.783,0,0,1,2.313-1.1,1.769,1.769,0,0,1,1.656.217,2.052,2.052,0,0,1,.619,1.671,4.543,4.543,0,0,1-.274,1.538,7.315,7.315,0,0,1-.9,1.682,1.838,1.838,0,0,1,1.545.533m-2.143,4.328a2.426,2.426,0,0,0,.473-1.433c0-.57-.189-.916-.562-1.032a2.788,2.788,0,0,0-1.863.578l-.457.263.01,3.4.551-.318a5.928,5.928,0,0,0,1.848-1.463m-2.422-6.678.008,2.8.482-.278a3.363,3.363,0,0,0,1.195-1.078,2.349,2.349,0,0,0,.387-1.28c0-.416-.126-.673-.372-.776s-.626,0-1.13.287l-.568.328",
    transform: "translate(-68.948 -125.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71244",
    "data-name": "Path 71244",
    className: "cls-5",
    d: "M58.545,74.087a.314.314,0,0,1,.311-.032.309.309,0,0,1,.13.283l.032,11.3a.89.89,0,0,1-.128.431L54.367,93.9a.9.9,0,0,1-.31.327L48.586,97.39a.316.316,0,0,1-.312.032.31.31,0,0,1-.13-.283l-.008-2.861L45.884,93l-6.93,4-2.026,3.509.026,9.05a.968.968,0,0,1-.439.76l-8.482,4.9a.319.319,0,0,1-.312.032.315.315,0,0,1-.13-.284l-.015-5.444-4.167-2.375-8.894,5.135c-.242.14-.44.027-.441-.251a.967.967,0,0,1,.438-.76l9.077-5.24A.313.313,0,0,1,23.9,106l4.425,2.522a.309.309,0,0,1,.13.283l.014,5.148,7.6-4.39-.025-8.754a.9.9,0,0,1,.128-.432l2.283-3.954a.9.9,0,0,1,.311-.328l7.294-4.211a.314.314,0,0,1,.311-.032l2.511,1.431a.308.308,0,0,1,.13.283l.007,2.564,4.849-2.8,4.266-7.389-.03-10.585-14.35,8.285L41.846,86.95a.892.892,0,0,1-.31.327.314.314,0,0,1-.311.032c-.173-.1-.174-.418,0-.715l2.041-3.535a.9.9,0,0,1,.31-.327Z",
    transform: "translate(-0.942 -74.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71245",
    "data-name": "Path 71245",
    className: "cls-34",
    d: "M5.473,220.351c.53-.306.962-.06.964.551a2.112,2.112,0,0,1-.958,1.659c-.532.307-.963.061-.965-.549a2.112,2.112,0,0,1,.959-1.661",
    transform: "translate(6.145 -182.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71246",
    "data-name": "Path 71246",
    className: "cls-34",
    d: "M6.94,194.214,11.62,205.4l-2.388,1.379-.951-2.313L3.358,207.3l-.973,3.423L0,212.1l4.612-16.546ZM4.2,204.246l3.227-1.863L5.8,198.553,4.2,204.246",
    transform: "translate(0 -158.844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetTrackingNew);
export default __webpack_public_path__ + "static/media/AssetTrackingNew.3a8bc86e82809904c21b12c942964d27.svg";
export { ForwardRef as ReactComponent };